const parkingData = {
  id: "parking",
  name: "Parking",

  values: [
    {
      type: "ALL",
      totalSlots: "400",
      available: "670",
      occupied: "335",
      occupiedPercentage: "50",

      iconsInfo: [
        {
          type: "VIP",

          total: "100",

          available: "150",

          occupied: "100",

          icon: "",
        },

        {
          type: "Person Disabilities",

          total: "25",

          available: "100",

          occupied: "25",

          icon: "",
        },

        {
          type: "Electric Vehicle",

          total: "10",

          available: "150",

          occupied: "10",

          icon: "",
        },

        {
          type: "Car",

          total: "200",

          available: "270",

          occupied: "200",

          icon: "",
        },
      ],
      analytics: {
        day: {
          analytics: [
            {
              node: "2022-10-11T11:00:00",
              count: 99.0,
            },
            {
              node: "2022-10-11T12:00:00",
              count: 47.0,
            },
            {
              node: "2022-10-11T13:00:00",
              count: 100.0,
            },
            {
              node: "2022-10-11T14:00:00",
              count: 47.0,
            },
            {
              node: "2022-10-11T15:00:00",
              count: 98.0,
            },
            {
              node: "2022-10-11T16:00:00",
              count: 67.0,
            },
            {
              node: "2022-10-11T17:00:00",
              count: 98.0,
            },
            {
              node: "2022-10-11T18:00:00",
              count: 57.0,
            },
            {
              node: "2022-10-11T19:00:00",
              count: 96.0,
            },
            {
              node: "2022-10-11T21:00:00",
              count: 47.0,
            },
            {
              node: "2022-10-11T22:00:00",
              count: 90.0,
            },
            {
              node: "2022-10-11T17:00:00",
              count: 98.0,
            },
            {
              node: "2022-10-11T11:00:00",
              count: 99.0,
            },
            {
              node: "2022-10-11T12:00:00",
              count: 47.0,
            },
            {
              node: "2022-10-11T13:00:00",
              count: 100.0,
            },
            {
              node: "2022-10-11T14:00:00",
              count: 47.0,
            },
            {
              node: "2022-10-11T15:00:00",
              count: 98.0,
            },
            {
              node: "2022-10-11T16:00:00",
              count: 67.0,
            },
            {
              node: "2022-10-11T17:00:00",
              count: 98.0,
            },
            {
              node: "2022-10-11T18:00:00",
              count: 57.0,
            },
            {
              node: "2022-10-11T19:00:00",
              count: 96.0,
            },
            {
              node: "2022-10-11T21:00:00",
              count: 47.0,
            },
            {
              node: "2022-10-11T22:00:00",
              count: 90.0,
            },
            {
              node: "2022-10-11T17:00:00",
              count: 98.0,
            },
          ],
        },
        weekly: {
          analytics: [
            {
              node: "2022-04-11T11:00:00",
              count: 100.0,
            },
            {
              node: "2022-05-11T12:00:00",
              count: 30.0,
            },
            {
              node: "2022-06-11T13:00:00",
              count: 77.0,
            },
            {
              node: "2022-07-11T14:00:00",
              count: 47.0,
            },
            {
              node: "2022-08-11T15:00:00",
              count: 37.0,
            },
            {
              node: "2022-09-11T16:00:00",
              count: 27.0,
            },
            {
              node: "2022-10-11T17:00:00",
              count: 67.0,
            },
          ],
        },
        monthly: {
          analytics: [
            {
              node: "2022-10-11T11:00:00",
              count: 77.0,
            },
            {
              node: "2022-11-11T12:00:00",
              count: 27.0,
            },
            {
              node: "2022-12-11T13:00:00",
              count: 57.0,
            },
            {
              node: "2023-01-11T14:00:00",
              count: 47.0,
            },
            {
              node: "2023-02-11T15:00:00",
              count: 87.0,
            },
            {
              node: "2023-03-11T16:00:00",
              count: 17.0,
            },
            {
              node: "2023-04-11T17:00:00",
              count: 27.0,
            },
            {
              node: "2023-05-11T18:00:00",
              count: 97.0,
            },
            {
              node: "2023-06-11T19:00:00",
              count: 87.0,
            },
            {
              node: "2023-07-11T21:00:00",
              count: 47.0,
            },
            {
              node: "2022-10-11T11:00:00",
              count: 77.0,
            },
            {
              node: "2022-11-11T12:00:00",
              count: 27.0,
            },
            {
              node: "2022-12-11T13:00:00",
              count: 57.0,
            },
            {
              node: "2023-01-11T14:00:00",
              count: 47.0,
            },
            {
              node: "2023-02-11T15:00:00",
              count: 87.0,
            },
            {
              node: "2023-03-11T16:00:00",
              count: 17.0,
            },
            {
              node: "2023-04-11T17:00:00",
              count: 27.0,
            },
            {
              node: "2023-05-11T18:00:00",
              count: 97.0,
            },
            {
              node: "2023-06-11T19:00:00",
              count: 87.0,
            },
            {
              node: "2023-07-11T21:00:00",
              count: 47.0,
            },
            {
              node: "2022-10-11T11:00:00",
              count: 77.0,
            },
            {
              node: "2022-11-11T12:00:00",
              count: 27.0,
            },
            {
              node: "2022-12-11T13:00:00",
              count: 57.0,
            },
            {
              node: "2023-01-11T14:00:00",
              count: 47.0,
            },
            {
              node: "2023-02-11T15:00:00",
              count: 87.0,
            },
            {
              node: "2023-03-11T16:00:00",
              count: 17.0,
            },
            {
              node: "2023-04-11T17:00:00",
              count: 27.0,
            },
            {
              node: "2023-05-11T18:00:00",
              count: 97.0,
            },
            {
              node: "2023-06-11T19:00:00",
              count: 87.0,
            },
            {
              node: "2023-07-11T21:00:00",
              count: 47.0,
            },
          ],
        },
        yearly: {
          analytics: [
            {
              node: "2022-05-11T11:00:00",
              count: 17.0,
            },
            {
              node: "2022-06-11T12:00:00",
              count: 47.0,
            },
            {
              node: "2022-07-11T13:00:00",
              count: 57.0,
            },
            {
              node: "2022-08-11T14:00:00",
              count: 47.0,
            },
            {
              node: "2022-09-11T15:00:00",
              count: 87.0,
            },
            {
              node: "2022-10-11T16:00:00",
              count: 67.0,
            },
            {
              node: "2022-11-11T17:00:00",
              count: 27.0,
            },
            {
              node: "2022-12-11T18:00:00",
              count: 57.0,
            },
            {
              node: "2023-01-11T19:00:00",
              count: 87.0,
            },
            {
              node: "2023-02-11T21:00:00",
              count: 47.0,
            },
            {
              node: "2023-03-11T22:00:00",
              count: 77.0,
            },
            {
              node: "2022-11-11T17:00:00",
              count: 27.0,
            },
          ],
        },
      },
      notifications: {
        events: {
          totalCount: "40",
          list: [
            {
              category: "parking",
              id: "evt-01",
              title: "Vehicle Parked",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "A1",
              parkingLot: "Parking Lot - A",
              img: "",
              video: "",
              location: {
                lat: 40.75636780531853,
                lng: -73.84443159837639,
              },
            },
            {
              category: "parking",
              id: "evt-02",
              title: "Vehicle Entered",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "A1",
              parkingLot: "Parking Lot - A",
              img: "",
              video: "",
              location: {
                lat: 40.75614683681981,
                lng: -73.84506520790768,
              },
            },
            {
              category: "parking",
              id: "evt-03",
              title: "Vehicle Parked",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "A1",
              parkingLot: "Parking Lot - B",
              img: "",
              video: "",
              location: {
                lat: 40.7586943218119,
                lng: -73.84695240950991,
              },
            },
            {
              category: "parking",
              id: "evt-04",
              title: "Vehicle Entered",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "A1",
              parkingLot: "Parking Lot - A",
              img: "",
              video: "",
              location: {
                lat: 40.7581222590056,
                lng: -73.84767627474734,
              },
            },
            {
              category: "parking",
              id: "evt-0",
              title: "Vehicle Entered",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "A1",
              parkingLot: "Parking Lot - A",
              img: "",
              video: "",
              location: {
                lat: 40.75827692495188,
                lng: -73.84777018507495,
              },
            },
            {
              category: "parking",
              id: "evt-05",
              title: "Vehicle Entered",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#24567C15A",
              spot: "A2",
              parkingLot: "Parking Lot - C",
              img: "",
              video: "",
              location: {
                lat: 40.758220602839714,
                lng: -73.84743857009768,
              },
            },
            {
              category: "parking",
              id: "evt-06",
              title: "Vehicle Parked",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#24567C15A",
              spot: "A2",
              parkingLot: "Parking Lot - C",
              img: "",
              video: "",
              location: {
                lat: 40.75649703006932,
                lng: -73.84762906841908,
              },
            },
            {
              category: "parking",
              id: "evt-07",
              title: "Vehicle Exited",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#24567C15A",
              spot: "A2",
              parkingLot: "Parking Lot - A",
              img: "",
              video: "",
              location: {
                lat: 40.75635810900475,
                lng: -73.84786553392162,
              },
            },
            {
              category: "parking",
              id: "evt-08",
              title: "Occupancy 50%",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#24567C15A",
              spot: "A2",
              parkingLot: "Parking Lot - A",
              img: "",
              video: "",
              location: {
                lat: 40.754506831981736,
                lng: -73.84925801909061,
              },
            },
            {
              category: "parking",
              id: "evt-09",
              title: "Vehicle Entered",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#24567C15A",
              spot: "A2",
              parkingLot: "Parking Lot - E",
              img: "",
              video: "",
              location: {
                lat: 40.75588158821897,
                lng: -73.84422133300635,
              },
            },
            {
              category: "parking",
              id: "evt-10",
              title: "Accident Detected",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#14567C15A",
              spot: "A3",
              parkingLot: "Parking Lot - A",
              img: "",
              video: "",
              location: {
                lat: 40.75756929325999,
                lng: -73.84747819815442,
              },
            },
            {
              category: "parking",
              id: "evt-11",
              title: "Bus Entered",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "",
              spot: "",
              parkingLot: "Bus Lot",
              img: "",
              video: "",
              location: {
                lat: 40.75740469829044,
                lng: -73.8480106885973,
              },
            },
            {
              category: "parking",
              id: "evt-12",
              title: "Bus Exited",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "",
              spot: "",
              parkingLot: "Bus Lot",
              img: "",
              video: "",
              location: {
                lat: 40.75664488754454,
                lng: -73.84801024923001,
              },
            },
            {
              category: "parking",
              id: "evt-13",
              title: "Vehicle Entered",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "A1",
              parkingLot: "Parking Lot - A",
              img: "",
              video: "",
              location: {
                lat: 40.75827692495188,
                lng: -73.84777018507495,
              },
            },
            {
              category: "parking",
              id: "evt-14",
              title: "Vehicle Parked",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "A1",
              parkingLot: "Parking Lot - A",
              img: "",
              video: "",
              location: {
                lat: 40.758365316071114,
                lng: -73.84812438125051,
              },
            },
            {
              category: "parking",
              id: "evt-15",
              title: "Bus Entered",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "A1",
              parkingLot: "Parking Lot - A",
              img: "",
              video: "",
              location: {
                lat: 40.758397552802975,
                lng: -73.84809280562247,
              },
            },
            // {
            //   category: "parking",
            //   id: "evt-16",
            //   title: "Occupancy 75%",
            //   timeStamp: "12-15-2022 | 09:00 AM",
            //   vehicleId: "#34567C15A",
            //   spot: "A1",
            //   parkingLot: "Parking Lot - A",
            //   img: "",
            //   video: "",
            //   location: {
            //     lat: 40.75840171238357,
            //     lng: -73.84735695619449,
            //   },
            // },
            {
              category: "parking",
              id: "evt-17",
              title: "Vehicle Entered",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "A1",
              parkingLot: "Parking Lot - B",
              img: "",
              video: "",
              location: {
                lat: 40.75743467017536,
                lng: -73.84801382006799,
              },
            },
            {
              category: "parking",
              id: "evt-18",
              title: "Vehicle Parked",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "A1",
              parkingLot: "Parking Lot - B",
              img: "",
              video: "",
              location: {
                lat: 40.75730228314339,
                lng: -73.84828155701987,
              },
            },
            {
              category: "parking",
              id: "evt-19",
              title: "Bus Entered",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "A1",
              parkingLot: "Parking Lot - B",
              img: "",
              video: "",
              location: {
                lat: 40.758397552802975,
                lng: -73.84809280562247,
              },
            },
            // {
            //   category: "parking",
            //   id: "evt-20",
            //   title: "Occupancy 75%",
            //   timeStamp: "12-15-2022 | 09:00 AM",
            //   vehicleId: "#34567C15A",
            //   spot: "A1",
            //   parkingLot: "Parking Lot - B",
            //   img: "",
            //   video: "",
            //   location: {
            //     lat: 40.7571403199266,
            //     lng: -73.84817743709415,
            //   },
            // },
            {
              category: "parking",
              id: "evt-21",
              title: "Vehicle Entered",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "A1",
              parkingLot: "Parking Lot - C",
              img: "",
              video: "",
              location: {
                lat: 40.75625788810083,
                lng: -73.8475039399799,
              },
            },
            {
              category: "parking",
              id: "evt-22",
              title: "Vehicle Parked",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "A1",
              parkingLot: "Parking Lot - C",
              img: "",
              video: "",
              location: {
                lat: 40.75609412440173,
                lng: -73.84760751066403,
              },
            },
            {
              category: "parking",
              id: "evt-23",
              title: "Bus Entered",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "A1",
              parkingLot: "Parking Lot - C",
              img: "",
              video: "",
              location: {
                lat: 40.75614287270781,
                lng: -73.8476014774203,
              },
            },
            // {
            //   category: "parking",
            //   id: "evt-24",
            //   title: "Occupancy 75%",
            //   timeStamp: "12-15-2022 | 09:00 AM",
            //   vehicleId: "#34567C15A",
            //   spot: "A1",
            //   parkingLot: "Parking Lot - C",
            //   img: "",
            //   video: "",
            //   location: {
            //     lat: 40.75585419081178,
            //     lng: -73.84721836644312,
            //   },
            // },
            {
              category: "parking",
              id: "evt-25",
              title: "Vehicle Entered",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "A1",
              parkingLot: "Parking Lot - D",
              img: "",
              video: "",
              location: {
                lat: 40.755404789043006,
                lng: -73.84703837465305,
              },
            },
            {
              category: "parking",
              id: "evt-26",
              title: "Vehicle Parked",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "A1",
              parkingLot: "Parking Lot - D",
              img: "",
              video: "",
              location: {
                lat: 40.758365316071114,
                lng: -73.84812438125051,
              },
            },
            {
              category: "parking",
              id: "evt-27",
              title: "Bus Entered",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "A1",
              parkingLot: "Parking Lot - D",
              img: "",
              video: "",
              location: {
                lat: 40.755265397712726,
                lng: -73.84706250762,
              },
            },
            // {
            //   category: "parking",
            //   id: "evt-28",
            //   title: "Occupancy 75%",
            //   timeStamp: "12-15-2022 | 09:00 AM",
            //   vehicleId: "#34567C15A",
            //   spot: "A1",
            //   parkingLot: "Parking Lot - D",
            //   img: "",
            //   video: "",
            //   location: {
            //     lat: 40.75513743164401,
            //     lng: -73.84700016410939,
            //   },
            // },
            {
              category: "parking",
              id: "evt-29",
              title: "Vehicle Entered",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "A1",
              parkingLot: "Parking Lot - E",
              img: "",
              video: "",
              location: {
                lat: 40.755458752973155,
                lng: -73.84991154944886,
              },
            },
            {
              category: "parking",
              id: "evt-30",
              title: "Vehicle Parked",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "A1",
              parkingLot: "Parking Lot - E",
              img: "",
              video: "",
              location: {
                lat: 40.75462062770408,
                lng: -73.84972341241921,
              },
            },
            {
              category: "parking",
              id: "evt-31",
              title: "Bus Entered",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "A1",
              parkingLot: "Parking Lot - E",
              img: "",
              video: "",
              location: {
                lat: 40.75486833383745,
                lng: -73.85056554959277,
              },
            },
            // {
            //   category: "parking",
            //   id: "evt-32",
            //   title: "Occupancy 75%",
            //   timeStamp: "12-15-2022 | 09:00 AM",
            //   vehicleId: "#34567C15A",
            //   spot: "A1",
            //   parkingLot: "Parking Lot - E",
            //   img: "",
            //   video: "",
            //   location: {
            //     lat: 40.75437801052809,
            //     lng: -73.85061034412327,
            //   },
            // },
            {
              category: "parking",
              id: "evt-33",
              title: "Vehicle Entered",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "A1",
              parkingLot: "Parking Lot - F",
              img: "",
              video: "",
              location: {
                lat: 40.754775019990205,
                lng: -73.84833702165541,
              },
            },
            {
              category: "parking",
              id: "evt-34",
              title: "Vehicle Parked",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "A1",
              parkingLot: "Parking Lot - F",
              img: "",
              video: "",
              location: {
                lat: 40.754508650654714,
                lng: -73.84859459020582,
              },
            },
            {
              category: "parking",
              id: "evt-35",
              title: "Bus Entered",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "A1",
              parkingLot: "Parking Lot - F",
              img: "",
              video: "",
              location: {
                lat: 40.75493110853166,
                lng: -73.84854307649573,
              },
            },
            // {
            //   category: "parking",
            //   id: "evt-36",
            //   title: "Occupancy 75%",
            //   timeStamp: "12-15-2022 | 09:00 AM",
            //   vehicleId: "#34567C15A",
            //   spot: "A1",
            //   parkingLot: "Parking Lot - F",
            //   img: "",
            //   video: "",
            //   location: {
            //     lat: 40.754607054737356,
            //     lng: -73.84766062424472,
            //   },
            // },
            {
              category: "parking",
              id: "evt-37",
              title: "Vehicle Entered",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "A1",
              parkingLot: "Parking Lot - G",
              img: "",
              video: "",
              location: {
                lat: 40.75630255576299,
                lng: -73.84466881440774,
              },
            },
            {
              category: "parking",
              id: "evt-38",
              title: "Vehicle Parked",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "A1",
              parkingLot: "Parking Lot - G",
              img: "",
              video: "",
              location: {
                lat: 40.75589185394445,
                lng: -73.84450615926231,
              },
            },
            {
              category: "parking",
              id: "evt-39",
              title: "Bus Entered",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "A1",
              parkingLot: "Parking Lot - G",
              img: "",
              video: "",
              location: {
                lat: 40.755966388907375,
                lng: -73.84458246661448,
              },
            },
            // {
            //   category: "parking",
            //   id: "evt-40",
            //   title: "Occupancy 75%",
            //   timeStamp: "12-15-2022 | 09:00 AM",
            //   vehicleId: "#34567C15A",
            //   spot: "A1",
            //   parkingLot: "Parking Lot - G",
            //   img: "",
            //   video: "",
            //   location: {
            //     lat: 40.75603027595193,
            //     lng: -73.84434149602866,
            //   },
            // },
          ],
        },
        incidents: {
          totalCount: "39",
          list: [
            {
              category: "parking",
              id: "ict-01",
              title: "Wrong Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "B1",
              parkingLot: "Parking Lot - A",
              img: "",
              video: "",
              location: {
                lat: 40.75828536114887,
                lng: -73.84695417342891,
              },
            },
            {
              category: "parking",
              id: "ict-02",
              title: "Double Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "B1",
              parkingLot: "Parking Lot - A",
              img: "",
              video: "",
              location: {
                lat: 40.758460764776814,
                lng: -73.84657950595624,
              },
            },
            {
              category: "parking",
              id: "ict-03",
              title: "Reverse Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "B1",
              parkingLot: "Parking Lot - A",
              img: "",
              video: "",
              location: {
                lat: 40.756309118139086,
                lng: -73.84875469078845,
              },
            },
            {
              category: "parking",
              id: "ict-04",
              title: "Double Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "B1",
              parkingLot: "Parking Lot - B",
              img: "",
              video: "",
              location: {
                lat: 40.75710978495599,
                lng: -73.8489565128386,
              },
            },
            {
              category: "parking",
              id: "ict-05",
              title: "Accident Detected",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "B1",
              parkingLot: "Parking Lot - A",
              img: "",
              video: "",
              location: {
                lat: 40.75668202276822,
                lng: -73.8496273805259,
              },
            },
            {
              category: "parking",
              id: "ict-06",
              title: "Close Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "B1",
              parkingLot: "Parking Lot - B",
              img: "",
              video: "",
              location: {
                lat: 40.755735756887695,
                lng: -73.84898421515462,
              },
            },
            {
              category: "parking",
              id: "ict-07",
              title: "Reverse Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "B1",
              parkingLot: "Parking Lot - C",
              img: "",
              video: "",
              location: {
                lat: 40.75387933244808,
                lng: -73.84981835804898,
              },
            },
            {
              category: "parking",
              id: "ict-08",
              title: "Wrong Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "B1",
              parkingLot: "Parking Lot - C",
              img: "",
              video: "",
              location: {
                lat: 40.757944725202286,
                lng: -73.84774250035763,
              },
            },
            {
              category: "parking",
              id: "ict-09",
              title: "Wrong Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "B1",
              parkingLot: "Parking Lot - C",
              img: "",
              video: "",
              location: {
                lat: 40.754888326876774,
                lng: -73.84857614587526,
              },
            },
            {
              category: "parking",
              id: "ict-10",
              title: "Double Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "B1",
              parkingLot: "Parking Lot - D",
              img: "",
              video: "",
              location: {
                lat: 40.7563347135207,
                lng: -73.85012508279607,
              },
            },
            {
              category: "parking",
              id: "ict-11",
              title: "Close Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "B1",
              parkingLot: "Parking Lot - D",
              img: "",
              video: "",
              location: {
                lat: 40.75665215356642,
                lng: -73.84836111476568,
              },
            },
            {
              category: "parking",
              id: "ict-12",
              title: "Wrong Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "B1",
              parkingLot: "Parking Lot - A",
              img: "",
              video: "",
              location: {
                lat: 40.75898542217435,
                lng: -73.84606160494323,
              },
            },
            {
              category: "parking",
              id: "ict-13",
              title: "Double Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "B1",
              parkingLot: "Parking Lot - A",
              img: "",
              video: "",
              location: {
                lat: 40.759037366217,
                lng: -73.84597285900811,
              },
            },
            {
              category: "parking",
              id: "ict-14",
              title: "Reverse Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "B1",
              parkingLot: "Parking Lot - A",
              img: "",
              video: "",
              location: {
                lat: 40.7591198654954,
                lng: -73.84652147024337,
              },
            },
            {
              category: "parking",
              id: "ict-15",
              title: "Accident Detected",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "B1",
              parkingLot: "Parking Lot - A",
              img: "",
              video: "",
              location: {
                lat: 40.75862181273928,
                lng: -73.8460575710371,
              },
            },
            {
              category: "parking",
              id: "ict-16",
              title: "Wrong Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "B1",
              parkingLot: "Parking Lot - B",
              img: "",
              video: "",
              location: {
                lat: 40.75905669977894,
                lng: -73.84556229529741,
              },
            },
            {
              category: "parking",
              id: "ict-17",
              title: "Double Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "B1",
              parkingLot: "Parking Lot - B",
              img: "",
              video: "",
              location: {
                lat: 40.75895326828967,
                lng: -73.84529923574122,
              },
            },
            {
              category: "parking",
              id: "ict-18",
              title: "Reverse Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "B1",
              parkingLot: "Parking Lot - B",
              img: "",
              video: "",
              location: {
                lat: 40.758807247089656,
                lng: -73.84536148647588,
              },
            },
            {
              category: "parking",
              id: "ict-19",
              title: "Accident Detected",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "B1",
              parkingLot: "Parking Lot - B",
              img: "",
              video: "",
              location: {
                lat: 40.758831583978605,
                lng: -73.8452189122126,
              },
            },
            {
              category: "parking",
              id: "ict-20",
              title: "Wrong Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "B1",
              parkingLot: "Parking Lot - C",
              img: "",
              video: "",
              location: {
                lat: 40.75600388200904,
                lng: -73.84744588208888,
              },
            },
            {
              category: "parking",
              id: "ict-21",
              title: "Double Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "B1",
              parkingLot: "Parking Lot - C",
              img: "",
              video: "",
              location: {
                lat: 40.755737685479325,
                lng: -73.84743985782424,
              },
            },
            {
              category: "parking",
              id: "ict-22",
              title: "Reverse Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "B1",
              parkingLot: "Parking Lot - C",
              img: "",
              video: "",
              location: {
                lat: 40.75574833336098,
                lng: -73.84703623209298,
              },
            },
            {
              category: "parking",
              id: "ict-23",
              title: "Accident Detected",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "B1",
              parkingLot: "Parking Lot - C",
              img: "",
              video: "",
              location: {
                lat: 40.75587915005353,
                lng: -73.84751616517642,
              },
            },
            {
              category: "parking",
              id: "ict-24",
              title: "Wrong Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "B1",
              parkingLot: "Parking Lot - D",
              img: "",
              video: "",
              location: {
                lat: 40.75898542217435,
                lng: -73.84606160494323,
              },
            },
            {
              category: "parking",
              id: "ict-25",
              title: "Double Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "B1",
              parkingLot: "Parking Lot - D",
              img: "",
              video: "",
              location: {
                lat: 40.75567227701903,
                lng: -73.84818887477387,
              },
            },
            {
              category: "parking",
              id: "ict-26",
              title: "Reverse Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "B1",
              parkingLot: "Parking Lot - D",
              img: "",
              video: "",
              location: {
                lat: 40.75546692448007,
                lng: -73.84825514168496,
              },
            },
            {
              category: "parking",
              id: "ict-27",
              title: "Accident Detected",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "B1",
              parkingLot: "Parking Lot - D",
              img: "",
              video: "",
              location: {
                lat: 40.755797009362695,
                lng: -73.84893387550171,
              },
            },
            {
              category: "parking",
              id: "ict-28",
              title: "Wrong Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "B1",
              parkingLot: "Parking Lot - E",
              img: "",
              video: "",
              location: {
                lat: 40.75509272487776,
                lng: -73.85004836452536,
              },
            },
            {
              category: "parking",
              id: "ict-29",
              title: "Double Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "B1",
              parkingLot: "Parking Lot - E",
              img: "",
              video: "",
              location: {
                lat: 40.75500754093674,
                lng: -73.85037166672802,
              },
            },
            {
              category: "parking",
              id: "ict-30",
              title: "Reverse Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "B1",
              parkingLot: "Parking Lot - E",
              img: "",
              video: "",
              location: {
                lat: 40.75487976482059,
                lng: -73.85056243510844,
              },
            },
            {
              category: "parking",
              id: "ict-31",
              title: "Accident Detected",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "B1",
              parkingLot: "Parking Lot - E",
              img: "",
              video: "",
              location: {
                lat: 40.75507751346773,
                lng: -73.85051022481487,
              },
            },
            {
              category: "parking",
              id: "ict-32",
              title: "Wrong Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "B1",
              parkingLot: "Parking Lot - F",
              img: "",
              video: "",
              location: {
                lat: 40.754732762550084,
                lng: -73.84784179279583,
              },
            },
            {
              category: "parking",
              id: "ict-33",
              title: "Double Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "B1",
              parkingLot: "Parking Lot - F",
              img: "",
              video: "",
              location: {
                lat: 40.754654859183375,
                lng: -73.8483694126824,
              },
            },
            {
              category: "parking",
              id: "ict-34",
              title: "Reverse Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "B1",
              parkingLot: "Parking Lot - F",
              img: "",
              video: "",
              location: {
                lat: 40.755152761737115,
                lng: -73.84754668336775,
              },
            },
            {
              category: "parking",
              id: "ict-35",
              title: "Accident Detected",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "B1",
              parkingLot: "Parking Lot - F",
              img: "",
              video: "",
              location: {
                lat: 40.75492582702202,
                lng: -73.84866899346545,
              },
            },
            {
              category: "parking",
              id: "ict-36",
              title: "Wrong Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "B1",
              parkingLot: "Parking Lot - G",
              img: "",
              video: "",
              location: {
                lat: 40.75623323134528,
                lng: -73.84496671141537,
              },
            },
            {
              category: "parking",
              id: "ict-37",
              title: "Double Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "B1",
              parkingLot: "Parking Lot - G",
              img: "",
              video: "",
              location: {
                lat: 40.75654483686646,
                lng: -73.84431836494457,
              },
            },
            {
              category: "parking",
              id: "ict-38",
              title: "Reverse Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "B1",
              parkingLot: "Parking Lot - G",
              img: "",
              video: "",
              location: {
                lat: 40.75639580832116,
                lng: -73.84424682326504,
              },
            },
            {
              category: "parking",
              id: "ict-39",
              title: "Accident Detected",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "B1",
              parkingLot: "Parking Lot - G",
              img: "",
              video: "",
              location: {
                lat: 40.75604017067001,
                lng: -73.84425129462001,
              },
            },
          ],
        },
        operationalAlerts: {
          totalCount: "35",
          list: [
            {
              category: "parking",
              id: "opr-01",
              title: "No Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "C1",
              parkingLot: "Parking Lot - F",
              img: "",
              video: "",
              location: {
                lat: 40.755301325633475,
                lng: -73.84856925263351,
              },
            },
            {
              category: "parking",
              id: "opr-02",
              title: "No Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "C1",
              parkingLot: "Parking Lot - A",
              img: "",
              video: "",
              location: {
                lat: 40.755698337853495,
                lng: -73.84501569681177,
              },
            },
            {
              category: "parking",
              id: "opr-03",
              title: "Accident Detected",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "C1",
              parkingLot: "Parking Lot - B",
              img: "",
              video: "",
              location: {
                lat: 40.755254266984274,
                lng: -73.84539461420266,
              },
            },
            {
              category: "parking",
              id: "opr-04",
              title: "Close Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "C1",
              parkingLot: "Parking Lot - A",
              img: "",
              video: "",
              location: {
                lat: 40.75459034705933,
                lng: -73.84766516701225,
              },
            },
            {
              category: "parking",
              id: "opr-05",
              title: "Parking Slot Is Full",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "C1",
              parkingLot: "Parking Lot - A",
              img: "",
              video: "",
              location: {
                lat: 40.75621618988331,
                lng: -73.84942506249978,
              },
            },
            {
              category: "parking",
              id: "opr-06",
              title: "Parking Slot Is In Maintenance",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "C1",
              parkingLot: "Parking Lot - F",
              img: "",
              video: "",
              location: {
                lat: 40.75520200305613,
                lng: -73.84740291825163,
              },
            },
            {
              category: "parking",
              id: "opr-07",
              title: "No Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "C1",
              parkingLot: "Parking Lot - C",
              img: "",
              video: "",
              location: {
                lat: 40.75599140563482,
                lng: -73.84799644562368,
              },
            },
            {
              category: "parking",
              id: "opr-08",
              title: "Parking Slot Is Available",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "C1",
              parkingLot: "Parking Lot - A",
              img: "",
              video: "",
              location: {
                lat: 40.75528562457897,
                lng: -73.84976319865595,
              },
            },
            {
              category: "parking",
              id: "opr-09",
              title: "Close Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "C1",
              parkingLot: "Parking Lot - A",
              img: "",
              video: "",
              location: {
                lat: 40.7585637572672,
                lng: -73.84613018134763,
              },
            },
            {
              category: "parking",
              id: "opr-10",
              title: "No Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "C1",
              parkingLot: "Parking Lot - A",
              img: "",
              video: "",
              location: {
                lat: 40.75838347942546,
                lng: -73.84658601274165,
              },
            },
            {
              category: "parking",
              id: "opr-11",
              title: "Close Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "C1",
              parkingLot: "Parking Lot - A",
              img: "",
              video: "",
              location: {
                lat: 40.758520979518494,
                lng: -73.84627136806259,
              },
            },
            {
              category: "parking",
              id: "opr-12",
              title: "Parking Slot Is Available",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "C1",
              parkingLot: "Parking Lot - B",
              img: "",
              video: "",
              location: {
                lat: 40.758891992438784,
                lng: -73.84526629222921,
              },
            },
            {
              category: "parking",
              id: "opr-13",
              title: "Close Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "C1",
              parkingLot: "Parking Lot - B",
              img: "",
              video: "",
              location: {
                lat: 40.75927809666472,
                lng: -73.84562400062688,
              },
            },
            {
              category: "parking",
              id: "opr-14",
              title: "No Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "C1",
              parkingLot: "Parking Lot - B",
              img: "",
              video: "",
              location: {
                lat: 40.758820867731494,
                lng: -73.84536913339353,
              },
            },
            {
              category: "parking",
              id: "opr-15",
              title: "Close Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "C1",
              parkingLot: "Parking Lot - B",
              img: "",
              video: "",
              location: {
                lat: 40.75685982794488,
                lng: -73.8479043917183,
              },
            },
            {
              category: "parking",
              id: "opr-16",
              title: "Parking Slot Is Available",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "C1",
              parkingLot: "Parking Lot - C",
              img: "",
              video: "",
              location: {
                lat: 40.75606993155225,
                lng: -73.84768350922519,
              },
            },
            {
              category: "parking",
              id: "opr-17",
              title: "Close Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "C1",
              parkingLot: "Parking Lot - C",
              img: "",
              video: "",
              location: {
                lat: 40.75583688850895,
                lng: -73.84753737607751,
              },
            },
            {
              category: "parking",
              id: "opr-18",
              title: "No Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "C1",
              parkingLot: "Parking Lot - C",
              img: "",
              video: "",
              location: {
                lat: 40.756093235811626,
                lng: -73.84765658996116,
              },
            },
            {
              category: "parking",
              id: "opr-19",
              title: "Close Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "C1",
              parkingLot: "Parking Lot - C",
              img: "",
              video: "",
              location: {
                lat: 40.7557407580156,
                lng: -73.84744892706706,
              },
            },
            {
              category: "parking",
              id: "opr-20",
              title: "Parking Slot Is Available",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "C1",
              parkingLot: "Parking Lot - D",
              img: "",
              video: "",
              location: {
                lat: 40.75542614814402,
                lng: -73.84888333929021,
              },
            },
            {
              category: "parking",
              id: "opr-21",
              title: "Close Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "C1",
              parkingLot: "Parking Lot - D",
              img: "",
              video: "",
              location: {
                lat: 40.75542614814402,
                lng: -73.84859107299482,
              },
            },
            {
              category: "parking",
              id: "opr-22",
              title: "No Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "C1",
              parkingLot: "Parking Lot - D",
              img: "",
              video: "",
              location: {
                lat: 40.75571162752321,
                lng: -73.8491140758392,
              },
            },
            {
              category: "parking",
              id: "opr-23",
              title: "Close Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "C1",
              parkingLot: "Parking Lot - D",
              img: "",
              video: "",
              location: {
                lat: 40.755478583223926,
                lng: -73.8478104143374,
              },
            },
            {
              category: "parking",
              id: "opr-24",
              title: "Parking Slot Is Available",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "C1",
              parkingLot: "Parking Lot - E",
              img: "",
              video: "",
              location: {
                lat: 40.754866838039305,
                lng: -73.85066385636345,
              },
            },
            {
              category: "parking",
              id: "opr-25",
              title: "Close Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "C1",
              parkingLot: "Parking Lot - E",
              img: "",
              video: "",
              location: {
                lat: 40.755056188337036,
                lng: -73.85047157590597,
              },
            },
            {
              category: "parking",
              id: "opr-26",
              title: "No Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "C1",
              parkingLot: "Parking Lot - E",
              img: "",
              video: "",
              location: {
                lat: 40.75460757291081,
                lng: -73.84943710704466,
              },
            },
            {
              category: "parking",
              id: "opr-27",
              title: "Close Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "C1",
              parkingLot: "Parking Lot - E",
              img: "",
              video: "",
              location: {
                lat: 40.75450852753863,
                lng: -73.84940634217146,
              },
            },
            {
              category: "parking",
              id: "opr-28",
              title: "Parking Slot Is Available",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "C1",
              parkingLot: "Parking Lot - F",
              img: "",
              video: "",
              location: {
                lat: 40.75441822133541,
                lng: -73.84786040729324,
              },
            },
            {
              category: "parking",
              id: "opr-29",
              title: "Close Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "C1",
              parkingLot: "Parking Lot - F",
              img: "",
              video: "",
              location: {
                lat: 40.754339567445555,
                lng: -73.8484141750108,
              },
            },
            {
              category: "parking",
              id: "opr-30",
              title: "No Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "C1",
              parkingLot: "Parking Lot - F",
              img: "",
              video: "",
              location: {
                lat: 40.75493383897552,
                lng: -73.8472258817835,
              },
            },
            {
              category: "parking",
              id: "opr-31",
              title: "Close Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "C1",
              parkingLot: "Parking Lot - F",
              img: "",
              video: "",
              location: {
                lat: 40.754424047545776,
                lng: -73.84757583221614,
              },
            },
            {
              category: "parking",
              id: "opr-32",
              title: "Parking Slot Is Available",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "C1",
              parkingLot: "Parking Lot - G",
              img: "",
              video: "",
              location: {
                lat: 40.75562714905974,
                lng: -73.8446416322879,
              },
            },
            {
              category: "parking",
              id: "opr-33",
              title: "Close Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "C1",
              parkingLot: "Parking Lot - G",
              img: "",
              video: "",
              location: {
                lat: 40.75570871447516,
                lng: -73.84429168185525,
              },
            },
            {
              category: "parking",
              id: "opr-34",
              title: "No Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "C1",
              parkingLot: "Parking Lot - G",
              img: "",
              video: "",
              location: {
                lat: 40.75587475804728,
                lng: -73.84395326825008,
              },
            },
            {
              category: "parking",
              id: "opr-35",
              title: "Close Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "C1",
              parkingLot: "Parking Lot - G",
              img: "",
              video: "",
              location: {
                lat: 40.75603206210152,
                lng: -73.84393404020433,
              },
            },
          ],
        },
      },
      parkingSlots: [
        {
          parkingLot: "A",
          slots: [
            {
              paths: [
                {
                  lat: 40.758225248713806,
                  lng: -73.8474589523742,
                },
                {
                  lat: 40.75818027055971,
                  lng: -73.84743547459969,
                },
                {
                  lat: 40.758188354662245,
                  lng: -73.84740877864596,
                },
                {
                  lat: 40.75823336887028,
                  lng: -73.84743221045616,
                },
                {
                  lat: 40.758225248713806,
                  lng: -73.8474589523742,
                },
              ],
              type: "events",
              shape: "fill",
            },
            {
              paths: [
                {
                  lat: 40.75835227672024,
                  lng: -73.84702772080189,
                },
                {
                  lat: 40.75830903256137,
                  lng: -73.84700513426486,
                },
                {
                  lat: 40.758317243423136,
                  lng: -73.84697971553202,
                },
                {
                  lat: 40.75836232187898,
                  lng: -73.84700214239611,
                },
                {
                  lat: 40.75835227672024,
                  lng: -73.84702772080189,
                },
              ],
              type: "opAlerts",
              shape: "fill",
            },
            {
              paths: [
                {
                  lat: 40.75823336887028,
                  lng: -73.84743221045616,
                },
                {
                  lat: 40.758188354662245,
                  lng: -73.84740877864596,
                },
                {
                  lat: 40.75819655708222,
                  lng: -73.84738166640747,
                },
                {
                  lat: 40.75824111101975,
                  lng: -73.84740490475849,
                },
                {
                  lat: 40.75823336887028,
                  lng: -73.84743221045616,
                },
              ],
              type: "incidents",
              shape: "fill",
            },
            {
              paths: [
                {
                  lat: 40.75824111101975,
                  lng: -73.84740490475849,
                },
                {
                  lat: 40.75819655708222,
                  lng: -73.84738166640747,
                },
                {
                  lat: 40.75820420527928,
                  lng: -73.84735559898782,
                },
                {
                  lat: 40.75824945261164,
                  lng: -73.84737783632028,
                },
                {
                  lat: 40.75824111101975,
                  lng: -73.84740490475849,
                },
              ],
              type: "events",
              shape: "fill",
            },
            {
              paths: [
                {
                  lat: 40.758134748913236,
                  lng: -73.84741121211586,
                },
                {
                  lat: 40.75818027055971,
                  lng: -73.84743547459969,
                },
                {
                  lat: 40.758188354662245,
                  lng: -73.84740877864596,
                },
                {
                  lat: 40.758143043289124,
                  lng: -73.84738405172214,
                },
                {
                  lat: 40.758134748913236,
                  lng: -73.84741121211586,
                },
              ],
              type: "incidents",
              shape: "fill",
            },
            {
              paths: [
                {
                  lat: 40.75811509769592,
                  lng: -73.84842676237491,
                },
                {
                  lat: 40.75822772728387,
                  lng: -73.8482998519924,
                },
                {
                  lat: 40.758279535608,
                  lng: -73.84824553737229,
                },
                {
                  lat: 40.75839737406086,
                  lng: -73.84809131023971,
                },
                {
                  lat: 40.75843496010653,
                  lng: -73.84803565444743,
                },
                {
                  lat: 40.75852029112063,
                  lng: -73.84789081506042,
                },
                {
                  lat: 40.759561504252815,
                  lng: -73.84568343276048,
                },
                {
                  lat: 40.75954626642679,
                  lng: -73.84556407431778,
                },
                {
                  lat: 40.758650808710286,
                  lng: -73.84508932394594,
                },
                {
                  lat: 40.75862338107435,
                  lng: -73.84513492155455,
                },
                {
                  lat: 40.75847152790236,
                  lng: -73.84566733871623,
                },
                {
                  lat: 40.75844979416734,
                  lng: -73.84569012910532,
                },
                {
                  lat: 40.75762390691657,
                  lng: -73.84819397193895,
                },
                {
                  lat: 40.757461366336464,
                  lng: -73.84868481364319,
                },
                {
                  lat: 40.75753755559373,
                  lng: -73.84868213252086,
                },
                {
                  lat: 40.75753755559373,
                  lng: -73.84868213252086,
                },
                {
                  lat: 40.757791694024206,
                  lng: -73.8488402453693,
                },
                {
                  lat: 40.757791694024206,
                  lng: -73.8488402453693,
                },
                {
                  lat: 40.757831669790725,
                  lng: -73.8488473771783,
                },
                {
                  lat: 40.75785273811002,
                  lng: -73.84883810592447,
                },
                {
                  lat: 40.75811509769592,
                  lng: -73.84842676237491,
                },
              ],
              shape: "stroke",
            },
            {
              shape: "stroke",
              paths: [
                {
                  lat: 40.757953718250604,
                  lng: -73.8481919975431,
                },
                {
                  lat: 40.758612089247535,
                  lng: -73.84598367167747,
                },
              ],
            },
            {
              shape: "stroke",
              paths: [
                {
                  lat: 40.75799991324995,
                  lng: -73.84821574184352,
                },
                {
                  lat: 40.75790948241505,
                  lng: -73.8481681851226,
                },
              ],
            },
            {
              shape: "stroke",
              paths: [
                {
                  lat: 40.75800863580032,
                  lng: -73.8481863527074,
                },
                {
                  lat: 40.75791713949157,
                  lng: -73.84814032790807,
                },
              ],
            },
            {
              shape: "stroke",
              paths: [
                {
                  lat: 40.75801437132073,
                  lng: -73.8481607358166,
                },
                {
                  lat: 40.757925390309715,
                  lng: -73.84811285983771,
                },
              ],
            },
            {
              shape: "stroke",
              paths: [
                {
                  lat: 40.7580244118424,
                  lng: -73.8481346624244,
                },
                {
                  lat: 40.75793256492758,
                  lng: -73.84808586535053,
                },
              ],
            },
            {
              shape: "stroke",
              paths: [
                {
                  lat: 40.758034081417065,
                  lng: -73.84810874102077,
                },
                {
                  lat: 40.75794151458426,
                  lng: -73.84805842582851,
                },
              ],
            },
            {
              shape: "stroke",
              paths: [
                {
                  lat: 40.75804164461913,
                  lng: -73.84808068849033,
                },
                {
                  lat: 40.75794979700286,
                  lng: -73.84803178252865,
                },
              ],
            },
            {
              shape: "stroke",
              paths: [
                {
                  lat: 40.75804701271827,
                  lng: -73.84805450125083,
                },
                {
                  lat: 40.757957008547756,
                  lng: -73.8480055650308,
                },
              ],
            },
            {
              shape: "stroke",
              paths: [
                {
                  lat: 40.75805713116388,
                  lng: -73.84802600979256,
                },
                {
                  lat: 40.757964571722354,
                  lng: -73.84797893890382,
                },
              ],
            },
          ],
        },
        {
          parkingLot: "A",
          slots: [
            {
              paths: [
                {
                  lat: 40.758225248713806,
                  lng: -73.8474589523742,
                },
                {
                  lat: 40.75818027055971,
                  lng: -73.84743547459969,
                },
                {
                  lat: 40.758188354662245,
                  lng: -73.84740877864596,
                },
                {
                  lat: 40.75823336887028,
                  lng: -73.84743221045616,
                },
                {
                  lat: 40.758225248713806,
                  lng: -73.8474589523742,
                },
              ],
              type: "events",
              shape: "fill",
            },
            {
              paths: [
                {
                  lat: 40.75835227672024,
                  lng: -73.84702772080189,
                },
                {
                  lat: 40.75830903256137,
                  lng: -73.84700513426486,
                },
                {
                  lat: 40.758317243423136,
                  lng: -73.84697971553202,
                },
                {
                  lat: 40.75836232187898,
                  lng: -73.84700214239611,
                },
                {
                  lat: 40.75835227672024,
                  lng: -73.84702772080189,
                },
              ],
              type: "opAlerts",
              shape: "fill",
            },
            {
              paths: [
                {
                  lat: 40.75823336887028,
                  lng: -73.84743221045616,
                },
                {
                  lat: 40.758188354662245,
                  lng: -73.84740877864596,
                },
                {
                  lat: 40.75819655708222,
                  lng: -73.84738166640747,
                },
                {
                  lat: 40.75824111101975,
                  lng: -73.84740490475849,
                },
                {
                  lat: 40.75823336887028,
                  lng: -73.84743221045616,
                },
              ],
              type: "incidents",
              shape: "fill",
            },
            {
              paths: [
                {
                  lat: 40.75824111101975,
                  lng: -73.84740490475849,
                },
                {
                  lat: 40.75819655708222,
                  lng: -73.84738166640747,
                },
                {
                  lat: 40.75820420527928,
                  lng: -73.84735559898782,
                },
                {
                  lat: 40.75824945261164,
                  lng: -73.84737783632028,
                },
                {
                  lat: 40.75824111101975,
                  lng: -73.84740490475849,
                },
              ],
              type: "events",
              shape: "fill",
            },
            {
              paths: [
                {
                  lat: 40.758134748913236,
                  lng: -73.84741121211586,
                },
                {
                  lat: 40.75818027055971,
                  lng: -73.84743547459969,
                },
                {
                  lat: 40.758188354662245,
                  lng: -73.84740877864596,
                },
                {
                  lat: 40.758143043289124,
                  lng: -73.84738405172214,
                },
                {
                  lat: 40.758134748913236,
                  lng: -73.84741121211586,
                },
              ],
              type: "incidents",
              shape: "fill",
            },
            {
              paths: [
                {
                  lat: 40.75811509769592,
                  lng: -73.84842676237491,
                },
                {
                  lat: 40.75822772728387,
                  lng: -73.8482998519924,
                },
                {
                  lat: 40.758279535608,
                  lng: -73.84824553737229,
                },
                {
                  lat: 40.75839737406086,
                  lng: -73.84809131023971,
                },
                {
                  lat: 40.75843496010653,
                  lng: -73.84803565444743,
                },
                {
                  lat: 40.75852029112063,
                  lng: -73.84789081506042,
                },
                {
                  lat: 40.759561504252815,
                  lng: -73.84568343276048,
                },
                {
                  lat: 40.75954626642679,
                  lng: -73.84556407431778,
                },
                {
                  lat: 40.758650808710286,
                  lng: -73.84508932394594,
                },
                {
                  lat: 40.75862338107435,
                  lng: -73.84513492155455,
                },
                {
                  lat: 40.75847152790236,
                  lng: -73.84566733871623,
                },
                {
                  lat: 40.75844979416734,
                  lng: -73.84569012910532,
                },
                {
                  lat: 40.75762390691657,
                  lng: -73.84819397193895,
                },
                {
                  lat: 40.757461366336464,
                  lng: -73.84868481364319,
                },
                {
                  lat: 40.75753755559373,
                  lng: -73.84868213252086,
                },
                {
                  lat: 40.75753755559373,
                  lng: -73.84868213252086,
                },
                {
                  lat: 40.757791694024206,
                  lng: -73.8488402453693,
                },
                {
                  lat: 40.757791694024206,
                  lng: -73.8488402453693,
                },
                {
                  lat: 40.757831669790725,
                  lng: -73.8488473771783,
                },
                {
                  lat: 40.75785273811002,
                  lng: -73.84883810592447,
                },
                {
                  lat: 40.75811509769592,
                  lng: -73.84842676237491,
                },
              ],
              shape: "stroke",
            },
            {
              shape: "stroke",
              paths: [
                {
                  lat: 40.757953718250604,
                  lng: -73.8481919975431,
                },
                {
                  lat: 40.758612089247535,
                  lng: -73.84598367167747,
                },
              ],
            },
            {
              shape: "stroke",
              paths: [
                {
                  lat: 40.75799991324995,
                  lng: -73.84821574184352,
                },
                {
                  lat: 40.75790948241505,
                  lng: -73.8481681851226,
                },
              ],
            },
            {
              shape: "stroke",
              paths: [
                {
                  lat: 40.75800863580032,
                  lng: -73.8481863527074,
                },
                {
                  lat: 40.75791713949157,
                  lng: -73.84814032790807,
                },
              ],
            },
            {
              shape: "stroke",
              paths: [
                {
                  lat: 40.75801437132073,
                  lng: -73.8481607358166,
                },
                {
                  lat: 40.757925390309715,
                  lng: -73.84811285983771,
                },
              ],
            },
            {
              shape: "stroke",
              paths: [
                {
                  lat: 40.7580244118424,
                  lng: -73.8481346624244,
                },
                {
                  lat: 40.75793256492758,
                  lng: -73.84808586535053,
                },
              ],
            },
            {
              shape: "stroke",
              paths: [
                {
                  lat: 40.758034081417065,
                  lng: -73.84810874102077,
                },
                {
                  lat: 40.75794151458426,
                  lng: -73.84805842582851,
                },
              ],
            },
            {
              shape: "stroke",
              paths: [
                {
                  lat: 40.75804164461913,
                  lng: -73.84808068849033,
                },
                {
                  lat: 40.75794979700286,
                  lng: -73.84803178252865,
                },
              ],
            },
            {
              shape: "stroke",
              paths: [
                {
                  lat: 40.75804701271827,
                  lng: -73.84805450125083,
                },
                {
                  lat: 40.757957008547756,
                  lng: -73.8480055650308,
                },
              ],
            },
            {
              shape: "stroke",
              paths: [
                {
                  lat: 40.75805713116388,
                  lng: -73.84802600979256,
                },
                {
                  lat: 40.757964571722354,
                  lng: -73.84797893890382,
                },
              ],
            },
          ],
        },
        {
          parkingLot: "A",
          slots: [
            {
              paths: [
                {
                  lat: 40.758225248713806,
                  lng: -73.8474589523742,
                },
                {
                  lat: 40.75818027055971,
                  lng: -73.84743547459969,
                },
                {
                  lat: 40.758188354662245,
                  lng: -73.84740877864596,
                },
                {
                  lat: 40.75823336887028,
                  lng: -73.84743221045616,
                },
                {
                  lat: 40.758225248713806,
                  lng: -73.8474589523742,
                },
              ],
              type: "events",
              shape: "fill",
            },
            {
              paths: [
                {
                  lat: 40.75835227672024,
                  lng: -73.84702772080189,
                },
                {
                  lat: 40.75830903256137,
                  lng: -73.84700513426486,
                },
                {
                  lat: 40.758317243423136,
                  lng: -73.84697971553202,
                },
                {
                  lat: 40.75836232187898,
                  lng: -73.84700214239611,
                },
                {
                  lat: 40.75835227672024,
                  lng: -73.84702772080189,
                },
              ],
              type: "opAlerts",
              shape: "fill",
            },
            {
              paths: [
                {
                  lat: 40.75823336887028,
                  lng: -73.84743221045616,
                },
                {
                  lat: 40.758188354662245,
                  lng: -73.84740877864596,
                },
                {
                  lat: 40.75819655708222,
                  lng: -73.84738166640747,
                },
                {
                  lat: 40.75824111101975,
                  lng: -73.84740490475849,
                },
                {
                  lat: 40.75823336887028,
                  lng: -73.84743221045616,
                },
              ],
              type: "incidents",
              shape: "fill",
            },
            {
              paths: [
                {
                  lat: 40.75824111101975,
                  lng: -73.84740490475849,
                },
                {
                  lat: 40.75819655708222,
                  lng: -73.84738166640747,
                },
                {
                  lat: 40.75820420527928,
                  lng: -73.84735559898782,
                },
                {
                  lat: 40.75824945261164,
                  lng: -73.84737783632028,
                },
                {
                  lat: 40.75824111101975,
                  lng: -73.84740490475849,
                },
              ],
              type: "events",
              shape: "fill",
            },
            {
              paths: [
                {
                  lat: 40.758134748913236,
                  lng: -73.84741121211586,
                },
                {
                  lat: 40.75818027055971,
                  lng: -73.84743547459969,
                },
                {
                  lat: 40.758188354662245,
                  lng: -73.84740877864596,
                },
                {
                  lat: 40.758143043289124,
                  lng: -73.84738405172214,
                },
                {
                  lat: 40.758134748913236,
                  lng: -73.84741121211586,
                },
              ],
              type: "incidents",
              shape: "fill",
            },
            {
              paths: [
                {
                  lat: 40.75811509769592,
                  lng: -73.84842676237491,
                },
                {
                  lat: 40.75822772728387,
                  lng: -73.8482998519924,
                },
                {
                  lat: 40.758279535608,
                  lng: -73.84824553737229,
                },
                {
                  lat: 40.75839737406086,
                  lng: -73.84809131023971,
                },
                {
                  lat: 40.75843496010653,
                  lng: -73.84803565444743,
                },
                {
                  lat: 40.75852029112063,
                  lng: -73.84789081506042,
                },
                {
                  lat: 40.759561504252815,
                  lng: -73.84568343276048,
                },
                {
                  lat: 40.75954626642679,
                  lng: -73.84556407431778,
                },
                {
                  lat: 40.758650808710286,
                  lng: -73.84508932394594,
                },
                {
                  lat: 40.75862338107435,
                  lng: -73.84513492155455,
                },
                {
                  lat: 40.75847152790236,
                  lng: -73.84566733871623,
                },
                {
                  lat: 40.75844979416734,
                  lng: -73.84569012910532,
                },
                {
                  lat: 40.75762390691657,
                  lng: -73.84819397193895,
                },
                {
                  lat: 40.757461366336464,
                  lng: -73.84868481364319,
                },
                {
                  lat: 40.75753755559373,
                  lng: -73.84868213252086,
                },
                {
                  lat: 40.75753755559373,
                  lng: -73.84868213252086,
                },
                {
                  lat: 40.757791694024206,
                  lng: -73.8488402453693,
                },
                {
                  lat: 40.757791694024206,
                  lng: -73.8488402453693,
                },
                {
                  lat: 40.757831669790725,
                  lng: -73.8488473771783,
                },
                {
                  lat: 40.75785273811002,
                  lng: -73.84883810592447,
                },
                {
                  lat: 40.75811509769592,
                  lng: -73.84842676237491,
                },
              ],
              shape: "stroke",
            },
            {
              shape: "stroke",
              paths: [
                {
                  lat: 40.757953718250604,
                  lng: -73.8481919975431,
                },
                {
                  lat: 40.758612089247535,
                  lng: -73.84598367167747,
                },
              ],
            },
            {
              shape: "stroke",
              paths: [
                {
                  lat: 40.75799991324995,
                  lng: -73.84821574184352,
                },
                {
                  lat: 40.75790948241505,
                  lng: -73.8481681851226,
                },
              ],
            },
            {
              shape: "stroke",
              paths: [
                {
                  lat: 40.75800863580032,
                  lng: -73.8481863527074,
                },
                {
                  lat: 40.75791713949157,
                  lng: -73.84814032790807,
                },
              ],
            },
            {
              shape: "stroke",
              paths: [
                {
                  lat: 40.75801437132073,
                  lng: -73.8481607358166,
                },
                {
                  lat: 40.757925390309715,
                  lng: -73.84811285983771,
                },
              ],
            },
            {
              shape: "stroke",
              paths: [
                {
                  lat: 40.7580244118424,
                  lng: -73.8481346624244,
                },
                {
                  lat: 40.75793256492758,
                  lng: -73.84808586535053,
                },
              ],
            },
            {
              shape: "stroke",
              paths: [
                {
                  lat: 40.758034081417065,
                  lng: -73.84810874102077,
                },
                {
                  lat: 40.75794151458426,
                  lng: -73.84805842582851,
                },
              ],
            },
            {
              shape: "stroke",
              paths: [
                {
                  lat: 40.75804164461913,
                  lng: -73.84808068849033,
                },
                {
                  lat: 40.75794979700286,
                  lng: -73.84803178252865,
                },
              ],
            },
            {
              shape: "stroke",
              paths: [
                {
                  lat: 40.75804701271827,
                  lng: -73.84805450125083,
                },
                {
                  lat: 40.757957008547756,
                  lng: -73.8480055650308,
                },
              ],
            },
            {
              shape: "stroke",
              paths: [
                {
                  lat: 40.75805713116388,
                  lng: -73.84802600979256,
                },
                {
                  lat: 40.757964571722354,
                  lng: -73.84797893890382,
                },
              ],
            },
          ],
        },
        {
          parkingLot: "A",
          slots: [
            {
              paths: [
                {
                  lat: 40.758225248713806,
                  lng: -73.8474589523742,
                },
                {
                  lat: 40.75818027055971,
                  lng: -73.84743547459969,
                },
                {
                  lat: 40.758188354662245,
                  lng: -73.84740877864596,
                },
                {
                  lat: 40.75823336887028,
                  lng: -73.84743221045616,
                },
                {
                  lat: 40.758225248713806,
                  lng: -73.8474589523742,
                },
              ],
              type: "events",
              shape: "fill",
            },
            {
              paths: [
                {
                  lat: 40.75835227672024,
                  lng: -73.84702772080189,
                },
                {
                  lat: 40.75830903256137,
                  lng: -73.84700513426486,
                },
                {
                  lat: 40.758317243423136,
                  lng: -73.84697971553202,
                },
                {
                  lat: 40.75836232187898,
                  lng: -73.84700214239611,
                },
                {
                  lat: 40.75835227672024,
                  lng: -73.84702772080189,
                },
              ],
              type: "opAlerts",
              shape: "fill",
            },
            {
              paths: [
                {
                  lat: 40.75823336887028,
                  lng: -73.84743221045616,
                },
                {
                  lat: 40.758188354662245,
                  lng: -73.84740877864596,
                },
                {
                  lat: 40.75819655708222,
                  lng: -73.84738166640747,
                },
                {
                  lat: 40.75824111101975,
                  lng: -73.84740490475849,
                },
                {
                  lat: 40.75823336887028,
                  lng: -73.84743221045616,
                },
              ],
              type: "incidents",
              shape: "fill",
            },
            {
              paths: [
                {
                  lat: 40.75824111101975,
                  lng: -73.84740490475849,
                },
                {
                  lat: 40.75819655708222,
                  lng: -73.84738166640747,
                },
                {
                  lat: 40.75820420527928,
                  lng: -73.84735559898782,
                },
                {
                  lat: 40.75824945261164,
                  lng: -73.84737783632028,
                },
                {
                  lat: 40.75824111101975,
                  lng: -73.84740490475849,
                },
              ],
              type: "events",
              shape: "fill",
            },
            {
              paths: [
                {
                  lat: 40.758134748913236,
                  lng: -73.84741121211586,
                },
                {
                  lat: 40.75818027055971,
                  lng: -73.84743547459969,
                },
                {
                  lat: 40.758188354662245,
                  lng: -73.84740877864596,
                },
                {
                  lat: 40.758143043289124,
                  lng: -73.84738405172214,
                },
                {
                  lat: 40.758134748913236,
                  lng: -73.84741121211586,
                },
              ],
              type: "incidents",
              shape: "fill",
            },
            {
              paths: [
                {
                  lat: 40.75811509769592,
                  lng: -73.84842676237491,
                },
                {
                  lat: 40.75822772728387,
                  lng: -73.8482998519924,
                },
                {
                  lat: 40.758279535608,
                  lng: -73.84824553737229,
                },
                {
                  lat: 40.75839737406086,
                  lng: -73.84809131023971,
                },
                {
                  lat: 40.75843496010653,
                  lng: -73.84803565444743,
                },
                {
                  lat: 40.75852029112063,
                  lng: -73.84789081506042,
                },
                {
                  lat: 40.759561504252815,
                  lng: -73.84568343276048,
                },
                {
                  lat: 40.75954626642679,
                  lng: -73.84556407431778,
                },
                {
                  lat: 40.758650808710286,
                  lng: -73.84508932394594,
                },
                {
                  lat: 40.75862338107435,
                  lng: -73.84513492155455,
                },
                {
                  lat: 40.75847152790236,
                  lng: -73.84566733871623,
                },
                {
                  lat: 40.75844979416734,
                  lng: -73.84569012910532,
                },
                {
                  lat: 40.75762390691657,
                  lng: -73.84819397193895,
                },
                {
                  lat: 40.757461366336464,
                  lng: -73.84868481364319,
                },
                {
                  lat: 40.75753755559373,
                  lng: -73.84868213252086,
                },
                {
                  lat: 40.75753755559373,
                  lng: -73.84868213252086,
                },
                {
                  lat: 40.757791694024206,
                  lng: -73.8488402453693,
                },
                {
                  lat: 40.757791694024206,
                  lng: -73.8488402453693,
                },
                {
                  lat: 40.757831669790725,
                  lng: -73.8488473771783,
                },
                {
                  lat: 40.75785273811002,
                  lng: -73.84883810592447,
                },
                {
                  lat: 40.75811509769592,
                  lng: -73.84842676237491,
                },
              ],
              shape: "stroke",
            },
            {
              shape: "stroke",
              paths: [
                {
                  lat: 40.757953718250604,
                  lng: -73.8481919975431,
                },
                {
                  lat: 40.758612089247535,
                  lng: -73.84598367167747,
                },
              ],
            },
            {
              shape: "stroke",
              paths: [
                {
                  lat: 40.75799991324995,
                  lng: -73.84821574184352,
                },
                {
                  lat: 40.75790948241505,
                  lng: -73.8481681851226,
                },
              ],
            },
            {
              shape: "stroke",
              paths: [
                {
                  lat: 40.75800863580032,
                  lng: -73.8481863527074,
                },
                {
                  lat: 40.75791713949157,
                  lng: -73.84814032790807,
                },
              ],
            },
            {
              shape: "stroke",
              paths: [
                {
                  lat: 40.75801437132073,
                  lng: -73.8481607358166,
                },
                {
                  lat: 40.757925390309715,
                  lng: -73.84811285983771,
                },
              ],
            },
            {
              shape: "stroke",
              paths: [
                {
                  lat: 40.7580244118424,
                  lng: -73.8481346624244,
                },
                {
                  lat: 40.75793256492758,
                  lng: -73.84808586535053,
                },
              ],
            },
            {
              shape: "stroke",
              paths: [
                {
                  lat: 40.758034081417065,
                  lng: -73.84810874102077,
                },
                {
                  lat: 40.75794151458426,
                  lng: -73.84805842582851,
                },
              ],
            },
            {
              shape: "stroke",
              paths: [
                {
                  lat: 40.75804164461913,
                  lng: -73.84808068849033,
                },
                {
                  lat: 40.75794979700286,
                  lng: -73.84803178252865,
                },
              ],
            },
            {
              shape: "stroke",
              paths: [
                {
                  lat: 40.75804701271827,
                  lng: -73.84805450125083,
                },
                {
                  lat: 40.757957008547756,
                  lng: -73.8480055650308,
                },
              ],
            },
            {
              shape: "stroke",
              paths: [
                {
                  lat: 40.75805713116388,
                  lng: -73.84802600979256,
                },
                {
                  lat: 40.757964571722354,
                  lng: -73.84797893890382,
                },
              ],
            },
          ],
        },
        {
          parkingLot: "A",
          slots: [
            {
              paths: [
                {
                  lat: 40.758225248713806,
                  lng: -73.8474589523742,
                },
                {
                  lat: 40.75818027055971,
                  lng: -73.84743547459969,
                },
                {
                  lat: 40.758188354662245,
                  lng: -73.84740877864596,
                },
                {
                  lat: 40.75823336887028,
                  lng: -73.84743221045616,
                },
                {
                  lat: 40.758225248713806,
                  lng: -73.8474589523742,
                },
              ],
              type: "events",
              shape: "fill",
            },
            {
              paths: [
                {
                  lat: 40.75835227672024,
                  lng: -73.84702772080189,
                },
                {
                  lat: 40.75830903256137,
                  lng: -73.84700513426486,
                },
                {
                  lat: 40.758317243423136,
                  lng: -73.84697971553202,
                },
                {
                  lat: 40.75836232187898,
                  lng: -73.84700214239611,
                },
                {
                  lat: 40.75835227672024,
                  lng: -73.84702772080189,
                },
              ],
              type: "opAlerts",
              shape: "fill",
            },
            {
              paths: [
                {
                  lat: 40.75823336887028,
                  lng: -73.84743221045616,
                },
                {
                  lat: 40.758188354662245,
                  lng: -73.84740877864596,
                },
                {
                  lat: 40.75819655708222,
                  lng: -73.84738166640747,
                },
                {
                  lat: 40.75824111101975,
                  lng: -73.84740490475849,
                },
                {
                  lat: 40.75823336887028,
                  lng: -73.84743221045616,
                },
              ],
              type: "incidents",
              shape: "fill",
            },
            {
              paths: [
                {
                  lat: 40.75824111101975,
                  lng: -73.84740490475849,
                },
                {
                  lat: 40.75819655708222,
                  lng: -73.84738166640747,
                },
                {
                  lat: 40.75820420527928,
                  lng: -73.84735559898782,
                },
                {
                  lat: 40.75824945261164,
                  lng: -73.84737783632028,
                },
                {
                  lat: 40.75824111101975,
                  lng: -73.84740490475849,
                },
              ],
              type: "events",
              shape: "fill",
            },
            {
              paths: [
                {
                  lat: 40.758134748913236,
                  lng: -73.84741121211586,
                },
                {
                  lat: 40.75818027055971,
                  lng: -73.84743547459969,
                },
                {
                  lat: 40.758188354662245,
                  lng: -73.84740877864596,
                },
                {
                  lat: 40.758143043289124,
                  lng: -73.84738405172214,
                },
                {
                  lat: 40.758134748913236,
                  lng: -73.84741121211586,
                },
              ],
              type: "incidents",
              shape: "fill",
            },
            {
              paths: [
                {
                  lat: 40.75811509769592,
                  lng: -73.84842676237491,
                },
                {
                  lat: 40.75822772728387,
                  lng: -73.8482998519924,
                },
                {
                  lat: 40.758279535608,
                  lng: -73.84824553737229,
                },
                {
                  lat: 40.75839737406086,
                  lng: -73.84809131023971,
                },
                {
                  lat: 40.75843496010653,
                  lng: -73.84803565444743,
                },
                {
                  lat: 40.75852029112063,
                  lng: -73.84789081506042,
                },
                {
                  lat: 40.759561504252815,
                  lng: -73.84568343276048,
                },
                {
                  lat: 40.75954626642679,
                  lng: -73.84556407431778,
                },
                {
                  lat: 40.758650808710286,
                  lng: -73.84508932394594,
                },
                {
                  lat: 40.75862338107435,
                  lng: -73.84513492155455,
                },
                {
                  lat: 40.75847152790236,
                  lng: -73.84566733871623,
                },
                {
                  lat: 40.75844979416734,
                  lng: -73.84569012910532,
                },
                {
                  lat: 40.75762390691657,
                  lng: -73.84819397193895,
                },
                {
                  lat: 40.757461366336464,
                  lng: -73.84868481364319,
                },
                {
                  lat: 40.75753755559373,
                  lng: -73.84868213252086,
                },
                {
                  lat: 40.75753755559373,
                  lng: -73.84868213252086,
                },
                {
                  lat: 40.757791694024206,
                  lng: -73.8488402453693,
                },
                {
                  lat: 40.757791694024206,
                  lng: -73.8488402453693,
                },
                {
                  lat: 40.757831669790725,
                  lng: -73.8488473771783,
                },
                {
                  lat: 40.75785273811002,
                  lng: -73.84883810592447,
                },
                {
                  lat: 40.75811509769592,
                  lng: -73.84842676237491,
                },
              ],
              shape: "stroke",
            },
            {
              shape: "stroke",
              paths: [
                {
                  lat: 40.757953718250604,
                  lng: -73.8481919975431,
                },
                {
                  lat: 40.758612089247535,
                  lng: -73.84598367167747,
                },
              ],
            },
            {
              shape: "stroke",
              paths: [
                {
                  lat: 40.75799991324995,
                  lng: -73.84821574184352,
                },
                {
                  lat: 40.75790948241505,
                  lng: -73.8481681851226,
                },
              ],
            },
            {
              shape: "stroke",
              paths: [
                {
                  lat: 40.75800863580032,
                  lng: -73.8481863527074,
                },
                {
                  lat: 40.75791713949157,
                  lng: -73.84814032790807,
                },
              ],
            },
            {
              shape: "stroke",
              paths: [
                {
                  lat: 40.75801437132073,
                  lng: -73.8481607358166,
                },
                {
                  lat: 40.757925390309715,
                  lng: -73.84811285983771,
                },
              ],
            },
            {
              shape: "stroke",
              paths: [
                {
                  lat: 40.7580244118424,
                  lng: -73.8481346624244,
                },
                {
                  lat: 40.75793256492758,
                  lng: -73.84808586535053,
                },
              ],
            },
            {
              shape: "stroke",
              paths: [
                {
                  lat: 40.758034081417065,
                  lng: -73.84810874102077,
                },
                {
                  lat: 40.75794151458426,
                  lng: -73.84805842582851,
                },
              ],
            },
            {
              shape: "stroke",
              paths: [
                {
                  lat: 40.75804164461913,
                  lng: -73.84808068849033,
                },
                {
                  lat: 40.75794979700286,
                  lng: -73.84803178252865,
                },
              ],
            },
            {
              shape: "stroke",
              paths: [
                {
                  lat: 40.75804701271827,
                  lng: -73.84805450125083,
                },
                {
                  lat: 40.757957008547756,
                  lng: -73.8480055650308,
                },
              ],
            },
            {
              shape: "stroke",
              paths: [
                {
                  lat: 40.75805713116388,
                  lng: -73.84802600979256,
                },
                {
                  lat: 40.757964571722354,
                  lng: -73.84797893890382,
                },
              ],
            },
          ],
        },
        {
          parkingLot: "A",
          slots: [
            {
              paths: [
                {
                  lat: 40.758225248713806,
                  lng: -73.8474589523742,
                },
                {
                  lat: 40.75818027055971,
                  lng: -73.84743547459969,
                },
                {
                  lat: 40.758188354662245,
                  lng: -73.84740877864596,
                },
                {
                  lat: 40.75823336887028,
                  lng: -73.84743221045616,
                },
                {
                  lat: 40.758225248713806,
                  lng: -73.8474589523742,
                },
              ],
              type: "events",
              shape: "fill",
            },
            {
              paths: [
                {
                  lat: 40.75835227672024,
                  lng: -73.84702772080189,
                },
                {
                  lat: 40.75830903256137,
                  lng: -73.84700513426486,
                },
                {
                  lat: 40.758317243423136,
                  lng: -73.84697971553202,
                },
                {
                  lat: 40.75836232187898,
                  lng: -73.84700214239611,
                },
                {
                  lat: 40.75835227672024,
                  lng: -73.84702772080189,
                },
              ],
              type: "opAlerts",
              shape: "fill",
            },
            {
              paths: [
                {
                  lat: 40.75823336887028,
                  lng: -73.84743221045616,
                },
                {
                  lat: 40.758188354662245,
                  lng: -73.84740877864596,
                },
                {
                  lat: 40.75819655708222,
                  lng: -73.84738166640747,
                },
                {
                  lat: 40.75824111101975,
                  lng: -73.84740490475849,
                },
                {
                  lat: 40.75823336887028,
                  lng: -73.84743221045616,
                },
              ],
              type: "incidents",
              shape: "fill",
            },
            {
              paths: [
                {
                  lat: 40.75824111101975,
                  lng: -73.84740490475849,
                },
                {
                  lat: 40.75819655708222,
                  lng: -73.84738166640747,
                },
                {
                  lat: 40.75820420527928,
                  lng: -73.84735559898782,
                },
                {
                  lat: 40.75824945261164,
                  lng: -73.84737783632028,
                },
                {
                  lat: 40.75824111101975,
                  lng: -73.84740490475849,
                },
              ],
              type: "events",
              shape: "fill",
            },
            {
              paths: [
                {
                  lat: 40.758134748913236,
                  lng: -73.84741121211586,
                },
                {
                  lat: 40.75818027055971,
                  lng: -73.84743547459969,
                },
                {
                  lat: 40.758188354662245,
                  lng: -73.84740877864596,
                },
                {
                  lat: 40.758143043289124,
                  lng: -73.84738405172214,
                },
                {
                  lat: 40.758134748913236,
                  lng: -73.84741121211586,
                },
              ],
              type: "incidents",
              shape: "fill",
            },
            {
              paths: [
                {
                  lat: 40.75811509769592,
                  lng: -73.84842676237491,
                },
                {
                  lat: 40.75822772728387,
                  lng: -73.8482998519924,
                },
                {
                  lat: 40.758279535608,
                  lng: -73.84824553737229,
                },
                {
                  lat: 40.75839737406086,
                  lng: -73.84809131023971,
                },
                {
                  lat: 40.75843496010653,
                  lng: -73.84803565444743,
                },
                {
                  lat: 40.75852029112063,
                  lng: -73.84789081506042,
                },
                {
                  lat: 40.759561504252815,
                  lng: -73.84568343276048,
                },
                {
                  lat: 40.75954626642679,
                  lng: -73.84556407431778,
                },
                {
                  lat: 40.758650808710286,
                  lng: -73.84508932394594,
                },
                {
                  lat: 40.75862338107435,
                  lng: -73.84513492155455,
                },
                {
                  lat: 40.75847152790236,
                  lng: -73.84566733871623,
                },
                {
                  lat: 40.75844979416734,
                  lng: -73.84569012910532,
                },
                {
                  lat: 40.75762390691657,
                  lng: -73.84819397193895,
                },
                {
                  lat: 40.757461366336464,
                  lng: -73.84868481364319,
                },
                {
                  lat: 40.75753755559373,
                  lng: -73.84868213252086,
                },
                {
                  lat: 40.75753755559373,
                  lng: -73.84868213252086,
                },
                {
                  lat: 40.757791694024206,
                  lng: -73.8488402453693,
                },
                {
                  lat: 40.757791694024206,
                  lng: -73.8488402453693,
                },
                {
                  lat: 40.757831669790725,
                  lng: -73.8488473771783,
                },
                {
                  lat: 40.75785273811002,
                  lng: -73.84883810592447,
                },
                {
                  lat: 40.75811509769592,
                  lng: -73.84842676237491,
                },
              ],
              shape: "stroke",
            },
            {
              shape: "stroke",
              paths: [
                {
                  lat: 40.757953718250604,
                  lng: -73.8481919975431,
                },
                {
                  lat: 40.758612089247535,
                  lng: -73.84598367167747,
                },
              ],
            },
            {
              shape: "stroke",
              paths: [
                {
                  lat: 40.75799991324995,
                  lng: -73.84821574184352,
                },
                {
                  lat: 40.75790948241505,
                  lng: -73.8481681851226,
                },
              ],
            },
            {
              shape: "stroke",
              paths: [
                {
                  lat: 40.75800863580032,
                  lng: -73.8481863527074,
                },
                {
                  lat: 40.75791713949157,
                  lng: -73.84814032790807,
                },
              ],
            },
            {
              shape: "stroke",
              paths: [
                {
                  lat: 40.75801437132073,
                  lng: -73.8481607358166,
                },
                {
                  lat: 40.757925390309715,
                  lng: -73.84811285983771,
                },
              ],
            },
            {
              shape: "stroke",
              paths: [
                {
                  lat: 40.7580244118424,
                  lng: -73.8481346624244,
                },
                {
                  lat: 40.75793256492758,
                  lng: -73.84808586535053,
                },
              ],
            },
            {
              shape: "stroke",
              paths: [
                {
                  lat: 40.758034081417065,
                  lng: -73.84810874102077,
                },
                {
                  lat: 40.75794151458426,
                  lng: -73.84805842582851,
                },
              ],
            },
            {
              shape: "stroke",
              paths: [
                {
                  lat: 40.75804164461913,
                  lng: -73.84808068849033,
                },
                {
                  lat: 40.75794979700286,
                  lng: -73.84803178252865,
                },
              ],
            },
            {
              shape: "stroke",
              paths: [
                {
                  lat: 40.75804701271827,
                  lng: -73.84805450125083,
                },
                {
                  lat: 40.757957008547756,
                  lng: -73.8480055650308,
                },
              ],
            },
            {
              shape: "stroke",
              paths: [
                {
                  lat: 40.75805713116388,
                  lng: -73.84802600979256,
                },
                {
                  lat: 40.757964571722354,
                  lng: -73.84797893890382,
                },
              ],
            },
          ],
        },
        {
          parkingLot: "A",
          slots: [
            {
              paths: [
                {
                  lat: 40.758225248713806,
                  lng: -73.8474589523742,
                },
                {
                  lat: 40.75818027055971,
                  lng: -73.84743547459969,
                },
                {
                  lat: 40.758188354662245,
                  lng: -73.84740877864596,
                },
                {
                  lat: 40.75823336887028,
                  lng: -73.84743221045616,
                },
                {
                  lat: 40.758225248713806,
                  lng: -73.8474589523742,
                },
              ],
              type: "events",
              shape: "fill",
            },
            {
              paths: [
                {
                  lat: 40.75835227672024,
                  lng: -73.84702772080189,
                },
                {
                  lat: 40.75830903256137,
                  lng: -73.84700513426486,
                },
                {
                  lat: 40.758317243423136,
                  lng: -73.84697971553202,
                },
                {
                  lat: 40.75836232187898,
                  lng: -73.84700214239611,
                },
                {
                  lat: 40.75835227672024,
                  lng: -73.84702772080189,
                },
              ],
              type: "opAlerts",
              shape: "fill",
            },
            {
              paths: [
                {
                  lat: 40.75823336887028,
                  lng: -73.84743221045616,
                },
                {
                  lat: 40.758188354662245,
                  lng: -73.84740877864596,
                },
                {
                  lat: 40.75819655708222,
                  lng: -73.84738166640747,
                },
                {
                  lat: 40.75824111101975,
                  lng: -73.84740490475849,
                },
                {
                  lat: 40.75823336887028,
                  lng: -73.84743221045616,
                },
              ],
              type: "incidents",
              shape: "fill",
            },
            {
              paths: [
                {
                  lat: 40.75824111101975,
                  lng: -73.84740490475849,
                },
                {
                  lat: 40.75819655708222,
                  lng: -73.84738166640747,
                },
                {
                  lat: 40.75820420527928,
                  lng: -73.84735559898782,
                },
                {
                  lat: 40.75824945261164,
                  lng: -73.84737783632028,
                },
                {
                  lat: 40.75824111101975,
                  lng: -73.84740490475849,
                },
              ],
              type: "events",
              shape: "fill",
            },
            {
              paths: [
                {
                  lat: 40.758134748913236,
                  lng: -73.84741121211586,
                },
                {
                  lat: 40.75818027055971,
                  lng: -73.84743547459969,
                },
                {
                  lat: 40.758188354662245,
                  lng: -73.84740877864596,
                },
                {
                  lat: 40.758143043289124,
                  lng: -73.84738405172214,
                },
                {
                  lat: 40.758134748913236,
                  lng: -73.84741121211586,
                },
              ],
              type: "incidents",
              shape: "fill",
            },
            {
              paths: [
                {
                  lat: 40.75811509769592,
                  lng: -73.84842676237491,
                },
                {
                  lat: 40.75822772728387,
                  lng: -73.8482998519924,
                },
                {
                  lat: 40.758279535608,
                  lng: -73.84824553737229,
                },
                {
                  lat: 40.75839737406086,
                  lng: -73.84809131023971,
                },
                {
                  lat: 40.75843496010653,
                  lng: -73.84803565444743,
                },
                {
                  lat: 40.75852029112063,
                  lng: -73.84789081506042,
                },
                {
                  lat: 40.759561504252815,
                  lng: -73.84568343276048,
                },
                {
                  lat: 40.75954626642679,
                  lng: -73.84556407431778,
                },
                {
                  lat: 40.758650808710286,
                  lng: -73.84508932394594,
                },
                {
                  lat: 40.75862338107435,
                  lng: -73.84513492155455,
                },
                {
                  lat: 40.75847152790236,
                  lng: -73.84566733871623,
                },
                {
                  lat: 40.75844979416734,
                  lng: -73.84569012910532,
                },
                {
                  lat: 40.75762390691657,
                  lng: -73.84819397193895,
                },
                {
                  lat: 40.757461366336464,
                  lng: -73.84868481364319,
                },
                {
                  lat: 40.75753755559373,
                  lng: -73.84868213252086,
                },
                {
                  lat: 40.75753755559373,
                  lng: -73.84868213252086,
                },
                {
                  lat: 40.757791694024206,
                  lng: -73.8488402453693,
                },
                {
                  lat: 40.757791694024206,
                  lng: -73.8488402453693,
                },
                {
                  lat: 40.757831669790725,
                  lng: -73.8488473771783,
                },
                {
                  lat: 40.75785273811002,
                  lng: -73.84883810592447,
                },
                {
                  lat: 40.75811509769592,
                  lng: -73.84842676237491,
                },
              ],
              shape: "stroke",
            },
            {
              shape: "stroke",
              paths: [
                {
                  lat: 40.757953718250604,
                  lng: -73.8481919975431,
                },
                {
                  lat: 40.758612089247535,
                  lng: -73.84598367167747,
                },
              ],
            },
            {
              shape: "stroke",
              paths: [
                {
                  lat: 40.75799991324995,
                  lng: -73.84821574184352,
                },
                {
                  lat: 40.75790948241505,
                  lng: -73.8481681851226,
                },
              ],
            },
            {
              shape: "stroke",
              paths: [
                {
                  lat: 40.75800863580032,
                  lng: -73.8481863527074,
                },
                {
                  lat: 40.75791713949157,
                  lng: -73.84814032790807,
                },
              ],
            },
            {
              shape: "stroke",
              paths: [
                {
                  lat: 40.75801437132073,
                  lng: -73.8481607358166,
                },
                {
                  lat: 40.757925390309715,
                  lng: -73.84811285983771,
                },
              ],
            },
            {
              shape: "stroke",
              paths: [
                {
                  lat: 40.7580244118424,
                  lng: -73.8481346624244,
                },
                {
                  lat: 40.75793256492758,
                  lng: -73.84808586535053,
                },
              ],
            },
            {
              shape: "stroke",
              paths: [
                {
                  lat: 40.758034081417065,
                  lng: -73.84810874102077,
                },
                {
                  lat: 40.75794151458426,
                  lng: -73.84805842582851,
                },
              ],
            },
            {
              shape: "stroke",
              paths: [
                {
                  lat: 40.75804164461913,
                  lng: -73.84808068849033,
                },
                {
                  lat: 40.75794979700286,
                  lng: -73.84803178252865,
                },
              ],
            },
            {
              shape: "stroke",
              paths: [
                {
                  lat: 40.75804701271827,
                  lng: -73.84805450125083,
                },
                {
                  lat: 40.757957008547756,
                  lng: -73.8480055650308,
                },
              ],
            },
            {
              shape: "stroke",
              paths: [
                {
                  lat: 40.75805713116388,
                  lng: -73.84802600979256,
                },
                {
                  lat: 40.757964571722354,
                  lng: -73.84797893890382,
                },
              ],
            },
          ],
        },
        {
          parkingLot: "A",
          slots: [
            {
              paths: [
                {
                  lat: 40.758225248713806,
                  lng: -73.8474589523742,
                },
                {
                  lat: 40.75818027055971,
                  lng: -73.84743547459969,
                },
                {
                  lat: 40.758188354662245,
                  lng: -73.84740877864596,
                },
                {
                  lat: 40.75823336887028,
                  lng: -73.84743221045616,
                },
                {
                  lat: 40.758225248713806,
                  lng: -73.8474589523742,
                },
              ],
              type: "events",
              shape: "fill",
            },
            {
              paths: [
                {
                  lat: 40.75835227672024,
                  lng: -73.84702772080189,
                },
                {
                  lat: 40.75830903256137,
                  lng: -73.84700513426486,
                },
                {
                  lat: 40.758317243423136,
                  lng: -73.84697971553202,
                },
                {
                  lat: 40.75836232187898,
                  lng: -73.84700214239611,
                },
                {
                  lat: 40.75835227672024,
                  lng: -73.84702772080189,
                },
              ],
              type: "opAlerts",
              shape: "fill",
            },
            {
              paths: [
                {
                  lat: 40.75823336887028,
                  lng: -73.84743221045616,
                },
                {
                  lat: 40.758188354662245,
                  lng: -73.84740877864596,
                },
                {
                  lat: 40.75819655708222,
                  lng: -73.84738166640747,
                },
                {
                  lat: 40.75824111101975,
                  lng: -73.84740490475849,
                },
                {
                  lat: 40.75823336887028,
                  lng: -73.84743221045616,
                },
              ],
              type: "incidents",
              shape: "fill",
            },
            {
              paths: [
                {
                  lat: 40.75824111101975,
                  lng: -73.84740490475849,
                },
                {
                  lat: 40.75819655708222,
                  lng: -73.84738166640747,
                },
                {
                  lat: 40.75820420527928,
                  lng: -73.84735559898782,
                },
                {
                  lat: 40.75824945261164,
                  lng: -73.84737783632028,
                },
                {
                  lat: 40.75824111101975,
                  lng: -73.84740490475849,
                },
              ],
              type: "events",
              shape: "fill",
            },
            {
              paths: [
                {
                  lat: 40.758134748913236,
                  lng: -73.84741121211586,
                },
                {
                  lat: 40.75818027055971,
                  lng: -73.84743547459969,
                },
                {
                  lat: 40.758188354662245,
                  lng: -73.84740877864596,
                },
                {
                  lat: 40.758143043289124,
                  lng: -73.84738405172214,
                },
                {
                  lat: 40.758134748913236,
                  lng: -73.84741121211586,
                },
              ],
              type: "incidents",
              shape: "fill",
            },
            {
              paths: [
                {
                  lat: 40.75811509769592,
                  lng: -73.84842676237491,
                },
                {
                  lat: 40.75822772728387,
                  lng: -73.8482998519924,
                },
                {
                  lat: 40.758279535608,
                  lng: -73.84824553737229,
                },
                {
                  lat: 40.75839737406086,
                  lng: -73.84809131023971,
                },
                {
                  lat: 40.75843496010653,
                  lng: -73.84803565444743,
                },
                {
                  lat: 40.75852029112063,
                  lng: -73.84789081506042,
                },
                {
                  lat: 40.759561504252815,
                  lng: -73.84568343276048,
                },
                {
                  lat: 40.75954626642679,
                  lng: -73.84556407431778,
                },
                {
                  lat: 40.758650808710286,
                  lng: -73.84508932394594,
                },
                {
                  lat: 40.75862338107435,
                  lng: -73.84513492155455,
                },
                {
                  lat: 40.75847152790236,
                  lng: -73.84566733871623,
                },
                {
                  lat: 40.75844979416734,
                  lng: -73.84569012910532,
                },
                {
                  lat: 40.75762390691657,
                  lng: -73.84819397193895,
                },
                {
                  lat: 40.757461366336464,
                  lng: -73.84868481364319,
                },
                {
                  lat: 40.75753755559373,
                  lng: -73.84868213252086,
                },
                {
                  lat: 40.75753755559373,
                  lng: -73.84868213252086,
                },
                {
                  lat: 40.757791694024206,
                  lng: -73.8488402453693,
                },
                {
                  lat: 40.757791694024206,
                  lng: -73.8488402453693,
                },
                {
                  lat: 40.757831669790725,
                  lng: -73.8488473771783,
                },
                {
                  lat: 40.75785273811002,
                  lng: -73.84883810592447,
                },
                {
                  lat: 40.75811509769592,
                  lng: -73.84842676237491,
                },
              ],
              shape: "stroke",
            },
            {
              shape: "stroke",
              paths: [
                {
                  lat: 40.757953718250604,
                  lng: -73.8481919975431,
                },
                {
                  lat: 40.758612089247535,
                  lng: -73.84598367167747,
                },
              ],
            },
            {
              shape: "stroke",
              paths: [
                {
                  lat: 40.75799991324995,
                  lng: -73.84821574184352,
                },
                {
                  lat: 40.75790948241505,
                  lng: -73.8481681851226,
                },
              ],
            },
            {
              shape: "stroke",
              paths: [
                {
                  lat: 40.75800863580032,
                  lng: -73.8481863527074,
                },
                {
                  lat: 40.75791713949157,
                  lng: -73.84814032790807,
                },
              ],
            },
            {
              shape: "stroke",
              paths: [
                {
                  lat: 40.75801437132073,
                  lng: -73.8481607358166,
                },
                {
                  lat: 40.757925390309715,
                  lng: -73.84811285983771,
                },
              ],
            },
            {
              shape: "stroke",
              paths: [
                {
                  lat: 40.7580244118424,
                  lng: -73.8481346624244,
                },
                {
                  lat: 40.75793256492758,
                  lng: -73.84808586535053,
                },
              ],
            },
            {
              shape: "stroke",
              paths: [
                {
                  lat: 40.758034081417065,
                  lng: -73.84810874102077,
                },
                {
                  lat: 40.75794151458426,
                  lng: -73.84805842582851,
                },
              ],
            },
            {
              shape: "stroke",
              paths: [
                {
                  lat: 40.75804164461913,
                  lng: -73.84808068849033,
                },
                {
                  lat: 40.75794979700286,
                  lng: -73.84803178252865,
                },
              ],
            },
            {
              shape: "stroke",
              paths: [
                {
                  lat: 40.75804701271827,
                  lng: -73.84805450125083,
                },
                {
                  lat: 40.757957008547756,
                  lng: -73.8480055650308,
                },
              ],
            },
            {
              shape: "stroke",
              paths: [
                {
                  lat: 40.75805713116388,
                  lng: -73.84802600979256,
                },
                {
                  lat: 40.757964571722354,
                  lng: -73.84797893890382,
                },
              ],
            },
          ],
        },
      ],
    },
    {
      type: "LOTA",
      totalSlots: "900",
      available: "423",
      occupied: "211",
      occupiedPercentage: "50",
      iconsInfo: [
        {
          type: "VIP",

          total: "100",

          available: "100",

          occupied: "40",

          icon: "",
        },

        {
          type: "Person Disabilities",

          total: "25",

          available: "25",

          occupied: "20",

          icon: "",
        },

        {
          type: "Electric Vehicle",

          total: "10",

          available: "75",

          occupied: "30",

          icon: "",
        },

        {
          type: "Car",

          total: "200",

          available: "223",

          occupied: "121",

          icon: "",
        },
      ],

      analytics: {
        day: {
          analytics: [
            {
              node: "2022-10-11T11:00:00",
              count: 17.0,
            },
            {
              node: "2022-10-11T12:00:00",
              count: 47.0,
            },
            {
              node: "2022-10-11T13:00:00",
              count: 57.0,
            },
            {
              node: "2022-10-11T14:00:00",
              count: 47.0,
            },
            {
              node: "2022-10-11T15:00:00",
              count: 87.0,
            },
            {
              node: "2022-10-11T16:00:00",
              count: 67.0,
            },
            {
              node: "2022-10-11T17:00:00",
              count: 27.0,
            },
            {
              node: "2022-10-11T18:00:00",
              count: 57.0,
            },
            {
              node: "2022-10-11T19:00:00",
              count: 87.0,
            },
            {
              node: "2022-10-11T21:00:00",
              count: 47.0,
            },
            {
              node: "2022-10-11T22:00:00",
              count: 77.0,
            },
            {
              node: "2022-10-11T21:00:00",
              count: 47.0,
            },
          ],
        },
        weekly: {
          analytics: [
            {
              node: "2022-10-11T11:00:00",
              count: 99.0,
            },
            {
              node: "2022-11-11T12:00:00",
              count: 57.0,
            },
            {
              node: "2022-12-11T13:00:00",
              count: 77.0,
            },
            {
              node: "2023-01-11T14:00:00",
              count: 47.0,
            },
            {
              node: "2023-02-11T15:00:00",
              count: 37.0,
            },
            {
              node: "2023-03-11T16:00:00",
              count: 27.0,
            },
            {
              node: "2023-04-11T17:00:00",
              count: 67.0,
            },
          ],
        },
        monthly: {
          analytics: [
            {
              node: "2022-01-11T11:00:00",
              count: 77.0,
            },
            {
              node: "2022-02-11T12:00:00",
              count: 27.0,
            },
            {
              node: "2022-03-11T13:00:00",
              count: 57.0,
            },
            {
              node: "2022-04-11T14:00:00",
              count: 47.0,
            },
            {
              node: "2022-05-11T15:00:00",
              count: 87.0,
            },
            {
              node: "2022-06-11T16:00:00",
              count: 17.0,
            },
            {
              node: "2022-07-11T17:00:00",
              count: 27.0,
            },
            {
              node: "2022-08-11T18:00:00",
              count: 97.0,
            },
            {
              node: "2022-09-11T19:00:00",
              count: 87.0,
            },
            {
              node: "2022-10-11T21:00:00",
              count: 47.0,
            },
            {
              node: "2022-11-11T22:00:00",
              count: 77.0,
            },
            {
              node: "2022-01-11T11:00:00",
              count: 77.0,
            },
            {
              node: "2022-02-11T12:00:00",
              count: 27.0,
            },
            {
              node: "2022-03-11T13:00:00",
              count: 57.0,
            },
            {
              node: "2022-04-11T14:00:00",
              count: 47.0,
            },
            {
              node: "2022-05-11T15:00:00",
              count: 87.0,
            },
            {
              node: "2022-06-11T16:00:00",
              count: 17.0,
            },
            {
              node: "2022-07-11T17:00:00",
              count: 27.0,
            },
            {
              node: "2022-08-11T18:00:00",
              count: 97.0,
            },
            {
              node: "2022-09-11T19:00:00",
              count: 87.0,
            },
            {
              node: "2022-10-11T21:00:00",
              count: 47.0,
            },
            {
              node: "2022-11-11T22:00:00",
              count: 77.0,
            },
            {
              node: "2022-01-11T11:00:00",
              count: 77.0,
            },
            {
              node: "2022-02-11T12:00:00",
              count: 27.0,
            },
            {
              node: "2022-03-11T13:00:00",
              count: 57.0,
            },
            {
              node: "2022-04-11T14:00:00",
              count: 47.0,
            },
            {
              node: "2022-05-11T15:00:00",
              count: 87.0,
            },
            {
              node: "2022-06-11T16:00:00",
              count: 17.0,
            },
            {
              node: "2022-07-11T17:00:00",
              count: 27.0,
            },
            {
              node: "2022-08-11T18:00:00",
              count: 97.0,
            },
          ],
        },
        yearly: {
          analytics: [
            {
              node: "2022-05-11T11:00:00",
              count: 117.0,
            },
            {
              node: "2022-06-11T12:00:00",
              count: 147.0,
            },
            {
              node: "2022-07-11T13:00:00",
              count: 157.0,
            },
            {
              node: "2022-08-11T14:00:00",
              count: 147.0,
            },
            {
              node: "2022-09-11T15:00:00",
              count: 187.0,
            },
            {
              node: "2022-10-11T16:00:00",
              count: 267.0,
            },
            {
              node: "2022-11-11T17:00:00",
              count: 227.0,
            },
            {
              node: "2022-12-11T18:00:00",
              count: 257.0,
            },
            {
              node: "2023-01-11T19:00:00",
              count: 287.0,
            },
            {
              node: "2023-02-11T21:00:00",
              count: 247.0,
            },
            {
              node: "2023-03-11T22:00:00",
              count: 277.0,
            },
            {
              node: "2022-10-11T16:00:00",
              count: 267.0,
            },
          ],
        },
      },
      notifications: {
        events: {
          totalCount: "10",
          list: [
            {
              category: "parking",
              id: "evt-01",
              title: "Vehicle Parked",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "A1",
              parkingLot: "Parking Lot - A",
              img: "",
              video: "",
              location: {
                lat: 40.75895511919472,
                lng: -73.84604723504559,
              },
            },
            {
              category: "parking",
              id: "evt-02",
              title: "Vehicle Entered",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "A1",
              parkingLot: "Parking Lot - A",
              img: "",
              video: "",
              location: {
                lat: 40.75898148340152,
                lng: -73.84634228456198,
              },
            },
            {
              category: "parking",
              id: "evt-03",
              title: "Vehicle Entered",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "A1",
              parkingLot: "Parking Lot - A",
              img: "",
              video: "",
              location: {
                lat: 40.7586943218119,
                lng: -73.84695240950991,
              },
            },
            {
              category: "parking",
              id: "evt-04",
              title: "Vehicle Exited",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "A1",
              parkingLot: "Parking Lot - A",
              img: "",
              video: "",
              location: {
                lat: 40.758363899115125,
                lng: -73.84738875354515,
              },
            },
            {
              category: "parking",
              id: "evt-05",
              title: "Occupancy 50%",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "A1",
              parkingLot: "Parking Lot - A",
              img: "",
              video: "",
              location: {
                lat: 40.75858429599638,
                lng: -73.8460023263248,
              },
            },
            {
              category: "parking",
              id: "evt-06",
              title: "Vehicle Entered",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "A1",
              parkingLot: "Parking Lot - A",
              img: "",
              video: "",
              location: {
                lat: 40.757802189331514,
                lng: -73.84817814821952,
              },
            },
            {
              category: "parking",
              id: "evt-07",
              title: "Vehicle Parked",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "A1",
              parkingLot: "Parking Lot - A",
              img: "",
              video: "",
              location: {
                lat: 40.75858263634856,
                lng: -73.84625798470016,
              },
            },
            {
              category: "parking",
              id: "evt-08",
              title: "Vehicle Exited",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "A1",
              parkingLot: "Parking Lot - A",
              img: "",
              video: "",
              location: {
                lat: 40.75852942434301,
                lng: -73.84572408557527,
              },
            },
            {
              category: "parking",
              id: "evt-09",
              title: "Bus Entered",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "A3",
              parkingLot: "Parking Lot - A",
              img: "",
              video: "",
              location: {
                lat: 40.75856135155143,
                lng: -73.84622988474622,
              },
            },
            {
              category: "parking",
              id: "evt-10",
              title: "Bus Exited",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "A5",
              parkingLot: "Parking Lot - A",
              img: "",
              video: "",
              location: {
                lat: 40.75852942434301,
                lng: -73.84571003559829,
              },
            },
          ],
        },
        incidents: {
          totalCount: "10",
          list: [
            {
              category: "parking",
              id: "ict-01",
              title: "Double Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "A1",
              parkingLot: "Parking Lot - A",
              img: "",
              video: "",
              location: {
                lat: 40.7581222590056,
                lng: -73.84767627474734,
              },
            },
            {
              category: "parking",
              id: "ict-02",
              title: "Wrong Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "A2",
              parkingLot: "Parking Lot - A",
              img: "",
              video: "",
              location: {
                lat: 40.758220602839714,
                lng: -73.84743857009768,
              },
            },
            {
              category: "parking",
              id: "ict-03",
              title: "Accident Detected",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "A2",
              parkingLot: "Parking Lot - A",
              img: "",
              video: "",
              location: {
                lat: 40.75841945272989,
                lng: -73.84774728225909,
              },
            },
            {
              category: "parking",
              id: "ict-04",
              title: "Reverse Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "A2",
              parkingLot: "Parking Lot - A",
              img: "",
              video: "",
              location: {
                lat: 40.75892673962276,
                lng: -73.8467216339402,
              },
            },
            {
              category: "parking",
              id: "ict-05",
              title: "Sharp Turns",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "A1",
              parkingLot: "Parking Lot - A",
              img: "",
              video: "",
              location: {
                lat: 40.75831657589487,
                lng: -73.84689023366386,
              },
            },
            {
              category: "parking",
              id: "ict-06",
              title: "Double Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "A2",
              parkingLot: "Parking Lot - A",
              img: "",
              video: "",
              location: {
                lat: 40.75900833085952,
                lng: -73.84533536954574,
              },
            },
            {
              category: "parking",
              id: "ict-07",
              title: "Wrong Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "A2",
              parkingLot: "Parking Lot - A",
              img: "",
              video: "",
              location: {
                lat: 40.75857199395085,
                lng: -73.84607533499954,
              },
            },
            {
              category: "parking",
              id: "ict-08",
              title: "Reverse Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "A4",
              parkingLot: "Parking Lot - A",
              img: "",
              video: "",
              location: {
                lat: 40.758951307274415,
                lng: -73.84675582094441,
              },
            },
            {
              category: "parking",
              id: "ict-09",
              title: "Close Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "A1",
              parkingLot: "Parking Lot - A",
              img: "",
              video: "",
              location: {
                lat: 40.7581321066885,
                lng: -73.84756931588412,
              },
            },
            {
              category: "parking",
              id: "ict-10",
              title: "Wrong Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "A2",
              parkingLot: "Parking Lot - A",
              img: "",
              video: "",
              location: {
                lat: 40.75806115685745,
                lng: -73.84778006553867,
              },
            },
          ],
        },
        operationalAlerts: {
          totalCount: "10",
          list: [
            {
              category: "parking",
              id: "opr-01",
              title: "Unauthorized Access",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "A1",
              parkingLot: "Parking Lot - A",
              img: "",
              video: "",
              location: {
                lat: 40.759001848919244,
                lng: -73.84661068287038,
              },
            },

            {
              category: "parking",
              id: "opr-03",
              title: "Close Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "A1",
              parkingLot: "Parking Lot - A",
              img: "",
              video: "",
              location: {
                lat: 40.75888826519601,
                lng: -73.84678809727846,
              },
            },
            {
              category: "parking",
              id: "opr-04",
              title: "Accident Detected",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "A1",
              parkingLot: "Parking Lot - A",
              img: "",
              video: "",
              location: {
                lat: 40.758468974121364,
                lng: -73.84599210911195,
              },
            },

            {
              category: "parking",
              id: "opr-05",
              title: "Parking Slot Is In Maintenance",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "A3",
              parkingLot: "Parking Lot - A",
              img: "",
              video: "",
              location: {
                lat: 40.75931402009278,
                lng: -73.84597879516956,
              },
            },
            {
              category: "parking",
              id: "opr-06",
              title: "No Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "A4",
              parkingLot: "Parking Lot - A",
              img: "",
              video: "",
              location: {
                lat: 40.75926204958321,
                lng: -73.84594919869866,
              },
            },
            {
              category: "parking",
              id: "opr-07",
              title: "Close Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: " ",
              parkingLot: "Paring Lot - A",
              img: "",
              video: "",
              location: {
                lat: 40.75818456975528,
                lng: -73.84754117503167,
              },
            },
            {
              category: "parking",
              id: "opr-08",
              title: "Parking Slot Is In Maintenance",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "A6 ",
              parkingLot: "Paring Lot - A",
              img: "",
              video: "",
              location: {
                lat: 40.7585010760662,
                lng: -73.84754436767881,
              },
            },
            {
              category: "parking",
              id: "opr-09",
              title: "Close Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: " ",
              parkingLot: "Paring Lot - A",
              img: "",
              video: "",
              location: {
                lat: 40.7585760483526,
                lng: -73.84603281282959,
              },
            },
            {
              category: "parking",
              id: "opr-10",
              title: "No Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "A7",
              parkingLot: "Paring Lot - A",
              img: "",
              video: "",
              location: {
                lat: 40.7585760483526,
                lng: -73.84603281282959,
              },
            },
          ],
        },
      },
    },
    {
      type: "LOTB",
      totalSlots: "900",
      available: "250",
      occupied: "125",
      occupiedPercentage: "50",
      iconsInfo: [
        {
          type: "VIP",

          total: "50",

          available: "50",

          occupied: "20",

          icon: "",
        },

        {
          type: "Person Disabilities",

          total: "25",

          available: "25",

          occupied: "15",

          icon: "",
        },

        {
          type: "Electric Vehicle",

          total: "25",

          available: "25",

          occupied: "15",

          icon: "",
        },

        {
          type: "Car",

          total: "150",

          available: "150",

          occupied: "75",

          icon: "",
        },
      ],
      analytics: {
        day: {
          analytics: [
            {
              node: "2022-10-11T11:00:00",
              count: 17.0,
            },
            {
              node: "2022-10-11T12:00:00",
              count: 47.0,
            },
            {
              node: "2022-10-11T13:00:00",
              count: 57.0,
            },
            {
              node: "2022-10-11T14:00:00",
              count: 47.0,
            },
            {
              node: "2022-10-11T15:00:00",
              count: 87.0,
            },
            {
              node: "2022-10-11T16:00:00",
              count: 67.0,
            },
            {
              node: "2022-10-11T17:00:00",
              count: 27.0,
            },
            {
              node: "2022-10-11T18:00:00",
              count: 57.0,
            },
            {
              node: "2022-10-11T19:00:00",
              count: 87.0,
            },
            {
              node: "2022-10-11T21:00:00",
              count: 47.0,
            },
            {
              node: "2022-10-11T22:00:00",
              count: 77.0,
            },
            {
              node: "2022-10-11T19:00:00",
              count: 87.0,
            },
          ],
        },
        weekly: {
          analytics: [
            {
              node: "2022-02-11T11:00:00",
              count: 109.0,
            },
            {
              node: "2022-03-11T12:00:00",
              count: 157.0,
            },
            {
              node: "2022-04-11T13:00:00",
              count: 177.0,
            },
            {
              node: "2022-05-11T14:00:00",
              count: 147.0,
            },
            {
              node: "2022-06-11T15:00:00",
              count: 137.0,
            },
            {
              node: "2022-07-11T16:00:00",
              count: 227.0,
            },
            {
              node: "2022-08-11T17:00:00",
              count: 267.0,
            },
          ],
        },
        monthly: {
          analytics: [
            {
              node: "2022-02-11T11:00:00",
              count: 107.0,
            },
            {
              node: "2022-03-11T12:00:00",
              count: 127.0,
            },
            {
              node: "2022-04-11T13:00:00",
              count: 157.0,
            },
            {
              node: "2022-05-11T14:00:00",
              count: 147.0,
            },
            {
              node: "2022-06-11T15:00:00",
              count: 287.0,
            },
            {
              node: "2022-07-11T16:00:00",
              count: 217.0,
            },
            {
              node: "2022-08-11T17:00:00",
              count: 127.0,
            },
            {
              node: "2022-09-11T18:00:00",
              count: 297.0,
            },
            {
              node: "2022-10-11T19:00:00",
              count: 187.0,
            },
            {
              node: "2022-11-11T21:00:00",
              count: 247.0,
            },
            {
              node: "2022-12-11T22:00:00",
              count: 177.0,
            },
            {
              node: "2022-02-11T11:00:00",
              count: 107.0,
            },
            {
              node: "2022-03-11T12:00:00",
              count: 127.0,
            },
            {
              node: "2022-04-11T13:00:00",
              count: 157.0,
            },
            {
              node: "2022-05-11T14:00:00",
              count: 147.0,
            },
            {
              node: "2022-06-11T15:00:00",
              count: 287.0,
            },
            {
              node: "2022-07-11T16:00:00",
              count: 217.0,
            },
            {
              node: "2022-08-11T17:00:00",
              count: 127.0,
            },
            {
              node: "2022-09-11T18:00:00",
              count: 297.0,
            },
            {
              node: "2022-10-11T19:00:00",
              count: 187.0,
            },
            {
              node: "2022-11-11T21:00:00",
              count: 247.0,
            },
            {
              node: "2022-12-11T22:00:00",
              count: 177.0,
            },
            {
              node: "2022-02-11T11:00:00",
              count: 107.0,
            },
            {
              node: "2022-03-11T12:00:00",
              count: 127.0,
            },
            {
              node: "2022-04-11T13:00:00",
              count: 157.0,
            },
            {
              node: "2022-05-11T14:00:00",
              count: 147.0,
            },
            {
              node: "2022-06-11T15:00:00",
              count: 287.0,
            },
            {
              node: "2022-07-11T16:00:00",
              count: 217.0,
            },
            {
              node: "2022-08-11T17:00:00",
              count: 127.0,
            },
            {
              node: "2022-09-11T18:00:00",
              count: 297.0,
            },
          ],
        },
        yearly: {
          analytics: [
            {
              node: "2022-05-11T11:00:00",
              count: 117.0,
            },
            {
              node: "2022-06-11T12:00:00",
              count: 147.0,
            },
            {
              node: "2022-07-11T13:00:00",
              count: 157.0,
            },
            {
              node: "2022-08-11T14:00:00",
              count: 147.0,
            },
            {
              node: "2022-09-11T15:00:00",
              count: 187.0,
            },
            {
              node: "2022-10-11T16:00:00",
              count: 267.0,
            },
            {
              node: "2022-11-11T17:00:00",
              count: 227.0,
            },
            {
              node: "2022-12-11T18:00:00",
              count: 257.0,
            },
            {
              node: "2023-01-11T19:00:00",
              count: 287.0,
            },
            {
              node: "2023-02-11T21:00:00",
              count: 247.0,
            },
            {
              node: "2023-03-11T22:00:00",
              count: 277.0,
            },
            {
              node: "2023-02-11T21:00:00",
              count: 247.0,
            },
          ],
        },
      },
      notifications: {
        events: {
          totalCount: "1",
          list: [
            {
              category: "parking",
              id: "evt-01",
              title: "Vehicle Entered",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "B1",
              parkingLot: "Parking Lot - B",
              img: " ",
              video: "",
              location: {
                lat: 40.75719764597131,
                lng: -73.84790822067166,
              },
            },
            {
              category: "parking",
              id: "evt-02",
              title: "Vehicle Parked",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "B1",
              parkingLot: "Parking Lot - B",
              img: "",
              video: "",
              location: {
                lat: 40.7567841097522,
                lng: -73.84771041887387,
              },
            },
            {
              category: "parking",
              id: "evt-03",
              title: "Vehicle Entered",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "B1",
              parkingLot: "Parking Lot - B",
              img: "",
              video: "",
              location: {
                lat: 40.75719764597131,
                lng: -73.8481376707571,
              },
            },
            {
              category: "parking",
              id: "evt-04",
              title: "Vehicle Exited",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "B2",
              parkingLot: "Parking Lot - B",
              img: "",
              video: "",
              location: {
                lat: 40.75676313320879,
                lng: -73.8479477810312,
              },
            },
            {
              category: "parking",
              id: "evt-05",
              title: "Occupancy 50%",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "B2",
              parkingLot: "Parking Lot - B",
              img: "",
              video: "",
              location: {
                lat: 40.75685303263405,
                lng: -73.847967561211,
              },
            },
            {
              category: "parking",
              id: "evt-06",
              title: "Vehicle Entered",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "B3",
              parkingLot: "Parking Lot - B",
              img: "",
              video: "",
              location: {
                lat: 40.756838049404934,
                lng: -73.84811789057731,
              },
            },
            {
              category: "parking",
              id: "evt-07",
              title: "Vehicle Parked",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "B3",
              parkingLot: "Parking Lot - B",
              img: "",
              video: "",
              location: {
                lat: 40.75677511980585,
                lng: -73.8477618473413,
              },
            },
            {
              category: "parking",
              id: "evt-08",
              title: "Vehicle Exited",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "B2",
              parkingLot: "Parking Lot - B",
              img: "",
              video: "",
              location: {
                lat: 40.75725158528847,
                lng: -73.84835129669871,
              },
            },
            {
              category: "parking",
              id: "evt-09",
              title: "Bus Entered",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "B1",
              parkingLot: "Parking Lot - B",
              img: "",
              video: "",
              location: {
                lat: 40.75674515330913,
                lng: -73.8481376707571,
              },
            },
            {
              category: "parking",
              id: "evt-10",
              title: "Bus Exited",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "B2",
              parkingLot: "Parking Lot - B",
              img: "",
              video: "",
              location: {
                lat: 40.75720363923092,
                lng: -73.84837503291445,
              },
            },
          ],
        },
        incidents: {
          totalCount: "10",
          list: [
            {
              category: "parking",
              id: "ict-01",
              title: "Double Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "B1",
              parkingLot: "Parking Lot - B",
              img: "",
              video: "",
              location: {
                lat: 40.75739590477647,
                lng: -73.84798763218444,
              },
            },
            {
              category: "parking",
              id: "ict-02",
              title: "Wrong Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "B2",
              parkingLot: "Parking Lot - B",
              img: "",
              video: "",
              location: {
                lat: 40.75654577264158,
                lng: -73.84775656876351,
              },
            },
            {
              category: "parking",
              id: "ict-03",
              title: "Close Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "B1",
              parkingLot: "Parking Lot - B",
              img: "",
              video: "",
              location: {
                lat: 40.75682306617248,
                lng: -73.84777767148513,
              },
            },
            {
              category: "parking",
              id: "ict-04",
              title: "Accident Detected",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "B2",
              parkingLot: "Parking Lot - B",
              img: "",
              video: "",
              location: {
                lat: 40.75694892522031,
                lng: -73.84783305598852,
              },
            },
            {
              category: "parking",
              id: "ict-05",
              title: "Reverse Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "B2",
              parkingLot: "Parking Lot - B",
              img: "",
              video: "",
              location: {
                lat: 40.75683510454273,
                lng: -73.84801592565512,
              },
            },
            {
              category: "parking",
              id: "ict-06",
              title: "Sharp Turns",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "B2",
              parkingLot: "Parking Lot - B",
              img: "",
              video: "",
              location: {
                lat: 40.756493434203605,
                lng: -73.84776580337726,
              },
            },
            {
              category: "parking",
              id: "ict-07",
              title: "Double Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "B3",
              parkingLot: "Parking Lot - B",
              img: "",
              video: "",
              location: {
                lat: 40.757329497558274,
                lng: -73.84836712084254,
              },
            },
            {
              category: "parking",
              id: "ict-08",
              title: "Wrong Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "B4",
              parkingLot: "Parking Lot - B",
              img: "",
              video: "",
              location: {
                lat: 40.756906544324494,
                lng: -73.84810080609236,
              },
            },
            {
              category: "parking",
              id: "ict-09",
              title: "Reverse Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "B1",
              parkingLot: "Parking Lot - B",
              img: "",
              video: "",
              location: {
                lat: 40.75691596215937,
                lng: -73.84781327580872,
              },
            },
            {
              category: "parking",
              id: "ict-10",
              title: "Close Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "B2",
              parkingLot: "Parking Lot - B",
              img: "",
              video: "",
              location: {
                lat: 40.75672717340465,
                lng: -73.8477183309458,
              },
            },
          ],
        },
        operationalAlerts: {
          totalCount: "10",
          list: [
            {
              category: "parking",
              id: "opr-01",
              title: "Close Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "B1",
              parkingLot: "Parking Lot - B",
              img: "",
              video: "",
              location: {
                lat: 40.75655636406935,
                lng: -73.84788448445593,
              },
            },
            {
              category: "parking",
              id: "opr-02",
              title: "No Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "B1",
              parkingLot: "Parking Lot - B",
              img: "",
              video: "",
              location: {
                lat: 40.7571744428223,
                lng: -73.84822341116838,
              },
            },
            {
              category: "parking",
              id: "opr-03",
              title: "Accident Detected",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "B2",
              parkingLot: "Parking Lot - B",
              img: "",
              video: "",
              location: {
                lat: 40.75691895880196,
                lng: -73.8477618473413,
              },
            },
            {
              category: "parking",
              id: "opr-04",
              title: "Accident Detected",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "B1",
              parkingLot: "Parking Lot - B",
              img: "",
              video: "",
              location: {
                lat: 40.75670020353878,
                lng: -73.84791217670762,
              },
            },
            {
              category: "parking",
              id: "opr-05",
              title: "Close Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "B3",
              parkingLot: "Parking Lot - B",
              img: "",
              video: "",
              location: {
                lat: 40.75672118010206,
                lng: -73.8478607482402,
              },
            },
            {
              category: "parking",
              id: "opr-06",
              title: "Parking Slot Is In Maintenance",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "B3 ",
              parkingLot: "Parking Lot - B",
              img: "",
              video: "",
              location: {
                lat: 40.75692495208671,
                lng: -73.84805063796608,
              },
            },
            {
              category: "parking",
              id: "opr-07",
              title: "Close Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "B3",
              parkingLot: "Parking Lot - B",
              img: "",
              video: "",
              location: {
                lat: 40.756880002437896,
                lng: -73.84775789130535,
              },
            },
            {
              category: "parking",
              id: "opr-08",
              title: "No Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "B5",
              parkingLot: "Parking Lot - B",
              img: "",
              video: "",
              location: {
                lat: 40.75681707287854,
                lng: -73.84799129742674,
              },
            },
            {
              category: "parking",
              id: "opr-09",
              title: "Close Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "B5",
              parkingLot: "Parking Lot - B",
              img: "",
              video: "",
              location: {
                lat: 40.757199446627006,
                lng: -73.84794990753726,
              },
            },
            {
              category: "parking",
              id: "opr-10",
              title: "Parking Slot Is In Maintenance",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "B7",
              parkingLot: "Parking Lot - B",
              img: "",
              video: "",
              location: {
                lat: 40.75685303263405,
                lng: -73.84792404481549,
              },
            },
          ],
        },
      },
    },
    {
      type: "LOTC",
      totalSlots: "900",
      available: "423",
      occupied: "393",
      occupiedPercentage: "80",
      iconsInfo: [
        {
          type: "VIP",

          total: "100",

          available: "100",

          occupied: "80",

          icon: "",
        },

        {
          type: "Person Disabilities",

          total: "25",

          available: "25",

          occupied: "22",

          icon: "",
        },

        {
          type: "Electric Vehicle",

          total: "75",

          available: "75",

          occupied: "50",

          icon: "",
        },

        {
          type: "Car",

          total: "223",

          available: "223",

          occupied: "191",

          icon: "",
        },
      ],
      analytics: {
        day: {
          analytics: [
            {
              node: "2022-10-11T11:00:00",
              count: 17.0,
            },
            {
              node: "2022-10-11T12:00:00",
              count: 47.0,
            },
            {
              node: "2022-10-11T13:00:00",
              count: 57.0,
            },
            {
              node: "2022-10-11T14:00:00",
              count: 47.0,
            },
            {
              node: "2022-10-11T15:00:00",
              count: 87.0,
            },
            {
              node: "2022-10-11T16:00:00",
              count: 67.0,
            },
            {
              node: "2022-10-11T17:00:00",
              count: 27.0,
            },
            {
              node: "2022-10-11T18:00:00",
              count: 57.0,
            },
            {
              node: "2022-10-11T19:00:00",
              count: 87.0,
            },
            {
              node: "2022-10-11T21:00:00",
              count: 47.0,
            },
            {
              node: "2022-10-11T22:00:00",
              count: 77.0,
            },
            {
              node: "2022-10-11T17:00:00",
              count: 27.0,
            },
          ],
        },
        weekly: {
          analytics: [
            {
              node: "2022-03-11T11:00:00",
              count: 109.0,
            },
            {
              node: "2022-04-11T12:00:00",
              count: 157.0,
            },
            {
              node: "2022-05-11T13:00:00",
              count: 177.0,
            },
            {
              node: "2022-06-11T14:00:00",
              count: 147.0,
            },
            {
              node: "2022-07-11T15:00:00",
              count: 137.0,
            },
            {
              node: "2022-08-11T16:00:00",
              count: 227.0,
            },
            {
              node: "2022-09-11T17:00:00",
              count: 267.0,
            },
          ],
        },
        monthly: {
          analytics: [
            {
              node: "2022-03-11T11:00:00",
              count: 107.0,
            },
            {
              node: "2022-04-11T12:00:00",
              count: 127.0,
            },
            {
              node: "2022-05-11T13:00:00",
              count: 157.0,
            },
            {
              node: "2022-06-11T14:00:00",
              count: 147.0,
            },
            {
              node: "2022-07-11T15:00:00",
              count: 287.0,
            },
            {
              node: "2022-08-11T16:00:00",
              count: 217.0,
            },
            {
              node: "2022-09-11T17:00:00",
              count: 127.0,
            },
            {
              node: "2022-10-11T18:00:00",
              count: 297.0,
            },
            {
              node: "2022-11-11T19:00:00",
              count: 187.0,
            },
            {
              node: "2022-12-11T21:00:00",
              count: 247.0,
            },
            {
              node: "2023-01-11T22:00:00",
              count: 177.0,
            },
            {
              node: "2022-03-11T11:00:00",
              count: 107.0,
            },
            {
              node: "2022-04-11T12:00:00",
              count: 127.0,
            },
            {
              node: "2022-05-11T13:00:00",
              count: 157.0,
            },
            {
              node: "2022-06-11T14:00:00",
              count: 147.0,
            },
            {
              node: "2022-07-11T15:00:00",
              count: 287.0,
            },
            {
              node: "2022-08-11T16:00:00",
              count: 217.0,
            },
            {
              node: "2022-09-11T17:00:00",
              count: 127.0,
            },
            {
              node: "2022-10-11T18:00:00",
              count: 297.0,
            },
            {
              node: "2022-11-11T19:00:00",
              count: 187.0,
            },
            {
              node: "2022-12-11T21:00:00",
              count: 247.0,
            },
            {
              node: "2023-01-11T22:00:00",
              count: 177.0,
            },
            {
              node: "2022-10-11T18:00:00",
              count: 297.0,
            },
            {
              node: "2022-11-11T19:00:00",
              count: 187.0,
            },
            {
              node: "2022-12-11T21:00:00",
              count: 247.0,
            },
            {
              node: "2023-01-11T22:00:00",
              count: 177.0,
            },
            {
              node: "2022-10-11T18:00:00",
              count: 297.0,
            },
            {
              node: "2022-11-11T19:00:00",
              count: 187.0,
            },
            {
              node: "2022-12-11T21:00:00",
              count: 247.0,
            },
            {
              node: "2023-01-11T22:00:00",
              count: 177.0,
            },
          ],
        },
        yearly: {
          analytics: [
            {
              node: "2022-05-11T11:00:00",
              count: 117.0,
            },
            {
              node: "2022-06-11T12:00:00",
              count: 147.0,
            },
            {
              node: "2022-07-11T13:00:00",
              count: 157.0,
            },
            {
              node: "2022-08-11T14:00:00",
              count: 147.0,
            },
            {
              node: "2022-09-11T15:00:00",
              count: 187.0,
            },
            {
              node: "2022-10-11T16:00:00",
              count: 267.0,
            },
            {
              node: "2022-11-11T17:00:00",
              count: 227.0,
            },
            {
              node: "2022-12-11T18:00:00",
              count: 257.0,
            },
            {
              node: "2023-01-11T19:00:00",
              count: 287.0,
            },
            {
              node: "2023-02-11T21:00:00",
              count: 247.0,
            },
            {
              node: "2023-03-11T22:00:00",
              count: 277.0,
            },
            {
              node: "2022-12-11T18:00:00",
              count: 257.0,
            },
          ],
        },
      },
      notifications: {
        events: {
          totalCount: "10",
          list: [
            {
              category: "parking",
              id: "evt-01",
              title: "Vehicle Parked",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "C1",
              parkingLot: "Parking Lot - C",
              img: "",
              video: "",
              location: {
                lat: 40.75677511979188,
                lng: -73.84906338327205,
              },
            },
            {
              category: "parking",
              id: "evt-02",
              title: "Vehicle Entered",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "C2",
              parkingLot: "Parking Lot - C",
              img: "",
              video: "",
              location: {
                lat: 40.756292657553125,
                lng: -73.84989810685872,
              },
            },
            {
              category: "parking",
              id: "evt-03",
              title: "Vehicle Entered",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "C1",
              parkingLot: "Parking Lot - C",
              img: "",
              video: "",
              location: {
                lat: 40.75630764090514,
                lng: -73.84935217389682,
              },
            },
            {
              category: "parking",
              id: "evt-04",
              title: "Vehicle Exited",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "C1",
              parkingLot: "Parking Lot - C",
              img: "",
              video: "",
              location: {
                lat: 40.7566912135671,
                lng: -73.84914250399117,
              },
            },
            {
              category: "parking",
              id: "evt-05",
              title: "Occupancy 80%",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "C5",
              parkingLot: "Parking Lot - C",
              img: "",
              video: "",
              location: {
                lat: 40.75643949425731,
                lng: -73.84896843840913,
              },
            },
            {
              category: "parking",
              id: "evt-06",
              title: "Vehicle Entered",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "C3",
              parkingLot: "Parking Lot - C",
              img: "",
              video: "",
              location: {
                lat: 40.75584615211312,
                lng: -73.84977942578004,
              },
            },
            {
              category: "parking",
              id: "evt-07",
              title: "Vehicle Parked",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "C6",
              parkingLot: "Parking Lot - C",
              img: "",
              video: "",
              location: {
                lat: 40.7569994159147,
                lng: -73.84935515033185,
              },
            },
            {
              category: "parking",
              id: "evt-08",
              title: "Vehicle Exited",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "C7",
              parkingLot: "Parking Lot - C",
              img: "",
              video: "",
              location: {
                lat: 40.7571351510989,
                lng: -73.84896847278438,
              },
            },
            {
              category: "parking",
              id: "evt-09",
              title: "Bus Entered",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "C8",
              parkingLot: "Parking Lot - C",
              img: "",
              video: "",
              location: {
                lat: 40.75702084780431,
                lng: -73.84927970105429,
              },
            },
            {
              category: "parking",
              id: "evt-10",
              title: "Bus Exited",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "C5",
              parkingLot: "Parking Lot - C",
              img: "",
              video: "",
              location: {
                lat: 40.7561967640202,
                lng: -73.84870338400007,
              },
            },
          ],
        },
        incidents: {
          totalCount: "10",
          list: [
            {
              category: "parking",
              id: "ict-01",
              title: "Double Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "C1",
              parkingLot: "Parking Lot - C",
              img: "",
              video: "",
              location: {
                lat: 40.75588510908302,
                lng: -73.8503649191015,
              },
            },
            {
              category: "parking",
              id: "ict-02",
              title: "Wrong Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "C3",
              parkingLot: "Parking Lot - C",
              img: "",
              video: "",
              location: {
                lat: 40.75594204615177,
                lng: -73.85015524919584,
              },
            },
            {
              category: "parking",
              id: "ict-03",
              title: "Close Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "C4",
              parkingLot: "Parking Lot - C",
              img: "",
              video: "",
              location: {
                lat: 40.75580120173489,
                lng: -73.84998118361379,
              },
            },
            {
              category: "parking",
              id: "ict-04",
              title: "Accident Detected",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "C6",
              parkingLot: "Parking Lot - C",
              img: "",
              video: "",
              location: {
                lat: 40.75625969416679,
                lng: -73.84938382218446,
              },
            },
            {
              category: "parking",
              id: "ict-05",
              title: "Reverse Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "C5",
              parkingLot: "Parking Lot - C",
              img: "",
              video: "",
              location: {
                lat: 40.75655336739647,
                lng: -73.84918997642264,
              },
            },
            {
              category: "parking",
              id: "ict-06",
              title: "Sharp Turns",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "C5",
              parkingLot: "Parking Lot - C",
              img: "",
              video: "",
              location: {
                lat: 40.75653838409982,
                lng: -73.85000491982952,
              },
            },
            {
              category: "parking",
              id: "ict-07",
              title: "Double Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "C7",
              parkingLot: "Parking Lot - C",
              img: "",
              video: "",
              location: {
                lat: 40.75673017004177,
                lng: -73.8491939324586,
              },
            },
            {
              category: "parking",
              id: "ict-08",
              title: "Wrong Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "C8",
              parkingLot: "Parking Lot - C",
              img: "",
              video: "",
              location: {
                lat: 40.75669421021979,
                lng: -73.8489249220136,
              },
            },
            {
              category: "parking",
              id: "ict-09",
              title: "Reverse Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "C7",
              parkingLot: "Parking Lot - C",
              img: "",
              video: "",
              location: {
                lat: 40.75618477731887,
                lng: -73.84867173571244,
              },
            },
            {
              category: "parking",
              id: "ict-10",
              title: "Close Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "C7",
              parkingLot: "Parking Lot - C",
              img: "",
              video: "",
              location: {
                lat: 40.75635645601343,
                lng: -73.84856293291753,
              },
            },
          ],
        },
        operationalAlerts: {
          totalCount: "10",
          list: [
            {
              category: "parking",
              id: "opr-01",
              title: "Accident Detected",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "C2",
              parkingLot: "Parking Lot - C",
              img: "",
              video: "",
              location: {
                lat: 40.75652885022437,
                lng: -73.84877172657367,
              },
            },
            {
              category: "parking",
              id: "opr-02",
              title: "No Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "C1",
              parkingLot: "Parking Lot - C",
              img: "",
              video: "",
              location: {
                lat: 40.756693411257615,
                lng: -73.84926173530317,
              },
            },
            {
              category: "parking",
              id: "opr-03",
              title: "Close Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "C1",
              parkingLot: "Parking Lot - C",
              img: "",
              video: "",
              location: {
                lat: 40.75667329826428,
                lng: -73.8491072497924,
              },
            },
            {
              category: "parking",
              id: "opr-04",
              title: "Accident Detected",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "C1",
              parkingLot: "Parking Lot - C",
              img: "",
              video: "",
              location: {
                lat: 40.7563478326173,
                lng: -73.84941622081396,
              },
            },
            {
              category: "parking",
              id: "opr-05",
              title: "Parking Slot Is In Maintenance",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "C3",
              parkingLot: "Parking Lot - C",
              img: "",
              video: "",
              location: {
                lat: 40.75626372325843,
                lng: -73.84935828874741,
              },
            },
            {
              category: "parking",
              id: "opr-06",
              title: "No Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "C4",
              parkingLot: "Parking Lot - C",
              img: "",
              video: "",
              location: {
                lat: 40.756600160055434,
                lng: -73.84909035293965,
              },
            },
            {
              category: "parking",
              id: "opr-07",
              title: "Close Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "C6",
              parkingLot: "Paring Lot - C",
              img: "",
              video: "",
              location: {
                lat: 40.75643925571278,
                lng: -73.84938001327237,
              },
            },
            {
              category: "parking",
              id: "opr-08",
              title: "Parking Slot Is In Maintenance",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "C6",
              parkingLot: "Paring Lot - C",
              img: "",
              video: "",
              location: {
                lat: 40.756428284947965,
                lng: -73.8491917340561,
              },
            },
            {
              category: "parking",
              id: "opr-09",
              title: "Close Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "C7",
              parkingLot: "Paring Lot - C",
              img: "",
              video: "",
              location: {
                lat: 40.756380744946156,
                lng: -73.84878862342642,
              },
            },
            {
              category: "parking",
              id: "opr-10",
              title: "No Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "C7",
              parkingLot: "Paring Lot - C",
              img: "",
              video: "",
              location: {
                lat: 40.756603816967804,
                lng: -73.8494379453389,
              },
            },
          ],
        },
      },
    },
    {
      type: "LOTD",
      totalSlots: "900",
      available: "423",
      occupied: "401",
      occupiedPercentage: "87",
      iconsInfo: [
        {
          type: "VIP",

          total: "100",

          available: "100",

          occupied: "80",

          icon: "",
        },

        {
          type: "Person Disabilities",

          total: "25",

          available: "25",

          occupied: "20",

          icon: "",
        },

        {
          type: "Electric Vehicle",

          total: "75",

          available: "75",

          occupied: "50",

          icon: "",
        },

        {
          type: "Car",

          total: "223",

          available: "223",

          occupied: "201",

          icon: "",
        },
      ],
      analytics: {
        day: {
          analytics: [
            {
              node: "2022-10-11T11:00:00",
              count: 17.0,
            },
            {
              node: "2022-10-11T12:00:00",
              count: 47.0,
            },
            {
              node: "2022-10-11T13:00:00",
              count: 57.0,
            },
            {
              node: "2022-10-11T14:00:00",
              count: 47.0,
            },
            {
              node: "2022-10-11T15:00:00",
              count: 87.0,
            },
            {
              node: "2022-10-11T16:00:00",
              count: 67.0,
            },
            {
              node: "2022-10-11T17:00:00",
              count: 27.0,
            },
            {
              node: "2022-10-11T18:00:00",
              count: 57.0,
            },
            {
              node: "2022-10-11T19:00:00",
              count: 87.0,
            },
            {
              node: "2022-10-11T21:00:00",
              count: 47.0,
            },
            {
              node: "2022-10-11T22:00:00",
              count: 77.0,
            },
            {
              node: "2022-10-11T18:00:00",
              count: 57.0,
            },
          ],
        },
        weekly: {
          analytics: [
            {
              node: "2022-01-11T11:00:00",
              count: 109.0,
            },
            {
              node: "2022-02-11T12:00:00",
              count: 157.0,
            },
            {
              node: "2022-03-11T13:00:00",
              count: 177.0,
            },
            {
              node: "2022-04-11T14:00:00",
              count: 147.0,
            },
            {
              node: "2022-05-11T15:00:00",
              count: 137.0,
            },
            {
              node: "2022-06-11T16:00:00",
              count: 227.0,
            },
            {
              node: "2022-07-11T17:00:00",
              count: 267.0,
            },
          ],
        },
        monthly: {
          analytics: [
            {
              node: "2022-01-11T11:00:00",
              count: 107.0,
            },
            {
              node: "2022-02-11T12:00:00",
              count: 127.0,
            },
            {
              node: "2022-03-11T13:00:00",
              count: 157.0,
            },
            {
              node: "2022-04-11T14:00:00",
              count: 147.0,
            },
            {
              node: "2022-05-11T15:00:00",
              count: 287.0,
            },
            {
              node: "2022-06-11T16:00:00",
              count: 217.0,
            },
            {
              node: "2022-07-11T17:00:00",
              count: 127.0,
            },
            {
              node: "2022-08-11T18:00:00",
              count: 297.0,
            },
            {
              node: "2022-09-11T19:00:00",
              count: 187.0,
            },
            {
              node: "2022-10-11T21:00:00",
              count: 247.0,
            },
            {
              node: "2022-11-11T22:00:00",
              count: 177.0,
            },
            {
              node: "2022-01-11T11:00:00",
              count: 107.0,
            },
            {
              node: "2022-02-11T12:00:00",
              count: 127.0,
            },
            {
              node: "2022-03-11T13:00:00",
              count: 157.0,
            },
            {
              node: "2022-04-11T14:00:00",
              count: 147.0,
            },
            {
              node: "2022-05-11T15:00:00",
              count: 287.0,
            },
            {
              node: "2022-06-11T16:00:00",
              count: 217.0,
            },
            {
              node: "2022-07-11T17:00:00",
              count: 127.0,
            },
            {
              node: "2022-08-11T18:00:00",
              count: 297.0,
            },
            {
              node: "2022-09-11T19:00:00",
              count: 187.0,
            },
            {
              node: "2022-10-11T21:00:00",
              count: 247.0,
            },
            {
              node: "2022-11-11T22:00:00",
              count: 177.0,
            },
            {
              node: "2022-08-11T18:00:00",
              count: 297.0,
            },
            {
              node: "2022-09-11T19:00:00",
              count: 187.0,
            },
            {
              node: "2022-10-11T21:00:00",
              count: 247.0,
            },
            {
              node: "2022-11-11T22:00:00",
              count: 177.0,
            },
            {
              node: "2022-08-11T18:00:00",
              count: 297.0,
            },
            {
              node: "2022-09-11T19:00:00",
              count: 187.0,
            },
            {
              node: "2022-10-11T21:00:00",
              count: 247.0,
            },
            {
              node: "2022-11-11T22:00:00",
              count: 177.0,
            },
          ],
        },
        yearly: {
          analytics: [
            {
              node: "2022-05-11T11:00:00",
              count: 117.0,
            },
            {
              node: "2022-06-11T12:00:00",
              count: 147.0,
            },
            {
              node: "2022-07-11T13:00:00",
              count: 157.0,
            },
            {
              node: "2022-08-11T14:00:00",
              count: 147.0,
            },
            {
              node: "2022-09-11T15:00:00",
              count: 187.0,
            },
            {
              node: "2022-10-11T16:00:00",
              count: 267.0,
            },
            {
              node: "2022-11-11T17:00:00",
              count: 227.0,
            },
            {
              node: "2022-12-11T18:00:00",
              count: 257.0,
            },
            {
              node: "2023-01-11T19:00:00",
              count: 287.0,
            },
            {
              node: "2023-02-11T21:00:00",
              count: 247.0,
            },
            {
              node: "2023-03-11T22:00:00",
              count: 277.0,
            },
            {
              node: "2022-12-11T18:00:00",
              count: 257.0,
            },
          ],
        },
      },
      notifications: {
        events: {
          totalCount: "10",
          list: [
            {
              category: "parking",
              id: "evt-01",
              title: "Vehicle Parked",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "D1",
              parkingLot: "Parking Lot - D",
              img: "",
              video: "",
              location: {
                lat: 40.755983967434865,
                lng: -73.84813206000577,
              },
            },
            {
              category: "parking",
              id: "evt-02",
              title: "Vehicle Entered",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "D1",
              parkingLot: "Parking Lot - D",
              img: "",
              video: "",
              location: {
                lat: 40.75540068193351,
                lng: -73.84890690139576,
              },
            },
            {
              category: "parking",
              id: "evt-03",
              title: "Vehicle Entered",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "D1",
              parkingLot: "Parking Lot - D",
              img: "",
              video: "",
              location: {
                lat: 40.75551953362634,
                lng: -73.84883207247648,
              },
            },
            {
              category: "parking",
              id: "evt-04",
              title: "Vehicle Exited",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "D5",
              parkingLot: "Parking Lot - D",
              img: "",
              video: "",
              location: {
                lat: 40.75561095786089,
                lng: -73.84809585246417,
              },
            },
            {
              category: "parking",
              id: "evt-05",
              title: "Occupancy 87%",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "D6",
              parkingLot: "Parking Lot - D",
              img: "",
              video: "",
              location: {
                lat: 40.75537325458959,
                lng: -73.84888517687081,
              },
            },
            {
              category: "parking",
              id: "evt-06",
              title: "Vehicle Entered",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "D7",
              parkingLot: "Parking Lot - D",
              img: "",
              video: "",
              location: {
                lat: 40.755537818483326,
                lng: -73.84807412793921,
              },
            },
            {
              category: "parking",
              id: "evt-07",
              title: "Vehicle Parked",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "D8",
              parkingLot: "Parking Lot - D",
              img: "",
              video: "",
              location: {
                lat: 40.75578832051734,
                lng: -73.84868000080182,
              },
            },
            {
              category: "parking",
              id: "evt-08",
              title: "Vehicle Exited",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "D7",
              parkingLot: "Parking Lot - D",
              img: "",
              video: "",
              location: {
                lat: 40.755653012966555,
                lng: -73.84803067888932,
              },
            },
            {
              category: "parking",
              id: "evt-09",
              title: "Bus Entered",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "D8",
              parkingLot: "Parking Lot - D",
              img: "",
              video: "",
              location: {
                lat: 40.75533485628911,
                lng: -73.84881034795153,
              },
            },
            {
              category: "parking",
              id: "evt-10",
              title: "Bus Exited",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "D9",
              parkingLot: "Parking Lot - D",
              img: "",
              video: "",
              location: {
                lat: 40.7557499224566,
                lng: -73.84892862592072,
              },
            },
          ],
        },
        incidents: {
          totalCount: "10",
          list: [
            {
              category: "parking",
              id: "ict-01",
              title: "Double Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "D7",
              parkingLot: "Parking Lot - D",
              img: "",
              video: "",
              location: {
                lat: 40.75563107117561,
                lng: -73.84878379575436,
              },
            },
            {
              category: "parking",
              id: "ict-02",
              title: "Wrong Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "D6",
              parkingLot: "Parking Lot - D",
              img: "",
              video: "",
              location: {
                lat: 40.755347655725075,
                lng: -73.84882724480427,
              },
            },
            {
              category: "parking",
              id: "ict-03",
              title: "Accident Detected",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: " ",
              parkingLot: "Parking Lot - D",
              img: "",
              video: "",
              location: {
                lat: 40.75561827179421,
                lng: -73.84811274931691,
              },
            },
            {
              category: "parking",
              id: "ict-04",
              title: "Reverse Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "D5",
              parkingLot: "Parking Lot - D",
              img: "",
              video: "",
              location: {
                lat: 40.7558322039882,
                lng: -73.84862931024358,
              },
            },
            {
              category: "parking",
              id: "ict-05",
              title: "Sharp Turns",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "D4",
              parkingLot: "Parking Lot - D",
              img: "",
              video: "",
              location: {
                lat: 40.7557023819697,
                lng: -73.84854482597987,
              },
            },
            {
              category: "parking",
              id: "ict-06",
              title: "Double Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "D6",
              parkingLot: "Parking Lot - D",
              img: "",
              video: "",
              location: {
                lat: 40.755678611713506,
                lng: -73.84884896932923,
              },
            },
            {
              category: "parking",
              id: "ict-07",
              title: "Wrong Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "D5",
              parkingLot: "Parking Lot - D",
              img: "",
              video: "",
              location: {
                lat: 40.755669469305,
                lng: -73.84811033548081,
              },
            },
            {
              category: "parking",
              id: "ict-08",
              title: "Reverse Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "D7",
              parkingLot: "Parking Lot - D",
              img: "",
              video: "",
              location: {
                lat: 40.755760893333346,
                lng: -73.84868965614623,
              },
            },
            {
              category: "parking",
              id: "ict-09",
              title: "Close Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "D5",
              parkingLot: "Parking Lot - D",
              img: "",
              video: "",
              location: {
                lat: 40.7554756499491,
                lng: -73.84851827378272,
              },
            },
            {
              category: "parking",
              id: "ict-10",
              title: "Wrong Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "D4",
              parkingLot: "Parking Lot - D",
              img: "",
              video: "",
              location: {
                lat: 40.755629242692706,
                lng: -73.84805723108647,
              },
            },
          ],
        },
        operationalAlerts: {
          totalCount: "10",
          list: [
            {
              category: "parking",
              id: "opr-01",
              title: "Accident Detected",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "D4",
              parkingLot: "Parking Lot - D",
              img: "",
              video: "",
              location: {
                lat: 40.75566549388711,
                lng: -73.84809304724554,
              },
            },
            {
              category: "parking",
              id: "opr-02",
              title: "No Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "D1",
              parkingLot: "Parking Lot - D",
              img: "",
              video: "",
              location: {
                lat: 40.75552319059814,
                lng: -73.84877414040993,
              },
            },
            {
              category: "parking",
              id: "opr-03",
              title: "Close Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "D1",
              parkingLot: "Parking Lot - D",
              img: "",
              video: "",
              location: {
                lat: 40.75553598999784,
                lng: -73.84879103726269,
              },
            },
            {
              category: "parking",
              id: "opr-04",
              title: "Accident Detected",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "D1",
              parkingLot: "Parking Lot - D",
              img: "",
              video: "",
              location: {
                lat: 40.75569872500774,
                lng: -73.84803309272542,
              },
            },

            {
              category: "parking",
              id: "opr-05",
              title: "Parking Slot Is In Maintenance",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "D3",
              parkingLot: "Parking Lot - D",
              img: "",
              video: "",
              location: {
                lat: 40.755744437017526,
                lng: -73.84829378702486,
              },
            },
            {
              category: "parking",
              id: "opr-06",
              title: "No Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "D3",
              parkingLot: "Parking Lot - D",
              img: "",
              video: "",
              location: {
                lat: 40.75590717151722,
                lng: -73.84822378577778,
              },
            },
            {
              category: "parking",
              id: "opr-07",
              title: "Close Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "D1",
              parkingLot: "Paring Lot - D",
              img: "",
              video: "",
              location: {
                lat: 40.75563589748905,
                lng: -73.84859741989484,
              },
            },
            {
              category: "parking",
              id: "opr-08",
              title: "Parking Slot Is In Maintenance",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "D6 ",
              parkingLot: "Paring Lot - D",
              img: "",
              video: "",
              location: {
                lat: 40.755673126268555,
                lng: -73.84807412793921,
              },
            },
            {
              category: "parking",
              id: "opr-09",
              title: "Close Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "D7",
              parkingLot: "Paring Lot - D",
              img: "",
              video: "",
              location: {
                lat: 40.7556968965267,
                lng: -73.84796791915056,
              },
            },
            {
              category: "parking",
              id: "opr-10",
              title: "No Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "D7",
              parkingLot: "Paring Lot - D",
              img: "",
              video: "",
              location: {
                lat: 40.75577552116622,
                lng: -73.84877896808214,
              },
            },
          ],
        },
      },
    },
    {
      type: "LOTE",
      totalSlots: "900",
      available: "423",
      occupied: "382",
      occupiedPercentage: "80",
      iconsInfo: [
        {
          type: "VIP",

          total: "100",

          available: "100",

          occupied: "80",

          icon: "",
        },

        {
          type: "Person Disabilities",

          total: "25",

          available: "25",

          occupied: "21",

          icon: "",
        },

        {
          type: "Electric Vehicle",

          total: "75",

          available: "75",

          occupied: "60",

          icon: "",
        },

        {
          type: "Car",

          total: "223",

          available: "223",

          occupied: "221",

          icon: "",
        },
      ],
      analytics: {
        day: {
          analytics: [
            {
              node: "2022-10-11T11:00:00",
              count: 17.0,
            },
            {
              node: "2022-10-11T12:00:00",
              count: 47.0,
            },
            {
              node: "2022-10-11T13:00:00",
              count: 57.0,
            },
            {
              node: "2022-10-11T14:00:00",
              count: 47.0,
            },
            {
              node: "2022-10-11T15:00:00",
              count: 87.0,
            },
            {
              node: "2022-10-11T16:00:00",
              count: 67.0,
            },
            {
              node: "2022-10-11T17:00:00",
              count: 27.0,
            },
            {
              node: "2022-10-11T18:00:00",
              count: 57.0,
            },
            {
              node: "2022-10-11T19:00:00",
              count: 87.0,
            },
            {
              node: "2022-10-11T21:00:00",
              count: 47.0,
            },
            {
              node: "2022-10-11T22:00:00",
              count: 77.0,
            },
            {
              node: "2022-10-11T18:00:00",
              count: 57.0,
            },
          ],
        },
        weekly: {
          analytics: [
            {
              node: "2022-01-11T11:00:00",
              count: 109.0,
            },
            {
              node: "2022-02-11T12:00:00",
              count: 157.0,
            },
            {
              node: "2022-03-11T13:00:00",
              count: 177.0,
            },
            {
              node: "2022-04-11T14:00:00",
              count: 147.0,
            },
            {
              node: "2022-05-11T15:00:00",
              count: 137.0,
            },
            {
              node: "2022-06-11T16:00:00",
              count: 227.0,
            },
            {
              node: "2022-07-11T17:00:00",
              count: 267.0,
            },
          ],
        },
        monthly: {
          analytics: [
            {
              node: "2022-10-11T11:00:00",
              count: 107.0,
            },
            {
              node: "2022-11-11T12:00:00",
              count: 127.0,
            },
            {
              node: "2022-12-11T13:00:00",
              count: 157.0,
            },
            {
              node: "2023-01-11T14:00:00",
              count: 147.0,
            },
            {
              node: "2023-02-11T15:00:00",
              count: 287.0,
            },
            {
              node: "2023-03-11T16:00:00",
              count: 217.0,
            },
            {
              node: "2023-04-11T17:00:00",
              count: 127.0,
            },
            {
              node: "2023-05-11T18:00:00",
              count: 297.0,
            },
            {
              node: "2023-06-11T19:00:00",
              count: 187.0,
            },
            {
              node: "2023-07-11T21:00:00",
              count: 247.0,
            },
            {
              node: "2023-08-11T22:00:00",
              count: 177.0,
            },
            {
              node: "2022-10-11T11:00:00",
              count: 107.0,
            },
            {
              node: "2022-11-11T12:00:00",
              count: 127.0,
            },
            {
              node: "2022-12-11T13:00:00",
              count: 157.0,
            },
            {
              node: "2023-01-11T14:00:00",
              count: 147.0,
            },
            {
              node: "2023-02-11T15:00:00",
              count: 287.0,
            },
            {
              node: "2023-03-11T16:00:00",
              count: 217.0,
            },
            {
              node: "2023-04-11T17:00:00",
              count: 127.0,
            },
            {
              node: "2023-05-11T18:00:00",
              count: 297.0,
            },
            {
              node: "2023-06-11T19:00:00",
              count: 187.0,
            },
            {
              node: "2023-07-11T21:00:00",
              count: 247.0,
            },
            {
              node: "2023-08-11T22:00:00",
              count: 177.0,
            },
            {
              node: "2023-05-11T18:00:00",
              count: 297.0,
            },
            {
              node: "2023-06-11T19:00:00",
              count: 187.0,
            },
            {
              node: "2023-07-11T21:00:00",
              count: 247.0,
            },
            {
              node: "2023-08-11T22:00:00",
              count: 177.0,
            },
            {
              node: "2023-05-11T18:00:00",
              count: 297.0,
            },
            {
              node: "2023-06-11T19:00:00",
              count: 187.0,
            },
            {
              node: "2023-07-11T21:00:00",
              count: 247.0,
            },
            {
              node: "2023-08-11T22:00:00",
              count: 177.0,
            },
          ],
        },
        yearly: {
          analytics: [
            {
              node: "2022-05-11T11:00:00",
              count: 117.0,
            },
            {
              node: "2022-06-11T12:00:00",
              count: 147.0,
            },
            {
              node: "2022-07-11T13:00:00",
              count: 157.0,
            },
            {
              node: "2022-08-11T14:00:00",
              count: 147.0,
            },
            {
              node: "2022-09-11T15:00:00",
              count: 187.0,
            },
            {
              node: "2022-10-11T16:00:00",
              count: 267.0,
            },
            {
              node: "2022-11-11T17:00:00",
              count: 227.0,
            },
            {
              node: "2022-12-11T18:00:00",
              count: 257.0,
            },
            {
              node: "2023-01-11T19:00:00",
              count: 287.0,
            },
            {
              node: "2023-02-11T21:00:00",
              count: 247.0,
            },
            {
              node: "2023-03-11T22:00:00",
              count: 277.0,
            },
            {
              node: "2023-01-11T19:00:00",
              count: 287.0,
            },
          ],
        },
      },
      notifications: {
        events: {
          totalCount: "10",
          list: [
            {
              category: "parking",
              id: "evt-01",
              title: "Vehicle Parked",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "E1",
              parkingLot: "Parking Lot - E",
              img: "",
              video: "",
              location: {
                lat: 40.7550294975723,
                lng: -73.84947415292035,
              },
            },
            {
              category: "parking",
              id: "evt-02",
              title: "Vehicle Entered",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "E1",
              parkingLot: "Parking Lot - E",
              img: "",
              video: "",
              location: {
                lat: 40.75480276325691,
                lng: -73.84984346984456,
              },
            },
            {
              category: "parking",
              id: "evt-03",
              title: "Vehicle Entered",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "E1",
              parkingLot: "Parking Lot - E",
              img: "",
              video: "",
              location: {
                lat: 40.754961843059135,
                lng: -73.84986519436951,
              },
            },
            {
              category: "parking",
              id: "evt-04",
              title: "Vehicle Exited",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "E4",
              parkingLot: "Parking Lot - E",
              img: "",
              video: "",
              location: {
                lat: 40.754751565078685,
                lng: -73.84979277928633,
              },
            },
            {
              category: "parking",
              id: "evt-05",
              title: "Occupancy 80%",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "E3",
              parkingLot: "Parking Lot - E",
              img: "",
              video: "",
              location: {
                lat: 40.754855789899935,
                lng: -73.85000036919145,
              },
            },
            {
              category: "parking",
              id: "evt-06",
              title: "Vehicle Entered",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "E2",
              parkingLot: "Parking Lot - E",
              img: "",
              video: "",
              location: {
                lat: 40.75499475607414,
                lng: -73.8496986396782,
              },
            },
            {
              category: "parking",
              id: "evt-07",
              title: "Vehicle Parked",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "E2",
              parkingLot: "Parking Lot - E",
              img: "",
              video: "",
              location: {
                lat: 40.75527817302911,
                lng: -73.8499424371249,
              },
            },
            {
              category: "parking",
              id: "evt-08",
              title: "Vehicle Exited",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "E3",
              parkingLot: "Parking Lot - E",
              img: "",
              video: "",
              location: {
                lat: 40.7549490435489,
                lng: -73.84987967738614,
              },
            },
            {
              category: "parking",
              id: "evt-09",
              title: "Bus Entered",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "E2",
              parkingLot: "Parking Lot - E",
              img: "",
              video: "",
              location: {
                lat: 40.75506241055381,
                lng: -73.8494958774453,
              },
            },
            {
              category: "parking",
              id: "evt-10",
              title: "Bus Exited",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "E4",
              parkingLot: "Parking Lot - E",
              img: "",
              video: "",
              location: {
                lat: 40.754372657109435,
                lng: -73.8491923665358,
              },
            },
          ],
        },
        incidents: {
          totalCount: "10",
          list: [
            {
              category: "parking",
              id: "ict-01",
              title: "Double Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "E3",
              parkingLot: "Parking Lot - E",
              img: "",
              video: "",
              location: {
                lat: 40.75505875355667,
                lng: -73.84982415915572,
              },
            },
            {
              category: "parking",
              id: "ict-02",
              title: "Wrong Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "E2",
              parkingLot: "Parking Lot - E",
              img: "",
              video: "",
              location: {
                lat: 40.75480276325691,
                lng: -73.84954174033132,
              },
            },
            {
              category: "parking",
              id: "ict-03",
              title: "Accident Detected",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "E3",
              parkingLot: "Parking Lot - E",
              img: "",
              video: "",
              location: {
                lat: 40.754974642566914,
                lng: -73.8502707188353,
              },
            },
            {
              category: "parking",
              id: "ict-04",
              title: "Reverse Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "E4",
              parkingLot: "Parking Lot - E",
              img: "",
              video: "",
              location: {
                lat: 40.75491795901379,
                lng: -73.85030451254079,
              },
            },
            {
              category: "parking",
              id: "ict-05",
              title: "Sharp Turns",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "E5",
              parkingLot: "Parking Lot - E",
              img: "",
              video: "",
              location: {
                lat: 40.75502584057336,
                lng: -73.8501065779801,
              },
            },
            {
              category: "parking",
              id: "ict-06",
              title: "Double Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "E6",
              parkingLot: "Parking Lot - E",
              img: "",
              video: "",
              location: {
                lat: 40.75477899267908,
                lng: -73.84967932898935,
              },
            },
            {
              category: "parking",
              id: "ict-07",
              title: "Wrong Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "E4",
              parkingLot: "Parking Lot - E",
              img: "",
              video: "",
              location: {
                lat: 40.75441329041025,
                lng: -73.84918690642374,
              },
            },
            {
              category: "parking",
              id: "ict-08",
              title: "Reverse Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "E6",
              parkingLot: "Parking Lot - E",
              img: "",
              video: "",
              location: {
                lat: 40.754378548590054,
                lng: -73.84936070262337,
              },
            },
            {
              category: "parking",
              id: "ict-09",
              title: "Close Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "E6",
              parkingLot: "Parking Lot - E",
              img: "",
              video: "",
              location: {
                lat: 40.75471865194327,
                lng: -73.84956105102016,
              },
            },
            {
              category: "parking",
              id: "ict-10",
              title: "Wrong Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "E8",
              parkingLot: "Parking Lot - E",
              img: "",
              video: "",
              location: {
                lat: 40.75436392044983,
                lng: -73.84932690891787,
              },
            },
          ],
        },
        operationalAlerts: {
          totalCount: "10",
          list: [
            {
              category: "parking",
              id: "opr-01",
              title: "Accident Detected",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "E4",
              parkingLot: "Parking Lot - E",
              img: "",
              video: "",
              location: {
                lat: 40.754866760924266,
                lng: -73.84999554151923,
              },
            },
            {
              category: "parking",
              id: "opr-02",
              title: "No Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "E1",
              parkingLot: "Parking Lot - E",
              img: "",
              video: "",
              location: {
                lat: 40.754676596246554,
                lng: -73.84947415292035,
              },
            },
            {
              category: "parking",
              id: "opr-03",
              title: "Close Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "E1",
              parkingLot: "Parking Lot - E",
              img: "",
              video: "",
              location: {
                lat: 40.75501486957529,
                lng: -73.85067865713721,
              },
            },
            {
              category: "parking",
              id: "opr-04",
              title: "Accident Detected",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "E1",
              parkingLot: "Parking Lot - E",
              img: "",
              video: "",
              location: {
                lat: 40.755060582055265,
                lng: -73.84958518938122,
              },
            },
            {
              category: "parking",
              id: "opr-05",
              title: "Parking Slot Is In Maintenance",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "E3",
              parkingLot: "Parking Lot - E",
              img: "",
              video: "",
              location: {
                lat: 40.753904960915236,
                lng: -73.8496551906283,
              },
            },
            {
              category: "parking",
              id: "opr-06",
              title: "No Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "E4",
              parkingLot: "Parking Lot - E",
              img: "",
              video: "",
              location: {
                lat: 40.75498012806949,
                lng: -73.84988450505836,
              },
            },
            {
              category: "parking",
              id: "opr-07",
              title: "Close Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "E6",
              parkingLot: "Paring Lot - E",
              img: "",
              video: "",
              location: {
                lat: 40.75425969485746,
                lng: -73.84920138944038,
              },
            },
            {
              category: "parking",
              id: "opr-08",
              title: "Parking Slot Is In Maintenance",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "E6 ",
              parkingLot: "Paring Lot - E",
              img: "",
              video: "",
              location: {
                lat: 40.75415364057824,
                lng: -73.84907345612677,
              },
            },
            {
              category: "parking",
              id: "opr-09",
              title: "Close Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "E7",
              parkingLot: "Paring Lot - E",
              img: "",
              video: "",
              location: {
                lat: 40.75491247350606,
                lng: -73.84988933273057,
              },
            },
            {
              category: "parking",
              id: "opr-10",
              title: "No Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "E7",
              parkingLot: "Paring Lot - E",
              img: "",
              video: "",
              location: {
                lat: 40.75515566391297,
                lng: -73.85037692762396,
              },
            },
          ],
        },
      },
    },
    {
      type: "LOTF",
      totalSlots: "900",
      available: "423",
      occupied: "401",
      occupiedPercentage: "93",
      iconsInfo: [
        {
          type: "VIP",

          total: "100",

          available: "100",

          occupied: "90",

          icon: "",
        },

        {
          type: "Person Disabilities",

          total: "25",

          available: "25",

          occupied: "25",

          icon: "",
        },

        {
          type: "Electric Vehicle",

          total: "75",

          available: "75",

          occupied: "75",

          icon: "",
        },

        {
          type: "Car",

          total: "223",

          available: "223",

          occupied: "221",

          icon: "",
        },
      ],
      analytics: {
        day: {
          analytics: [
            {
              node: "2022-10-11T11:00:00",
              count: 17.0,
            },
            {
              node: "2022-10-11T12:00:00",
              count: 47.0,
            },
            {
              node: "2022-10-11T13:00:00",
              count: 57.0,
            },
            {
              node: "2022-10-11T14:00:00",
              count: 47.0,
            },
            {
              node: "2022-10-11T15:00:00",
              count: 87.0,
            },
            {
              node: "2022-10-11T16:00:00",
              count: 67.0,
            },
            {
              node: "2022-10-11T17:00:00",
              count: 27.0,
            },
            {
              node: "2022-10-11T18:00:00",
              count: 57.0,
            },
            {
              node: "2022-10-11T19:00:00",
              count: 87.0,
            },
            {
              node: "2022-10-11T21:00:00",
              count: 47.0,
            },
            {
              node: "2022-10-11T22:00:00",
              count: 77.0,
            },
            {
              node: "2022-10-11T18:00:00",
              count: 57.0,
            },
          ],
        },
        weekly: {
          analytics: [
            {
              node: "2022-10-11T11:00:00",
              count: 109.0,
            },
            {
              node: "2022-11-11T12:00:00",
              count: 157.0,
            },
            {
              node: "2022-12-11T13:00:00",
              count: 177.0,
            },
            {
              node: "2023-01-11T14:00:00",
              count: 147.0,
            },
            {
              node: "2023-02-11T15:00:00",
              count: 137.0,
            },
            {
              node: "2023-03-11T16:00:00",
              count: 227.0,
            },
            {
              node: "2023-04-11T17:00:00",
              count: 267.0,
            },
          ],
        },
        monthly: {
          analytics: [
            {
              node: "2022-01-11T11:00:00",
              count: 107.0,
            },
            {
              node: "2022-02-11T12:00:00",
              count: 127.0,
            },
            {
              node: "2022-03-11T13:00:00",
              count: 157.0,
            },
            {
              node: "2022-04-11T14:00:00",
              count: 147.0,
            },
            {
              node: "2022-05-11T15:00:00",
              count: 287.0,
            },
            {
              node: "2022-06-11T16:00:00",
              count: 217.0,
            },
            {
              node: "2022-07-11T17:00:00",
              count: 127.0,
            },
            {
              node: "2022-08-11T18:00:00",
              count: 297.0,
            },
            {
              node: "2022-09-11T19:00:00",
              count: 187.0,
            },
            {
              node: "2022-10-11T21:00:00",
              count: 247.0,
            },
            {
              node: "2022-11-11T22:00:00",
              count: 177.0,
            },
            {
              node: "2022-01-11T11:00:00",
              count: 107.0,
            },
            {
              node: "2022-02-11T12:00:00",
              count: 127.0,
            },
            {
              node: "2022-03-11T13:00:00",
              count: 157.0,
            },
            {
              node: "2022-04-11T14:00:00",
              count: 147.0,
            },
            {
              node: "2022-05-11T15:00:00",
              count: 287.0,
            },
            {
              node: "2022-06-11T16:00:00",
              count: 217.0,
            },
            {
              node: "2022-07-11T17:00:00",
              count: 127.0,
            },
            {
              node: "2022-08-11T18:00:00",
              count: 297.0,
            },
            {
              node: "2022-09-11T19:00:00",
              count: 187.0,
            },
            {
              node: "2022-10-11T21:00:00",
              count: 247.0,
            },
            {
              node: "2022-11-11T22:00:00",
              count: 177.0,
            },
            {
              node: "2022-08-11T18:00:00",
              count: 297.0,
            },
            {
              node: "2022-09-11T19:00:00",
              count: 187.0,
            },
            {
              node: "2022-10-11T21:00:00",
              count: 247.0,
            },
            {
              node: "2022-11-11T22:00:00",
              count: 177.0,
            },
            {
              node: "2022-08-11T18:00:00",
              count: 297.0,
            },
            {
              node: "2022-09-11T19:00:00",
              count: 187.0,
            },
            {
              node: "2022-10-11T21:00:00",
              count: 247.0,
            },
            {
              node: "2022-11-11T22:00:00",
              count: 177.0,
            },
          ],
        },
        yearly: {
          analytics: [
            {
              node: "2022-05-11T11:00:00",
              count: 117.0,
            },
            {
              node: "2022-06-11T12:00:00",
              count: 147.0,
            },
            {
              node: "2022-07-11T13:00:00",
              count: 157.0,
            },
            {
              node: "2022-08-11T14:00:00",
              count: 147.0,
            },
            {
              node: "2022-09-11T15:00:00",
              count: 187.0,
            },
            {
              node: "2022-10-11T16:00:00",
              count: 267.0,
            },
            {
              node: "2022-11-11T17:00:00",
              count: 227.0,
            },
            {
              node: "2022-12-11T18:00:00",
              count: 257.0,
            },
            {
              node: "2023-01-11T19:00:00",
              count: 287.0,
            },
            {
              node: "2023-02-11T21:00:00",
              count: 247.0,
            },
            {
              node: "2023-03-11T22:00:00",
              count: 277.0,
            },
            {
              node: "2022-09-11T15:00:00",
              count: 187.0,
            },
          ],
        },
      },
      notifications: {
        events: {
          totalCount: "13",
          list: [
            {
              category: "parking",
              id: "evt-01",
              title: "Vehicle Parked",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "F1",
              parkingLot: "Parking Lot - F",
              img: "",
              video: "",
              location: {
                lat: 40.75519002720547,
                lng: -73.84757476730427,
              },
            },
            {
              category: "parking",
              id: "evt-02",
              title: "Vehicle Entered",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "F1",
              parkingLot: "Parking Lot - F",
              img: "",
              video: "",
              location: {
                lat: 40.75473234891081,
                lng: -73.84863156433566,
              },
            },
            {
              category: "parking",
              id: "evt-03",
              title: "Vehicle Entered",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "F1",
              parkingLot: "Parking Lot - F",
              img: "",
              video: "",
              location: {
                lat: 40.75491994887553,
                lng: -73.8484885231213,
              },
            },
            {
              category: "parking",
              id: "evt-04",
              title: "Vehicle Exited",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "F4",
              parkingLot: "Parking Lot - F",
              img: "",
              video: "",
              location: {
                lat: 40.754816445512176,
                lng: -73.84731003431057,
              },
            },
            {
              category: "parking",
              id: "evt-05",
              title: "Occupancy 93%",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "F5",
              parkingLot: "Parking Lot - F",
              img: "",
              video: "",
              location: {
                lat: 40.75465795567477,
                lng: -73.84801243072131,
              },
            },
            {
              category: "parking",
              id: "evt-06",
              title: "Vehicle Entered",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "F7",
              parkingLot: "Parking Lot - F",
              img: "",
              video: "",
              location: {
                lat: 40.75502058165558,
                lng: -73.84754122413023,
              },
            },
            {
              category: "parking",
              id: "evt-07",
              title: "Vehicle Parked",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "F4",
              parkingLot: "Parking Lot - F",
              img: "",
              video: "",
              location: {
                lat: 40.755213022816264,
                lng: -73.8475129968536,
              },
            },
            {
              category: "parking",
              id: "evt-08",
              title: "Vehicle Exited",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "",
              spot: "",
              parkingLot: "Parking Lot - F",
              img: "",
              video: "",
              location: {
                lat: 40.754887604091806,
                lng: -73.84850773761279,
              },
            },
            {
              category: "parking",
              id: "evt-09",
              title: "Bus Entered",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "",
              spot: "",
              parkingLot: "Parking Lot - F",
              img: "",
              video: "",
              location: {
                lat: 40.75460782105569,
                lng: -73.84760892640026,
              },
            },
            {
              category: "parking",
              id: "evt-10",
              title: "Bus Exited",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "",
              spot: "",
              parkingLot: "Parking Lot - F",
              img: "",
              video: "",
              location: {
                lat: 40.754966848783994,
                lng: -73.84825794922357,
              },
            },
          ],
        },
        incidents: {
          totalCount: "10",
          list: [
            {
              category: "parking",
              id: "ict-01",
              title: "Double Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "F8",
              parkingLot: "Parking Lot - F",
              img: "",
              video: "",
              location: {
                lat: 40.754646388915134,
                lng: -73.84701431496639,
              },
            },
            {
              category: "parking",
              id: "ict-02",
              title: "Wrong Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "F8",
              parkingLot: "Parking Lot - F",
              img: "",
              video: "",
              location: {
                lat: 40.7545822413767,
                lng: -73.8471789740801,
              },
            },
            {
              category: "parking",
              id: "ict-03",
              title: "Accident Detected",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "F8",
              parkingLot: "Parking Lot - F",
              img: "",
              video: "",
              location: {
                lat: 40.75451096626145,
                lng: -73.84696726950531,
              },
            },
            {
              category: "parking",
              id: "ict-04",
              title: "Reverse Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "F8",
              parkingLot: "Parking Lot - F",
              img: "",
              video: "",
              location: {
                lat: 40.75449671122923,
                lng: -73.84706136042743,
              },
            },
            {
              category: "parking",
              id: "ict-05",
              title: "Sharp Turns",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "F7",
              parkingLot: "Parking Lot - F",
              img: "",
              video: "",
              location: {
                lat: 40.754635697663005,
                lng: -73.8466991103773,
              },
            },
            {
              category: "parking",
              id: "ict-06",
              title: "Double Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "F9",
              parkingLot: "Parking Lot - F",
              img: "",
              video: "",
              location: {
                lat: 40.75486021359612,
                lng: -73.84739067865485,
              },
            },
            {
              category: "parking",
              id: "ict-07",
              title: "Wrong Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "F9",
              parkingLot: "Parking Lot - F",
              img: "",
              video: "",
              location: {
                lat: 40.754888723501615,
                lng: -73.84723072408724,
              },
            },
            {
              category: "parking",
              id: "ict-08",
              title: "Reverse Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "F8",
              parkingLot: "Parking Lot - F ",
              img: "",
              video: "",
              location: {
                lat: 40.75445741697166,
                lng: -73.8474616152989,
              },
            },
            {
              category: "parking",
              id: "ict-09",
              title: "Close Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "F6",
              parkingLot: "Parking Lot - F",
              img: "",
              video: "",
              location: {
                lat: 40.75489228723897,
                lng: -73.84740949683926,
              },
            },
            {
              category: "parking",
              id: "ict-10",
              title: "Wrong Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "F8",
              parkingLot: "Parking Lot - F",
              img: "",
              video: "",
              location: {
                lat: 40.754828139937814,
                lng: -73.8475129968536,
              },
            },
          ],
        },
        operationalAlerts: {
          totalCount: "10",
          list: [
            {
              category: "parking",
              id: "opr-01",
              title: "Accident Detected",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "F2",
              parkingLot: "Parking Lot - F",
              img: "",
              video: "",
              location: {
                lat: 40.75465348572979,
                lng: -73.8470764741189,
              },
            },
            {
              category: "parking",
              id: "opr-02",
              title: "No Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "F1",
              parkingLot: "Parking Lot - F",
              img: "",
              video: "",
              location: {
                lat: 40.7547768815338,
                lng: -73.84737698975513,
              },
            },
            {
              category: "parking",
              id: "opr-03",
              title: "Close Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "F1",
              parkingLot: "Parking Lot - F",
              img: "",
              video: "",
              location: {
                lat: 40.75480453918259,
                lng: -73.84859028652953,
              },
            },
            {
              category: "parking",
              id: "opr-04",
              title: "Accident Detected",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "F2",
              parkingLot: "Parking Lot - F",
              img: "",
              video: "",
              location: {
                lat: 40.75487900202598,
                lng: -73.84795555256885,
              },
            },
            {
              category: "parking",
              id: "opr-05",
              title: "Parking Slot Is In Maintenance",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "F3",
              parkingLot: "Parking Lot - F",
              img: "",
              video: "",
              location: {
                lat: 40.754574767597234,
                lng: -73.84775333643978,
              },
            },
            {
              category: "parking",
              id: "opr-06",
              title: "No Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "F4",
              parkingLot: "Parking Lot - F",
              img: "",
              video: "",
              location: {
                lat: 40.75469390851839,
                lng: -73.84807632053482,
              },
            },
            {
              category: "parking",
              id: "opr-07",
              title: "Close Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "F4",
              parkingLot: "Paring Lot - F",
              img: "",
              video: "",
              location: {
                lat: 40.754911963195575,
                lng: -73.84745405518872,
              },
            },
            {
              category: "parking",
              id: "opr-08",
              title: "Parking Slot Is In Maintenance",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "F6",
              parkingLot: "Paring Lot - F",
              img: "",
              video: "",
              location: {
                lat: 40.75468965348915,
                lng: -73.84806227774807,
              },
            },
            {
              category: "parking",
              id: "opr-09",
              title: "Close Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "F7",
              parkingLot: "Paring Lot - F",
              img: "",
              video: "",
              location: {
                lat: 40.75456200248588,
                lng: -73.84809878899361,
              },
            },
            {
              category: "parking",
              id: "opr-10",
              title: "No Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "F7",
              parkingLot: "Paring Lot - F",
              img: "",
              video: "",
              location: {
                lat: 40.75481517673675,
                lng: -73.84815496014056,
              },
            },
          ],
        },
      },
    },
    {
      type: "LOTG",
      totalSlots: "900",
      available: "500",
      occupied: "450",
      occupiedPercentage: "95",
      iconsInfo: [
        {
          type: "VIP",

          total: "100",

          available: "100",

          occupied: "90",

          icon: "",
        },

        {
          type: "Person Disabilities",

          total: "50",

          available: "50",

          occupied: "40",

          icon: "",
        },

        {
          type: "Electric Vehicle",

          total: "50",

          available: "50",

          occupied: "40",

          icon: "",
        },

        {
          type: "Car",

          total: "300",

          available: "300",

          occupied: "280",

          icon: "",
        },
      ],

      analytics: {
        day: {
          analytics: [
            {
              node: "2022-10-11T11:00:00",
              count: 17.0,
            },
            {
              node: "2022-10-11T12:00:00",
              count: 47.0,
            },
            {
              node: "2022-10-11T13:00:00",
              count: 57.0,
            },
            {
              node: "2022-10-11T14:00:00",
              count: 47.0,
            },
            {
              node: "2022-10-11T15:00:00",
              count: 87.0,
            },
            {
              node: "2022-10-11T16:00:00",
              count: 67.0,
            },
            {
              node: "2022-10-11T17:00:00",
              count: 27.0,
            },
            {
              node: "2022-10-11T18:00:00",
              count: 57.0,
            },
            {
              node: "2022-10-11T19:00:00",
              count: 87.0,
            },
            {
              node: "2022-10-11T21:00:00",
              count: 47.0,
            },
            {
              node: "2022-10-11T22:00:00",
              count: 77.0,
            },
            {
              node: "2022-10-11T21:00:00",
              count: 47.0,
            },
          ],
        },
        weekly: {
          analytics: [
            {
              node: "2022-10-11T11:00:00",
              count: 99.0,
            },
            {
              node: "2022-11-11T12:00:00",
              count: 57.0,
            },
            {
              node: "2022-12-11T13:00:00",
              count: 77.0,
            },
            {
              node: "2023-01-11T14:00:00",
              count: 47.0,
            },
            {
              node: "2023-02-11T15:00:00",
              count: 37.0,
            },
            {
              node: "2023-03-11T16:00:00",
              count: 27.0,
            },
            {
              node: "2023-04-11T17:00:00",
              count: 67.0,
            },
          ],
        },
        monthly: {
          analytics: [
            {
              node: "2022-01-11T11:00:00",
              count: 77.0,
            },
            {
              node: "2022-02-11T12:00:00",
              count: 27.0,
            },
            {
              node: "2022-03-11T13:00:00",
              count: 57.0,
            },
            {
              node: "2022-04-11T14:00:00",
              count: 47.0,
            },
            {
              node: "2022-05-11T15:00:00",
              count: 87.0,
            },
            {
              node: "2022-06-11T16:00:00",
              count: 17.0,
            },
            {
              node: "2022-07-11T17:00:00",
              count: 27.0,
            },
            {
              node: "2022-08-11T18:00:00",
              count: 97.0,
            },
            {
              node: "2022-09-11T19:00:00",
              count: 87.0,
            },
            {
              node: "2022-10-11T21:00:00",
              count: 47.0,
            },
            {
              node: "2022-11-11T22:00:00",
              count: 77.0,
            },
            {
              node: "2022-01-11T11:00:00",
              count: 77.0,
            },
            {
              node: "2022-02-11T12:00:00",
              count: 27.0,
            },
            {
              node: "2022-03-11T13:00:00",
              count: 57.0,
            },
            {
              node: "2022-04-11T14:00:00",
              count: 47.0,
            },
            {
              node: "2022-05-11T15:00:00",
              count: 87.0,
            },
            {
              node: "2022-06-11T16:00:00",
              count: 17.0,
            },
            {
              node: "2022-07-11T17:00:00",
              count: 27.0,
            },
            {
              node: "2022-08-11T18:00:00",
              count: 97.0,
            },
            {
              node: "2022-09-11T19:00:00",
              count: 87.0,
            },
            {
              node: "2022-10-11T21:00:00",
              count: 47.0,
            },
            {
              node: "2022-11-11T22:00:00",
              count: 77.0,
            },
            {
              node: "2022-01-11T11:00:00",
              count: 77.0,
            },
            {
              node: "2022-02-11T12:00:00",
              count: 27.0,
            },
            {
              node: "2022-03-11T13:00:00",
              count: 57.0,
            },
            {
              node: "2022-04-11T14:00:00",
              count: 47.0,
            },
            {
              node: "2022-05-11T15:00:00",
              count: 87.0,
            },
            {
              node: "2022-06-11T16:00:00",
              count: 17.0,
            },
            {
              node: "2022-07-11T17:00:00",
              count: 27.0,
            },
            {
              node: "2022-08-11T18:00:00",
              count: 97.0,
            },
          ],
        },
        yearly: {
          analytics: [
            {
              node: "2022-05-11T11:00:00",
              count: 117.0,
            },
            {
              node: "2022-06-11T12:00:00",
              count: 147.0,
            },
            {
              node: "2022-07-11T13:00:00",
              count: 157.0,
            },
            {
              node: "2022-08-11T14:00:00",
              count: 147.0,
            },
            {
              node: "2022-09-11T15:00:00",
              count: 187.0,
            },
            {
              node: "2022-10-11T16:00:00",
              count: 267.0,
            },
            {
              node: "2022-11-11T17:00:00",
              count: 227.0,
            },
            {
              node: "2022-12-11T18:00:00",
              count: 257.0,
            },
            {
              node: "2023-01-11T19:00:00",
              count: 287.0,
            },
            {
              node: "2023-02-11T21:00:00",
              count: 247.0,
            },
            {
              node: "2023-03-11T22:00:00",
              count: 277.0,
            },
            {
              node: "2022-10-11T16:00:00",
              count: 267.0,
            },
          ],
        },
      },

      notifications: {
        events: {
          totalCount: "10",
          list: [
            {
              category: "parking",
              id: "evt-01",
              title: "Vehicle Parked",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "G1",
              parkingLot: "Parking Lot - G",
              img: "",
              video: "",
              location: {
                lat: 40.75553983246337,
                lng: -73.8449552327351,
              },
            },
            {
              category: "parking",
              id: "evt-02",
              title: "Vehicle Entered",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "G1",
              parkingLot: "Parking Lot - G",
              img: "",
              video: "",
              location: {
                lat: 40.75566990466413,
                lng: -73.84438959248777,
              },
            },
            {
              category: "parking",
              id: "evt-03",
              title: "Vehicle Entered",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "G1",
              parkingLot: "Parking Lot - G",
              img: "",
              video: "",
              location: {
                lat: 40.75571198679226,
                lng: -73.84417242703569,
              },
            },
            {
              category: "parking",
              id: "evt-04",
              title: "Vehicle Exited",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "G3",
              parkingLot: "Parking Lot - G",
              img: "",
              video: "",
              location: {
                lat: 40.75554748377635,
                lng: -73.84477341979847,
              },
            },
            {
              category: "parking",
              id: "evt-05",
              title: "Occupancy 97%",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "G3",
              parkingLot: "Parking Lot - G",
              img: "",
              video: "",
              location: {
                lat: 40.75580762789345,
                lng: -73.84447544859674,
              },
            },
            {
              category: "parking",
              id: "evt-06",
              title: "Vehicle Entered",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "G3",
              parkingLot: "Parking Lot - G",
              img: "",
              video: "",
              location: {
                lat: 40.75563929946332,
                lng: -73.8440360673332,
              },
            },
            {
              category: "parking",
              id: "evt-07",
              title: "Vehicle Parked",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "G4",
              parkingLot: "Parking Lot - G",
              img: "",
              video: "",
              location: {
                lat: 40.75558988514798,
                lng: -73.8441880587607,
              },
            },
            {
              category: "parking",
              id: "evt-08",
              title: "Vehicle Exited",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "G4",
              parkingLot: "Parking Lot - G",
              img: "",
              video: "",
              location: {
                lat: 40.755549793512685,
                lng: -73.84433154741691,
              },
            },
            {
              category: "parking",
              id: "evt-09",
              title: "Bus Entered",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "G4",
              parkingLot: "Parking Lot - G",
              img: "",
              video: "",
              location: {
                lat: 40.75564868616931,
                lng: -73.84395518372845,
              },
            },
            {
              category: "parking",
              id: "evt-10",
              title: "Bus Exited",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "G7",
              parkingLot: "Parking Lot - G",
              img: "",
              video: "",
              location: {
                lat: 40.75556493924441,
                lng: -73.84492549636276,
              },
            },
          ],
        },
        incidents: {
          totalCount: "10",
          list: [
            {
              category: "parking",
              id: "ict-01",
              title: "Double Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "G2",
              parkingLot: "Parking Lot - G",
              img: "",
              video: "",
              location: {
                lat: 40.755924872088904,
                lng: -73.84435977469354,
              },
            },
            {
              category: "parking",
              id: "ict-02",
              title: "Wrong Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "G2",
              parkingLot: "Parking Lot - G",
              img: "",
              video: "",
              location: {
                lat: 40.755920417486415,
                lng: -73.84433037128039,
              },
            },
            {
              category: "parking",
              id: "ict-03",
              title: "Accident Detected",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "G2",
              parkingLot: "Parking Lot - G",
              img: "",
              video: "",
              location: {
                lat: 40.75594447233639,
                lng: -73.84427156445406,
              },
            },
            {
              category: "parking",
              id: "ict-04",
              title: "Reverse Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "G4",
              parkingLot: "Parking Lot - G",
              img: "",
              video: "",
              location: {
                lat: 40.755677195736695,
                lng: -73.84381287120875,
              },
            },
            {
              category: "parking",
              id: "ict-05",
              title: "Sharp Turns",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "G4",
              parkingLot: "Parking Lot - G",
              img: "",
              video: "",
              location: {
                lat: 40.755677195736695,
                lng: -73.84381287120875,
              },
            },
            {
              category: "parking",
              id: "ict-06",
              title: "Double Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "G4",
              parkingLot: "Parking Lot - G",
              img: "",
              video: "",
              location: {
                lat: 40.755677195736695,
                lng: -73.84381287120875,
              },
            },
            {
              category: "parking",
              id: "ict-07",
              title: "Wrong Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "G3",
              parkingLot: "Parking Lot - G",
              img: "",
              video: "",
              location: {
                lat: 40.755924872088904,
                lng: -73.84432213832471,
              },
            },
            {
              category: "parking",
              id: "ict-08",
              title: "Reverse Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "G3",
              parkingLot: "Parking Lot - G",
              img: "",
              video: "",
              location: {
                lat: 40.755924872088904,
                lng: -73.84432213832471,
              },
            },
            {
              category: "parking",
              id: "ict-09",
              title: "Close Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "G2",
              parkingLot: "Parking Lot - G",
              img: "",
              video: "",
              location: {
                lat: 40.75589101710239,
                lng: -73.84446092243482,
              },
            },
            {
              category: "parking",
              id: "ict-10",
              title: "Wrong Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "G2",
              parkingLot: "Parking Lot - G",
              img: "",
              video: "",
              location: {
                lat: 40.75589101710239,
                lng: -73.84446092243482,
              },
            },
          ],
        },
        operationalAlerts: {
          totalCount: "10",
          list: [
            {
              category: "parking",
              id: "opr-01",
              title: "Accident Detected",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "G2",
              parkingLot: "Parking Lot - G",
              img: "",
              video: "",
              location: {
                lat: 40.755677195736695,
                lng: -73.84455501335694,
              },
            },
            {
              category: "parking",
              id: "opr-02",
              title: "No Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "G2",
              parkingLot: "Parking Lot - G",
              img: "",
              video: "",
              location: {
                lat: 40.755677195736695,
                lng: -73.84455501335694,
              },
            },
            {
              category: "parking",
              id: "opr-03",
              title: "Close Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "G6",
              parkingLot: "Parking Lot - G",
              img: "",
              video: "",
              location: {
                lat: 40.7555513094325,
                lng: -73.8449148298603,
              },
            },
            {
              category: "parking",
              id: "opr-04",
              title: "Accident Detected",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "G6",
              parkingLot: "Parking Lot - G",
              img: "",
              video: "",
              location: {
                lat: 40.7555195020389,
                lng: -73.84488785999392,
              },
            },

            {
              category: "parking",
              id: "opr-05",
              title: "Parking Slot Is In Maintenance",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "G4",
              parkingLot: "Parking Lot - G",
              img: "",
              video: "",
              location: {
                lat: 40.75545713719642,
                lng: -73.84513602480101,
              },
            },
            {
              category: "parking",
              id: "opr-06",
              title: "No Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "G4",
              parkingLot: "Parking Lot - G",
              img: "",
              video: "",
              location: {
                lat: 40.75545713719642,
                lng: -73.84513602480101,
              },
            },
            {
              category: "parking",
              id: "opr-07",
              title: "Close Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "G8",
              parkingLot: "Paring Lot - G",
              img: "",
              video: "",
              location: {
                lat: 40.755505401544085,
                lng: -73.84517239818719,
              },
            },
            {
              category: "parking",
              id: "opr-08",
              title: "Parking Slot Is In Maintenance",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "G8",
              parkingLot: "Paring Lot - G",
              img: "",
              video: "",
              location: {
                lat: 40.75541741133608,
                lng: -73.84496028309445,
              },
            },
            {
              category: "parking",
              id: "opr-09",
              title: "Close Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "G8",
              parkingLot: "Paring Lot - G",
              img: "",
              video: "",
              location: {
                lat: 40.75523377922243,
                lng: -73.8453693622019,
              },
            },
            {
              category: "parking",
              id: "opr-10",
              title: "No Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "G8",
              parkingLot: "Paring Lot - G",
              img: "",
              video: "",
              location: {
                lat: 40.75562399685762,
                lng: -73.8439855637397,
              },
            },
          ],
        },
      },
    },
    {
      type: "LOTH",
      totalSlots: "900",
      available: "145",
      occupied: "104",
      occupiedPercentage: "75",
      iconsInfo: [
        {
          type: "VIP",

          total: "70",

          available: "70",

          occupied: "50",

          icon: "",
        },

        {
          type: "Person Disabilities",

          total: "05",

          available: "05",

          occupied: "03",

          icon: "",
        },

        {
          type: "Electric Vehicle",

          total: "20",

          available: "20",

          occupied: "10",

          icon: "",
        },

        {
          type: "Car",

          total: "50",

          available: "50",

          occupied: "41",

          icon: "",
        },
      ],

      analytics: {
        day: {
          analytics: [
            {
              node: "2022-10-11T11:00:00",
              count: 17.0,
            },
            {
              node: "2022-10-11T12:00:00",
              count: 47.0,
            },
            {
              node: "2022-10-11T13:00:00",
              count: 57.0,
            },
            {
              node: "2022-10-11T14:00:00",
              count: 47.0,
            },
            {
              node: "2022-10-11T15:00:00",
              count: 87.0,
            },
            {
              node: "2022-10-11T16:00:00",
              count: 67.0,
            },
            {
              node: "2022-10-11T17:00:00",
              count: 27.0,
            },
            {
              node: "2022-10-11T18:00:00",
              count: 57.0,
            },
            {
              node: "2022-10-11T19:00:00",
              count: 87.0,
            },
            {
              node: "2022-10-11T21:00:00",
              count: 47.0,
            },
            {
              node: "2022-10-11T22:00:00",
              count: 77.0,
            },
            {
              node: "2022-10-11T21:00:00",
              count: 47.0,
            },
          ],
        },
        weekly: {
          analytics: [
            {
              node: "2022-10-11T11:00:00",
              count: 99.0,
            },
            {
              node: "2022-11-11T12:00:00",
              count: 57.0,
            },
            {
              node: "2022-12-11T13:00:00",
              count: 77.0,
            },
            {
              node: "2023-01-11T14:00:00",
              count: 47.0,
            },
            {
              node: "2023-02-11T15:00:00",
              count: 37.0,
            },
            {
              node: "2023-03-11T16:00:00",
              count: 27.0,
            },
            {
              node: "2023-04-11T17:00:00",
              count: 67.0,
            },
          ],
        },
        monthly: {
          analytics: [
            {
              node: "2022-01-11T11:00:00",
              count: 77.0,
            },
            {
              node: "2022-02-11T12:00:00",
              count: 27.0,
            },
            {
              node: "2022-03-11T13:00:00",
              count: 57.0,
            },
            {
              node: "2022-04-11T14:00:00",
              count: 47.0,
            },
            {
              node: "2022-05-11T15:00:00",
              count: 87.0,
            },
            {
              node: "2022-06-11T16:00:00",
              count: 17.0,
            },
            {
              node: "2022-07-11T17:00:00",
              count: 27.0,
            },
            {
              node: "2022-08-11T18:00:00",
              count: 97.0,
            },
            {
              node: "2022-09-11T19:00:00",
              count: 87.0,
            },
            {
              node: "2022-10-11T21:00:00",
              count: 47.0,
            },
            {
              node: "2022-11-11T22:00:00",
              count: 77.0,
            },
            {
              node: "2022-01-11T11:00:00",
              count: 77.0,
            },
            {
              node: "2022-02-11T12:00:00",
              count: 27.0,
            },
            {
              node: "2022-03-11T13:00:00",
              count: 57.0,
            },
            {
              node: "2022-04-11T14:00:00",
              count: 47.0,
            },
            {
              node: "2022-05-11T15:00:00",
              count: 87.0,
            },
            {
              node: "2022-06-11T16:00:00",
              count: 17.0,
            },
            {
              node: "2022-07-11T17:00:00",
              count: 27.0,
            },
            {
              node: "2022-08-11T18:00:00",
              count: 97.0,
            },
            {
              node: "2022-09-11T19:00:00",
              count: 87.0,
            },
            {
              node: "2022-10-11T21:00:00",
              count: 47.0,
            },
            {
              node: "2022-11-11T22:00:00",
              count: 77.0,
            },
            {
              node: "2022-01-11T11:00:00",
              count: 77.0,
            },
            {
              node: "2022-02-11T12:00:00",
              count: 27.0,
            },
            {
              node: "2022-03-11T13:00:00",
              count: 57.0,
            },
            {
              node: "2022-04-11T14:00:00",
              count: 47.0,
            },
            {
              node: "2022-05-11T15:00:00",
              count: 87.0,
            },
            {
              node: "2022-06-11T16:00:00",
              count: 17.0,
            },
            {
              node: "2022-07-11T17:00:00",
              count: 27.0,
            },
            {
              node: "2022-08-11T18:00:00",
              count: 97.0,
            },
          ],
        },
        yearly: {
          analytics: [
            {
              node: "2022-05-11T11:00:00",
              count: 117.0,
            },
            {
              node: "2022-06-11T12:00:00",
              count: 147.0,
            },
            {
              node: "2022-07-11T13:00:00",
              count: 157.0,
            },
            {
              node: "2022-08-11T14:00:00",
              count: 147.0,
            },
            {
              node: "2022-09-11T15:00:00",
              count: 187.0,
            },
            {
              node: "2022-10-11T16:00:00",
              count: 267.0,
            },
            {
              node: "2022-11-11T17:00:00",
              count: 227.0,
            },
            {
              node: "2022-12-11T18:00:00",
              count: 257.0,
            },
            {
              node: "2023-01-11T19:00:00",
              count: 287.0,
            },
            {
              node: "2023-02-11T21:00:00",
              count: 247.0,
            },
            {
              node: "2023-03-11T22:00:00",
              count: 277.0,
            },
            {
              node: "2022-10-11T16:00:00",
              count: 267.0,
            },
          ],
        },
      },
      notifications: {
        events: {
          totalCount: "10",
          list: [
            {
              category: "parking",
              id: "evt-01",
              title: "Vehicle Parked",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "H1",
              parkingLot: "Parking Lot - H",
              img: "",
              video: "",
              location: {
                lat: 40.75636780531853,
                lng: -73.84443159837639,
              },
            },
            {
              category: "parking",
              id: "evt-02",
              title: "Vehicle Entered",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "H7",
              parkingLot: "Parking Lot - H",
              img: "",
              video: "",
              location: {
                lat: 40.75614683681981,
                lng: -73.84506520790768,
              },
            },
            {
              category: "parking",
              id: "evt-03",
              title: "Vehicle Entered",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "H2",
              parkingLot: "Parking Lot - H",
              img: "",
              video: "",
              location: {
                lat: 40.75627818013687,
                lng: -73.84478352055712,
              },
            },
            {
              category: "parking",
              id: "evt-04",
              title: "Vehicle Exited",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "H2",
              parkingLot: "Parking Lot - H",
              img: "",
              video: "",
              location: {
                lat: 40.756217520163414,
                lng: -73.84493526809634,
              },
            },
            {
              category: "parking",
              id: "evt-05",
              title: "Occupancy 50%",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "H3",
              parkingLot: "Parking Lot - H",
              img: "",
              video: "",
              location: {
                lat: 40.75621130000154,
                lng: -73.84492526809634,
              },
            },
            {
              category: "parking",
              id: "evt-06",
              title: "Vehicle Entered",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "H2",
              parkingLot: "Parking Lot - H",
              img: "",
              video: "",
              location: {
                lat: 40.756167520163414,
                lng: -73.84491526809634,
              },
            },
            {
              category: "parking",
              id: "evt-07",
              title: "Vehicle Parked",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "H5",
              parkingLot: "Parking Lot - H",
              img: "",
              video: "",
              location: {
                lat: 40.75647368635506,
                lng: -73.84455071600778,
              },
            },
            {
              category: "parking",
              id: "evt-08",
              title: "Vehicle Exited",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "H4",
              parkingLot: "Parking Lot - H",
              img: "",
              video: "",
              location: {
                lat: 40.7564557353062,
                lng: -73.84435404262423,
              },
            },
            {
              category: "parking",
              id: "evt-09",
              title: "Bus Entered",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "H3",
              parkingLot: "Parking Lot - H",
              img: "",
              video: "",
              location: {
                lat: 40.75635179657468,
                lng: -73.84458073298472,
              },
            },
            {
              category: "parking",
              id: "evt-10",
              title: "Bus Exited",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "H3",
              parkingLot: "Parking Lot - H",
              img: "",
              video: "",
              location: {
                lat: 40.75638155101395,
                lng: -73.8444731791501,
              },
            },
          ],
        },
        incidents: {
          totalCount: "10",
          list: [
            {
              category: "parking",
              id: "ict-01",
              title: "Double Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "H2",
              parkingLot: "Parking Lot - H",
              img: "",
              video: "",
              location: {
                lat: 40.756381471640516,
                lng: -73.84435929037163,
              },
            },
            {
              category: "parking",
              id: "ict-02",
              title: "Wrong Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "H2",
              parkingLot: "Parking Lot - H",
              img: "",
              video: "",
              location: {
                lat: 40.75647328617571,
                lng: -73.84434413929357,
              },
            },
            {
              category: "parking",
              id: "ict-03",
              title: "Accident Detected",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "H5",
              parkingLot: "Parking Lot - H",
              img: "",
              video: "",
              location: {
                lat: 40.75620043131726,
                lng: -73.84451205690578,
              },
            },
            {
              category: "parking",
              id: "ict-04",
              title: "Reverse Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "H7",
              parkingLot: "Parking Lot - H",
              img: "",
              video: "",
              location: {
                lat: 40.75607191664082,
                lng: -73.84506510689123,
              },
            },
            {
              category: "parking",
              id: "ict-05",
              title: "Sharp Turns",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "H5",
              parkingLot: "Parking Lot - H",
              img: "",
              video: "",
              location: {
                lat: 40.75620043131726,
                lng: -73.84451205690578,
              },
            },
            {
              category: "parking",
              id: "ict-06",
              title: "Double Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "H6",
              parkingLot: "Parking Lot - H",
              img: "",
              video: "",
              location: {
                lat: 40.75607191664082,
                lng: -73.84506510689123,
              },
            },
            {
              category: "parking",
              id: "ict-07",
              title: "Wrong Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "H7",
              parkingLot: "Parking Lot - H",
              img: "",
              video: "",
              location: {
                lat: 40.75640769220826,
                lng: -73.84426172901765,
              },
            },
            {
              category: "parking",
              id: "ict-08",
              title: "Reverse Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "H6",
              parkingLot: "Parking Lot - H",
              img: "",
              video: "",
              location: {
                lat: 40.75620043131726,
                lng: -73.84451205690578,
              },
            },
            {
              category: "parking",
              id: "ict-09",
              title: "Close Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "H4",
              parkingLot: "Parking Lot - H",
              img: "",
              video: "",
              location: {
                lat: 40.75640769220826,
                lng: -73.84426172901765,
              },
            },
            {
              category: "parking",
              id: "ict-10",
              title: "Wrong Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "H5",
              parkingLot: "Parking Lot - H",
              img: "",
              video: "",
              location: {
                lat: 40.75620043131726,
                lng: -73.84451205690578,
              },
            },
          ],
        },
        operationalAlerts: {
          totalCount: "10",
          list: [
            {
              category: "parking",
              id: "opr-01",
              title: "Accident Detected",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "H2",
              parkingLot: "Parking Lot - H",
              img: "",
              video: "",
              location: {
                lat: 40.756261538698794,
                lng: -73.84465593306741,
              },
            },
            {
              category: "parking",
              id: "opr-02",
              title: "No Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "H3",
              parkingLot: "Parking Lot - H",
              img: "",
              video: "",
              location: {
                lat: 40.756556995246044,
                lng: -73.84436319081948,
              },
            },
            {
              category: "parking",
              id: "opr-03",
              title: "Close Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "H4",
              parkingLot: "Parking Lot - H",
              img: "",
              video: "",
              location: {
                lat: 40.756261538698794,
                lng: -73.84465593306741,
              },
            },

            {
              category: "parking",
              id: "opr-04",
              title: "Close Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "H2",
              parkingLot: "Parking Lot - H",
              img: "",
              video: "",
              location: {
                lat: 40.756261538698794,
                lng: -73.84465593306741,
              },
            },
            {
              category: "parking",
              id: "opr-05",
              title: "Parking Slot Is In Maintenance",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "H7",
              parkingLot: "Parking Lot - H",
              img: "",
              video: "",
              location: {
                lat: 40.756556995246044,
                lng: -73.84436319081948,
              },
            },
            {
              category: "parking",
              id: "opr-06",
              title: "No Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "H8",
              parkingLot: "Parking Lot - H",
              img: "",
              video: "",
              location: {
                lat: 40.756353080348134,
                lng: -73.84426921274941,
              },
            },
            {
              category: "parking",
              id: "opr-07",
              title: "Close Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "H8",
              parkingLot: "Paring Lot - H",
              img: "",
              video: "",
              location: {
                lat: 40.7562753080348134,
                lng: -73.84427921274941,
              },
            },
            {
              category: "parking",
              id: "opr-08",
              title: "Parking Slot Is In Maintenance",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "H9",
              parkingLot: "Paring Lot - H",
              img: "",
              video: "",
              location: {
                lat: 40.756353080348134,
                lng: -73.84426921274941,
              },
            },
            {
              category: "parking",
              id: "opr-09",
              title: "Close Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "H9",
              parkingLot: "Paring Lot - H",
              img: "",
              video: "",
              location: {
                lat: 40.756353080348134,
                lng: -73.84426921274941,
              },
            },
            {
              category: "parking",
              id: "opr-10",
              title: "No Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "H3",
              parkingLot: "Paring Lot - H",
              img: "",
              video: "",
              location: {
                lat: 40.756556995246044,
                lng: -73.84436319081948,
              },
            },
          ],
        },
      },
    },
    {
      type: "BUSLOT",
      totalSlots: "900",
      totalSlots: "900",
      available: "423",
      occupied: "281",
      occupiedPercentage: "67",

      iconsInfo: [
        {
          type: "VIP",

          total: "100",

          available: "100",

          occupied: "50",

          icon: "",
        },

        {
          type: "Person Disabilities",

          total: "25",

          available: "25",

          occupied: "20",

          icon: "",
        },

        {
          type: "Electric Vehicle",

          total: "75",

          available: "75",

          occupied: "50",

          icon: "",
        },

        {
          type: "Car",

          total: "223",

          available: "223",

          occupied: "161",

          icon: "",
        },
      ],
      analytics: {
        day: {
          analytics: [
            {
              node: "2022-10-11T11:00:00",
              count: 17.0,
            },
            {
              node: "2022-10-11T12:00:00",
              count: 47.0,
            },
            {
              node: "2022-10-11T13:00:00",
              count: 57.0,
            },
            {
              node: "2022-10-11T14:00:00",
              count: 47.0,
            },
            {
              node: "2022-10-11T15:00:00",
              count: 87.0,
            },
            {
              node: "2022-10-11T16:00:00",
              count: 67.0,
            },
            {
              node: "2022-10-11T17:00:00",
              count: 27.0,
            },
            {
              node: "2022-10-11T18:00:00",
              count: 57.0,
            },
            {
              node: "2022-10-11T19:00:00",
              count: 87.0,
            },
            {
              node: "2022-10-11T21:00:00",
              count: 47.0,
            },
            {
              node: "2022-10-11T22:00:00",
              count: 77.0,
            },
            {
              node: "2022-10-11T15:00:00",
              count: 87.0,
            },
          ],
        },
        weekly: {
          analytics: [
            {
              node: "2022-01-11T11:00:00",
              count: 109.0,
            },
            {
              node: "2022-02-11T12:00:00",
              count: 157.0,
            },
            {
              node: "2022-03-11T13:00:00",
              count: 177.0,
            },
            {
              node: "2022-04-11T14:00:00",
              count: 147.0,
            },
            {
              node: "2022-05-11T15:00:00",
              count: 137.0,
            },
            {
              node: "2022-06-11T16:00:00",
              count: 227.0,
            },
            {
              node: "2022-07-11T17:00:00",
              count: 267.0,
            },
          ],
        },
        monthly: {
          analytics: [
            {
              node: "2022-10-11T11:00:00",
              count: 107.0,
            },
            {
              node: "2022-11-11T12:00:00",
              count: 127.0,
            },
            {
              node: "2022-12-11T13:00:00",
              count: 157.0,
            },
            {
              node: "2023-01-11T14:00:00",
              count: 147.0,
            },
            {
              node: "2023-02-11T15:00:00",
              count: 287.0,
            },
            {
              node: "2023-03-11T16:00:00",
              count: 217.0,
            },
            {
              node: "2023-04-11T17:00:00",
              count: 127.0,
            },
            {
              node: "2023-05-11T18:00:00",
              count: 297.0,
            },
            {
              node: "2023-06-11T19:00:00",
              count: 187.0,
            },
            {
              node: "2023-07-11T21:00:00",
              count: 247.0,
            },
            {
              node: "2023-08-11T22:00:00",
              count: 177.0,
            },
            {
              node: "2022-10-11T11:00:00",
              count: 107.0,
            },
            {
              node: "2022-11-11T12:00:00",
              count: 127.0,
            },
            {
              node: "2022-12-11T13:00:00",
              count: 157.0,
            },
            {
              node: "2023-01-11T14:00:00",
              count: 147.0,
            },
            {
              node: "2023-02-11T15:00:00",
              count: 287.0,
            },
            {
              node: "2023-03-11T16:00:00",
              count: 217.0,
            },
            {
              node: "2023-04-11T17:00:00",
              count: 127.0,
            },
            {
              node: "2023-05-11T18:00:00",
              count: 297.0,
            },
            {
              node: "2023-06-11T19:00:00",
              count: 187.0,
            },
            {
              node: "2023-07-11T21:00:00",
              count: 247.0,
            },
            {
              node: "2023-08-11T22:00:00",
              count: 177.0,
            },
            {
              node: "2023-05-11T18:00:00",
              count: 297.0,
            },
            {
              node: "2023-06-11T19:00:00",
              count: 187.0,
            },
            {
              node: "2023-07-11T21:00:00",
              count: 247.0,
            },
            {
              node: "2023-08-11T22:00:00",
              count: 177.0,
            },
            {
              node: "2023-05-11T18:00:00",
              count: 297.0,
            },
            {
              node: "2023-06-11T19:00:00",
              count: 187.0,
            },
            {
              node: "2023-07-11T21:00:00",
              count: 247.0,
            },
            {
              node: "2023-08-11T22:00:00",
              count: 177.0,
            },
          ],
        },
        yearly: {
          analytics: [
            {
              node: "2022-05-11T11:00:00",
              count: 117.0,
            },
            {
              node: "2022-06-11T12:00:00",
              count: 147.0,
            },
            {
              node: "2022-07-11T13:00:00",
              count: 157.0,
            },
            {
              node: "2022-08-11T14:00:00",
              count: 147.0,
            },
            {
              node: "2022-09-11T15:00:00",
              count: 187.0,
            },
            {
              node: "2022-10-11T16:00:00",
              count: 267.0,
            },
            {
              node: "2022-11-11T17:00:00",
              count: 227.0,
            },
            {
              node: "2022-12-11T18:00:00",
              count: 257.0,
            },
            {
              node: "2023-01-11T19:00:00",
              count: 287.0,
            },
            {
              node: "2023-02-11T21:00:00",
              count: 247.0,
            },
            {
              node: "2023-03-11T22:00:00",
              count: 277.0,
            },
            {
              node: "2023-02-11T21:00:00",
              count: 247.0,
            },
          ],
        },
      },
      notifications: {
        events: {
          totalCount: "10",
          list: [
            {
              category: "parking",
              id: "evt-01",
              title: "Vehicle Parked",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "B1",
              parkingLot: "BUSLOT",
              img: "",
              video: "",
              location: {
                lat: 40.756944074176545,
                lng: -73.85052768571522,
              },
            },
            {
              category: "parking",
              id: "evt-02",
              title: "Vehicle Entered",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "B1",
              parkingLot: "BUSLOT",
              img: "",
              video: "",
              location: {
                lat: 40.757033124597804,
                lng: -73.85041566893906,
              },
            },
            {
              category: "parking",
              id: "evt-03",
              title: "Vehicle Entered",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "B1",
              parkingLot: "BUSLOT",
              img: "",
              video: "",
              location: {
                lat: 40.757199599518835,
                lng: -73.85029544972902,
              },
            },
            {
              category: "parking",
              id: "evt-04",
              title: "Vehicle Exited",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "B1",
              parkingLot: "BUSLOT",
              img: "",
              video: "",
              location: {
                lat: 40.757461118563015,
                lng: -73.85018947721206,
              },
            },
            {
              category: "parking",
              id: "evt-05",
              title: "Occupancy 50%",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "B2",
              parkingLot: "BUSLOT",
              img: "",
              video: "",
              location: {
                lat: 40.75709771641627,
                lng: -73.85076638913954,
              },
            },
            {
              category: "parking",
              id: "evt-06",
              title: "Vehicle Entered",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "B3",
              parkingLot: "BUSLOT",
              img: "",
              video: "",
              location: {
                lat: 40.75750322445642,
                lng: -73.84986006003615,
              },
            },
            {
              category: "parking",
              id: "evt-07",
              title: "Vehicle Parked",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "B5",
              parkingLot: "BUSLOT",
              img: "",
              video: "",
              location: {
                lat: 40.75709497720814,
                lng: -73.85044453641156,
              },
            },
            {
              category: "parking",
              id: "evt-08",
              title: "Vehicle Exited",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "B5",
              parkingLot: "BUSLOT",
              img: "",
              video: "",
              location: {
                lat: 40.75702834664511,
                lng: -73.85044679187143,
              },
            },
            {
              category: "parking",
              id: "evt-09",
              title: "Bus Entered",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "B5",
              parkingLot: "BUSLOT",
              img: "",
              video: "",
              location: {
                lat: 40.75709497720814,
                lng: -73.85044453641156,
              },
            },
            {
              category: "parking",
              id: "evt-10",
              title: "Bus Exited",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "B5",
              parkingLot: "BUSLOT",
              img: "",
              video: "",
              location: {
                lat: 40.75702834664511,
                lng: -73.85044679187143,
              },
            },
          ],
        },
        incidents: {
          totalCount: "10",
          list: [
            {
              category: "parking",
              id: "ict-01",
              title: "Double Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "B3",
              parkingLot: "BUSLOT",
              img: "",
              video: "",
              location: {
                lat: 40.757636561614916,
                lng: -73.84972278925633,
              },
            },
            {
              category: "parking",
              id: "ict-02",
              title: "Wrong Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "B3",
              parkingLot: "BUSLOT",
              img: "",
              video: "",
              location: {
                lat: 40.75702834664511,
                lng: -73.85044679187143,
              },
            },
            {
              category: "parking",
              id: "ict-03",
              title: "Accident Detected",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "B3",
              parkingLot: "BUSLOT",
              img: "",
              video: "",
              location: {
                lat: 40.75700613644257,
                lng: -73.85049190106862,
              },
            },
            {
              category: "parking",
              id: "ict-04",
              title: "Reverse Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: " ",
              parkingLot: "BUSLOT",
              img: "",
              video: "",
              location: {
                lat: 40.757636561614916,
                lng: -73.84972278925633,
              },
            },
            {
              category: "parking",
              id: "ict-05",
              title: "Sharp Turns",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "B2",
              parkingLot: "BUSLOT",
              img: "",
              video: "",
              location: {
                lat: 40.75702834664511,
                lng: -73.85044679187143,
              },
            },
            {
              category: "parking",
              id: "ict-06",
              title: "Double Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "B3",
              parkingLot: "BUSLOT",
              img: "",
              video: "",
              location: {
                lat: 40.757636561614916,
                lng: -73.84972278925633,
              },
            },
            {
              category: "parking",
              id: "ict-07",
              title: "Wrong Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "B3",
              parkingLot: "BUSLOT",
              img: "",
              video: "",
              location: {
                lat: 40.757636561614916,
                lng: -73.84972278925633,
              },
            },
            {
              category: "parking",
              id: "ict-08",
              title: "Reverse Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "B2",
              parkingLot: "BUSLOT",
              img: "",
              video: "",
              location: {
                lat: 40.75702834664511,
                lng: -73.85044679187143,
              },
            },
            {
              category: "parking",
              id: "ict-09",
              title: "Close Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "B1",
              parkingLot: "BUSLOT",
              img: "",
              video: "",
              location: {
                lat: 40.757636561614916,
                lng: -73.84972278925633,
              },
            },
            {
              category: "parking",
              id: "ict-10",
              title: "Wrong Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#34567C15A",
              spot: "B3",
              parkingLot: "BUSLOT",
              img: "",
              video: "",
              location: {
                lat: 40.757636561614916,
                lng: -73.84972278925633,
              },
            },
          ],
        },
        operationalAlerts: {
          totalCount: "10",
          list: [
            {
              category: "parking",
              id: "opr-01",
              title: "Accident Detected",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "B1",
              parkingLot: "BUSLOT",
              img: "",
              video: "",
              location: {
                lat: 40.75737345806932,
                lng: -73.8500520863959,
              },
            },
            {
              category: "parking",
              id: "opr-02",
              title: "No Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "B3",
              parkingLot: "BUSLOT",
              img: "",
              video: "",
              location: {
                lat: 40.75713814946479,
                lng: -73.85072724611739,
              },
            },
            {
              category: "parking",
              id: "opr-03",
              title: "Close Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "B2",
              parkingLot: "BUSLOT",
              img: "",
              video: "",
              location: {
                lat: 40.75737345806932,
                lng: -73.8500520863959,
              },
            },
            {
              category: "parking",
              id: "opr-04",
              title: "Accident Detected",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "B3",
              parkingLot: "BUSLOT",
              img: "",
              video: "",
              location: {
                lat: 40.75758684701411,
                lng: -73.84977453269867,
              },
            },

            {
              category: "parking",
              id: "opr-05",
              title: "Parking Slot Is In Maintenance",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "B2",
              parkingLot: "BUSLOT",
              img: "",
              video: "",
              location: {
                lat: 40.75728640461311,
                lng: -73.85047103485874,
              },
            },
            {
              category: "parking",
              id: "opr-06",
              title: "No Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "B2",
              parkingLot: "BUSLOT",
              img: "",
              video: "",
              location: {
                lat: 40.757636561614916,
                lng: -73.84972278925633,
              },
            },
            {
              category: "parking",
              id: "opr-07",
              title: "Close Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "B2",
              parkingLot: "BUSLOT",
              img: "",
              video: "",
              location: {
                lat: 40.75720859267891,
                lng: -73.85055165882524,
              },
            },
            {
              category: "parking",
              id: "opr-08",
              title: "Parking Slot Is In Maintenance",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "B3",
              parkingLot: "BUSLOT",
              img: "",
              video: "",
              location: {
                lat: 40.757636561614916,
                lng: -73.84972278925633,
              },
            },
            {
              category: "parking",
              id: "opr-09",
              title: "Close Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "B2",
              parkingLot: "BUSLOT",
              img: "",
              video: "",
              location: {
                lat: 40.75742968004251,
                lng: -73.84999044116849,
              },
            },
            {
              category: "parking",
              id: "opr-10",
              title: "No Parking",
              timeStamp: "12-15-2022 | 09:00 AM",
              vehicleId: "#54567C15A",
              spot: "B3",
              parkingLot: "BUSLOT",
              img: "",
              video: "",
              location: {
                lat: 40.757636561614916,
                lng: -73.84972278925633,
              },
            },
          ],
        },
      },
    },
  ],
};
export default parkingData;
